import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  JSON: any;
};

export type AiDeepInsights = {
  __typename?: 'AIDeepInsights';
  learningSuggestions?: Maybe<LearningSuggestions>;
};

export type AiGoalsReportInput = {
  careerGoalAlignment?: InputMaybe<CareerGoalAlignmentInput>;
  interestsCompatibility?: InputMaybe<InterestsCompatibilityInput>;
  skillsCompatibilityAndGoalSelection?: InputMaybe<SkillsCompatibilityAndGoalSelectionInput>;
  userGoals: UserGoalsInput;
  workValuesCompatibility?: InputMaybe<WorkValuesCompatibilityInput>;
};

export type AiGoalsReportInsight = {
  __typename?: 'AIGoalsReportInsight';
  aiDeepInsights?: Maybe<AiDeepInsights>;
  keyPoints?: Maybe<KeyPoints>;
  narratives?: Maybe<Narratives>;
  outdated?: Maybe<Scalars['Boolean']>;
  rateLimit?: Maybe<RateLimitResult>;
  relatedTopics?: Maybe<Array<InsightKey>>;
  status?: Maybe<Scalars['String']>;
  surveyData?: Maybe<Scalars['JSON']>;
  /**
   * GR.5. The goals this report was written for (the stored survey_data's
   * userGoals). The page compares them with the learner's current goals and
   * says so when a report was written for an earlier goal.
   */
  writtenFor?: Maybe<InsightWrittenFor>;
};

/** CONNECT.1: one school the member asked for information. */
export type AcademicConnection = {
  __typename?: 'AcademicConnection';
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Null for requests made before the date was recorded. */
  requestedAt?: Maybe<Scalars['Date']>;
};

export type AccessRequestInput = {
  branchcode?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  fullName?: InputMaybe<Scalars['String']>;
  installationId?: InputMaybe<Scalars['String']>;
  /** Free text when the installation is not in the list. */
  installationOther?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  roleRequested?: InputMaybe<Scalars['String']>;
};

export type AccessRequestReport = {
  __typename?: 'AccessRequestReport';
  activated: Scalars['Int'];
  activatedDelta?: Maybe<PeriodDelta>;
  byInstallation: Array<AnalyticsLocationRow>;
  /** Distinct email addresses, alongside the raw request count. */
  distinctRequesters: Scalars['Int'];
  invited: Scalars['Int'];
  invitedDelta?: Maybe<PeriodDelta>;
  medianDaysToInvite?: Maybe<Scalars['Float']>;
  received: Scalars['Int'];
  receivedDelta?: Maybe<PeriodDelta>;
  recent: Array<AccessRequestRow>;
  series: Array<AnalyticsTimePoint>;
};

export type AccessRequestRow = {
  __typename?: 'AccessRequestRow';
  branch?: Maybe<Scalars['String']>;
  /** First character and domain only. The reporting surface never needs the address. */
  emailMasked: Scalars['String'];
  id: Scalars['ID'];
  installation?: Maybe<Scalars['String']>;
  requestedAt: Scalars['String'];
  /** awaiting | invited | active, derived by matching email against api.user. */
  status: Scalars['String'];
};

/**
 * PWS 4.1.8. One item on the plan's action board.
 *
 * Status, category and horizon are three fields on one item rather than three
 * arrangements of the data, so regrouping the board is a read concern and cannot
 * lose item state.
 */
export type ActionItem = {
  __typename?: 'ActionItem';
  /** assessment, records, credential, education or jobsearch. */
  category: Scalars['String'];
  dueOn?: Maybe<Scalars['Date']>;
  /**
   * now, three, six or later. A bucket and not a date: a hard date reads as a
   * commitment where a range reads as a plan. Independent of dueOn.
   */
  horizon: Scalars['String'];
  id: Scalars['ID'];
  notes?: Maybe<Scalars['String']>;
  /** member or via. */
  origin: Scalars['String'];
  sortOrder: Scalars['Int'];
  /** todo, doing or done. */
  status: Scalars['String'];
  /**
   * pending, accepted or discarded.
   *
   * A Via suggestion is not part of the plan until the member accepts it, and a
   * discarded one is kept so the same suggestion is not offered again.
   */
  suggestionState: Scalars['String'];
  title: Scalars['String'];
};

export type ActionItemInput = {
  category?: InputMaybe<Scalars['String']>;
  dueOn?: InputMaybe<Scalars['Date']>;
  horizon?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  streetAddress1?: Maybe<Scalars['String']>;
  streetAddress2?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type AirbaseLocation = {
  __typename?: 'AirbaseLocation';
  active?: Maybe<Scalars['Boolean']>;
  assignedbase?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  majcom?: Maybe<Scalars['String']>;
  nationalguard?: Maybe<Scalars['Boolean']>;
  reserve?: Maybe<Scalars['Boolean']>;
};

/** One row of a Career & Education table: a goal crossed with the six services. */
export type AnalyticsBranchRow = {
  __typename?: 'AnalyticsBranchRow';
  airForce: Scalars['Int'];
  army: Scalars['Int'];
  coastGuard: Scalars['Int'];
  key?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  marineCorps: Scalars['Int'];
  militarySpouse: Scalars['Int'];
  navy: Scalars['Int'];
  noBranch: Scalars['Int'];
  spaceForce: Scalars['Int'];
  total: Scalars['Int'];
};

export type AnalyticsCareerEducation = {
  __typename?: 'AnalyticsCareerEducation';
  rows: Array<AnalyticsBranchRow>;
  totalRows: Scalars['Int'];
};

/** Option lists for the per-tab secondary dropdowns on Career & Education. */
export type AnalyticsCareerEducationOptions = {
  __typename?: 'AnalyticsCareerEducationOptions';
  label: Scalars['String'];
  states: Array<Scalars['String']>;
  values: Array<Scalars['String']>;
};

export type AnalyticsDetail = {
  __typename?: 'AnalyticsDetail';
  description?: Maybe<Scalars['String']>;
  fyDeltaPct?: Maybe<Scalars['Float']>;
  fyGoals: Scalars['Int'];
  /** Top locations carry a low-sample caveat flag */
  locations: Array<AnalyticsOccupationLocation>;
  stats: Array<AnalyticsDetailStat>;
  subtitle?: Maybe<Scalars['String']>;
  tableA?: Maybe<AnalyticsDetailTable>;
  tableB?: Maybe<AnalyticsDetailTable>;
  title: Scalars['String'];
  totalGoals: Scalars['Int'];
};

/**
 * A row in a drill-through table. `values` holds text/number cells; `flags` holds
 * tri-state booleans rendered as tick / cross (used for degree-level matrices).
 */
export type AnalyticsDetailRow = {
  __typename?: 'AnalyticsDetailRow';
  flags: Array<Scalars['Boolean']>;
  label: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type AnalyticsDetailStat = {
  __typename?: 'AnalyticsDetailStat';
  hint?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  value: Scalars['String'];
};

export type AnalyticsDetailTable = {
  __typename?: 'AnalyticsDetailTable';
  columns: Array<Scalars['String']>;
  /** text = value cells, flags = tick/cross cells */
  kind: Scalars['String'];
  label: Scalars['String'];
  rows: Array<AnalyticsDetailRow>;
};

export type AnalyticsFilterInput = {
  /** ANALYTICS.2: learner | counselor | admin | legacy | visitor. Omit for no filter. */
  accountType?: InputMaybe<Array<Scalars['String']>>;
  /** Which field the 'Additional Filter' dropdown is pointed at */
  additionalField?: InputMaybe<Scalars['String']>;
  additionalValues?: InputMaybe<Array<Scalars['String']>>;
  branch?: InputMaybe<Array<Scalars['String']>>;
  category?: InputMaybe<Array<Scalars['String']>>;
  component?: InputMaybe<Array<Scalars['String']>>;
  dateFrom?: InputMaybe<Scalars['String']>;
  dateTo?: InputMaybe<Scalars['String']>;
  grade?: InputMaybe<Array<Scalars['String']>>;
  /** ANALYTICS.2: duty station, from api.userinstallation */
  installation?: InputMaybe<Array<Scalars['String']>>;
  milOccupation?: InputMaybe<Scalars['String']>;
};

export type AnalyticsFilterOptions = {
  __typename?: 'AnalyticsFilterOptions';
  additionalFields: Array<Scalars['String']>;
  additionalValues: Array<Scalars['String']>;
  branches: Array<Scalars['String']>;
  categories: Array<Scalars['String']>;
  components: Array<Scalars['String']>;
  grades: Array<Scalars['String']>;
  /** ANALYTICS.2: duty stations, from api.userinstallation. */
  installations: Array<Scalars['String']>;
};

export type AnalyticsFunnelStep = {
  __typename?: 'AnalyticsFunnelStep';
  label: Scalars['String'];
  pct: Scalars['Float'];
  value: Scalars['Float'];
};

export type AnalyticsIncomeRow = {
  __typename?: 'AnalyticsIncomeRow';
  beforeService?: Maybe<Scalars['Float']>;
  goal?: Maybe<Scalars['Float']>;
  goalVsBefore?: Maybe<Scalars['Float']>;
  paygrade: Scalars['String'];
  users: Scalars['Int'];
};

export type AnalyticsInsightStat = {
  __typename?: 'AnalyticsInsightStat';
  key: Scalars['String'];
  label: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type AnalyticsInsights = {
  __typename?: 'AnalyticsInsights';
  lifetime: Array<AnalyticsInsightStat>;
  sinceRelaunch: Array<AnalyticsInsightStat>;
};

export type AnalyticsInsightsExploration = {
  __typename?: 'AnalyticsInsightsExploration';
  sankey: Array<AnalyticsSankeyLink>;
  topCurrentMocs: Array<AnalyticsMocCount>;
  topFavoritedMocs: Array<AnalyticsMocCount>;
};

export type AnalyticsKpi = {
  __typename?: 'AnalyticsKpi';
  deltaPct?: Maybe<Scalars['Float']>;
  key: Scalars['String'];
  label: Scalars['String'];
  priorValue?: Maybe<Scalars['Float']>;
  value: Scalars['Float'];
};

export type AnalyticsLocationRow = {
  __typename?: 'AnalyticsLocationRow';
  name: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  users: Scalars['Int'];
};

export type AnalyticsMeta = {
  __typename?: 'AnalyticsMeta';
  /** Share of visitors who told us their branch, for coverage notes */
  branchCoveragePct: Scalars['Float'];
  /** Current DoD fiscal year label, e.g. FY26. Computed, never hardcoded. */
  fyLabel: Scalars['String'];
  /**
   * When the OLDEST rollup table behind these pages was last rebuilt successfully.
   *
   * Deliberately the oldest, not the newest: the rollup rebuilds five tables in
   * sequence, so a partial failure would otherwise hide behind whichever table
   * happened to succeed most recently.
   */
  lastRefreshedAt?: Maybe<Scalars['String']>;
  /**
   * Rollup tables whose most recent refresh attempt FAILED, so the pages they feed
   * are serving the previous run's data. Empty when everything is current.
   */
  staleTables: Array<Scalars['String']>;
  totalVisitors: Scalars['Int'];
};

export type AnalyticsMocCount = {
  __typename?: 'AnalyticsMocCount';
  moccode: Scalars['String'];
  moctitle?: Maybe<Scalars['String']>;
  users: Scalars['Int'];
};

export type AnalyticsMocOption = {
  __typename?: 'AnalyticsMocOption';
  moccode: Scalars['String'];
  moctitle: Scalars['String'];
};

export type AnalyticsNamedValue = {
  __typename?: 'AnalyticsNamedValue';
  /**
   * Exact words to print in place of `value`, when a number would be wrong.
   *
   * The server decides the wording because the reason differs by column: a count
   * we withheld reads "fewer than 10", while a change we could not compute reads
   * "not comparable" -- and a client that guessed from `suppressed` alone printed
   * the small-cell wording in the Change column, where it read as though the
   * movement itself were under ten.
   */
  display?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  pct?: Maybe<Scalars['Float']>;
  /**
   * True when this cell was not measurable rather than measured as 0. Set only by
   * period comparison today. Display it as a caveat, never as a number.
   */
  suppressed?: Maybe<Scalars['Boolean']>;
  /**
   * ALWAYS read `suppressed` before using this.
   *
   * When `suppressed` is true this is 0 as a placeholder and NOT a measurement:
   * the group fell below the small-cell floor in that period, so the real figure
   * is somewhere between 1 and 9 and we are not allowed to say which. Treating it
   * as a zero is what printed "Air Force down 85, or -100%" when the true figure
   * was 1. `value` stays non-null because it is shared by every analytics panel
   * and widening it would make the field nullable for all of them.
   */
  value: Scalars['Float'];
};

export type AnalyticsNlqChip = {
  __typename?: 'AnalyticsNlqChip';
  kind: Scalars['String'];
  label: Scalars['String'];
  value: Scalars['String'];
};

export type AnalyticsNlqResult = {
  __typename?: 'AnalyticsNlqResult';
  /** Plain-English answer, composed from the query result (never model-written) */
  answer: Scalars['String'];
  chartType: Scalars['String'];
  chips: Array<AnalyticsNlqChip>;
  columns: Array<Scalars['String']>;
  /** Restatement of what we understood, shown back to the user */
  interpretation: Scalars['String'];
  metricLabel: Scalars['String'];
  /** Coverage / suppression caveats to display under the answer */
  notes: Array<Scalars['String']>;
  /**
   * The resolved query object, as JSON. Send it back as `previousPlan` on the next
   * question so follow-ups like "how many of those were in 2026" keep their
   * context. Null on a refusal, so the client keeps the last good one.
   */
  plan?: Maybe<Scalars['String']>;
  /** Set when the question could not be mapped to a known metric */
  refusal?: Maybe<Scalars['String']>;
  rows: Array<AnalyticsPivotRow>;
  sql?: Maybe<Scalars['String']>;
};

export type AnalyticsOccupationLocation = {
  __typename?: 'AnalyticsOccupationLocation';
  city: Scalars['String'];
  demand?: Maybe<Scalars['Int']>;
  lowSample: Scalars['Boolean'];
  salary?: Maybe<Scalars['Float']>;
  state?: Maybe<Scalars['String']>;
};

export type AnalyticsPivot = {
  __typename?: 'AnalyticsPivot';
  columns: Array<Scalars['String']>;
  rows: Array<AnalyticsPivotRow>;
};

export type AnalyticsPivotRow = {
  __typename?: 'AnalyticsPivotRow';
  cells: Array<AnalyticsNamedValue>;
  label: Scalars['String'];
  total: Scalars['Int'];
};

export type AnalyticsSankeyLink = {
  __typename?: 'AnalyticsSankeyLink';
  source: Scalars['String'];
  target: Scalars['String'];
  value: Scalars['Int'];
};

export type AnalyticsTimePoint = {
  __typename?: 'AnalyticsTimePoint';
  period: Scalars['String'];
  series: Scalars['String'];
  value: Scalars['Float'];
};

export type AnalyticsTrafficOverview = {
  __typename?: 'AnalyticsTrafficOverview';
  kpis: Array<AnalyticsKpi>;
  monthly: Array<AnalyticsTimePoint>;
  monthlyByBranch: Array<AnalyticsTimePoint>;
  peakLabel?: Maybe<Scalars['String']>;
};

export type AnalyticsUserData = {
  __typename?: 'AnalyticsUserData';
  conversionPct: Scalars['Float'];
  currentLocations: Array<AnalyticsLocationRow>;
  education: Array<AnalyticsNamedValue>;
  funnel: Array<AnalyticsFunnelStep>;
  income: Array<AnalyticsIncomeRow>;
  interests: Array<AnalyticsNamedValue>;
  preferredLocations: Array<AnalyticsLocationRow>;
};

export type AspirationInput = {
  childcarePreference?: InputMaybe<Scalars['Int']>;
  familyTypePreference?: InputMaybe<Scalars['Int']>;
  foodPreference?: InputMaybe<Scalars['Int']>;
  housingPreference?: InputMaybe<Scalars['Int']>;
  numberOfChildren?: InputMaybe<Scalars['Int']>;
  spouseIncome?: InputMaybe<Scalars['Int']>;
  spouseIsEmployed?: InputMaybe<Scalars['Boolean']>;
  transportationPreference?: InputMaybe<Scalars['Int']>;
  vacationPreference?: InputMaybe<Scalars['Int']>;
};

/**
 * One ASVAB score. `scale` is the code the member's own score sheet prints:
 * a line score (GT, ST, GM, CL and the rest), a MAGE composite (M, A, G, E), a raw
 * subtest (AR, MK, GS and the rest), a printed Career Exploration Score
 * (VS, MS, STS), or the AFQT percentile (1 to 99). api.user_asvab_score holds the
 * full list.
 */
export type AsvabScore = {
  __typename?: 'AsvabScore';
  scale: Scalars['String'];
  score: Scalars['Int'];
};

/**
 * One edit to one scale. A null `score` clears that scale; a scale left out of the
 * payload is not touched, so saving one service's scores never wipes another's.
 */
export type AsvabScoreInput = {
  scale: Scalars['String'];
  score?: InputMaybe<Scalars['Int']>;
};

export type AsvabScores = {
  __typename?: 'AsvabScores';
  cl?: Maybe<Scalars['Int']>;
  el?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  mm?: Maybe<Scalars['Int']>;
};

export type AsvabScoresInput = {
  cl?: InputMaybe<Scalars['Int']>;
  el?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  mm?: InputMaybe<Scalars['Int']>;
};

export type BugReport = {
  __typename?: 'BugReport';
  buglocation?: Maybe<Scalars['String']>;
  createdat?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isviewed?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  updatedat?: Maybe<Scalars['String']>;
};

export type BugReportInput = {
  buglocation?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  message?: InputMaybe<Scalars['String']>;
};

export type BugReportViewedInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  viewed?: InputMaybe<Scalars['Boolean']>;
};

export type CpbCustomOccupation = {
  __typename?: 'CPBCustomOccupation';
  alternateTitle?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  interestsMatch?: Maybe<Scalars['Float']>;
  interestsMatchQualityId?: Maybe<Scalars['Int']>;
  lifestyleMatch?: Maybe<Scalars['Float']>;
  lifestyleMatchQualityId?: Maybe<Scalars['Int']>;
  onetCode: Scalars['ID'];
  onetTitle?: Maybe<Scalars['String']>;
  parentOnetCode?: Maybe<Scalars['ID']>;
  projectedGrowthRate?: Maybe<Scalars['String']>;
  relatedTo?: Maybe<Array<Maybe<Scalars['String']>>>;
  salaryAnalysis?: Maybe<SalaryAnalysis>;
  skillsMatch?: Maybe<Scalars['Float']>;
  skillsMatchQualityId?: Maybe<Scalars['Int']>;
  typicalWorkExperienceGroup?: Maybe<Scalars['String']>;
  valuesMatch?: Maybe<Scalars['Float']>;
  valuesMatchQualityId?: Maybe<Scalars['Int']>;
};

export type CpbOccupation = {
  __typename?: 'CPBOccupation';
  alternateTitle?: Maybe<Scalars['String']>;
  alternateTitles?: Maybe<Array<Maybe<Scalars['String']>>>;
  cipCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  description?: Maybe<Scalars['String']>;
  educationLevelFrequency?: Maybe<Array<Maybe<EducationLevelFrequency>>>;
  imageUrl?: Maybe<Scalars['String']>;
  onetCode?: Maybe<Scalars['String']>;
  onetTitle?: Maybe<Scalars['String']>;
  parentOnetCode?: Maybe<Scalars['String']>;
  projectedGrowthRate?: Maybe<Scalars['Int']>;
  salaryAnalysis?: Maybe<SalaryAnalysis>;
  typicalEducationLevelGroup?: Maybe<Scalars['String']>;
  typicalEducationLevelGroupId?: Maybe<Scalars['Int']>;
  typicalWorkExperienceGroup?: Maybe<Scalars['String']>;
  typicalWorkExperienceGroupId?: Maybe<Scalars['Int']>;
  videoUrl?: Maybe<Scalars['String']>;
};

export type CpdCertificate = {
  __typename?: 'CPDCertificate';
  airforceCool?: Maybe<Scalars['Boolean']>;
  ansi?: Maybe<Scalars['Boolean']>;
  armyCool?: Maybe<Scalars['Boolean']>;
  careerClusters?: Maybe<Scalars['Boolean']>;
  certId?: Maybe<Scalars['String']>;
  certName?: Maybe<Scalars['String']>;
  certType?: Maybe<Scalars['String']>;
  certUrl?: Maybe<Scalars['String']>;
  certifyingOrgName?: Maybe<Scalars['String']>;
  certifyingOrgUrl?: Maybe<Scalars['String']>;
  fundedBy?: Maybe<Scalars['String']>;
  hpn?: Maybe<Scalars['Boolean']>;
  inDemand?: Maybe<Scalars['Boolean']>;
  jobCorps?: Maybe<Scalars['Boolean']>;
  marineCool?: Maybe<Scalars['Boolean']>;
  military?: Maybe<Scalars['Boolean']>;
  nam?: Maybe<Scalars['Boolean']>;
  navyCool?: Maybe<Scalars['Boolean']>;
  ncca?: Maybe<Scalars['Boolean']>;
};

export type CpdInstitution = {
  __typename?: 'CPDInstitution';
  accreditationType?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  ageEntry?: Maybe<Scalars['Float']>;
  alignment?: Maybe<Scalars['Int']>;
  avgCostSH?: Maybe<Scalars['Float']>;
  c3yrRepaymentRateIndependentStudents?: Maybe<Scalars['Float']>;
  c3yrRepaymentRateIndependentStudentsN?: Maybe<Scalars['Float']>;
  costPerSH?: Maybe<Scalars['Float']>;
  creditForLifeExperiences?: Maybe<Scalars['Boolean']>;
  creditForMilitaryTraining?: Maybe<Scalars['Boolean']>;
  dedicatedPOCforServicemembers?: Maybe<Scalars['Boolean']>;
  /**
   * Completion rate, 0-100, refreshed monthly from College Scorecard. Real for 4,902
   * schools. Null where the measure does not apply - notably graduate-only
   * institutions, which have no first-time undergraduate cohort to measure.
   */
  graduationRate?: Maybe<Scalars['Float']>;
  institutionName: Scalars['String'];
  institutionType?: Maybe<Scalars['String']>;
  is2year?: Maybe<Scalars['Boolean']>;
  isOnline?: Maybe<Scalars['Boolean']>;
  isOpenAdmissionPolicy?: Maybe<Scalars['Boolean']>;
  /**
   * True when this school has a DoD Memorandum of Understanding that is in force
   * today, meaning a service member can spend Tuition Assistance here. False means
   * either no MOU or a lapsed one -- see taMouExpirationDate to tell them apart.
   * Sourced from the dodmou.com participating-institutions list, joined on opeid.
   */
  isTaApproved?: Maybe<Scalars['Boolean']>;
  meanEarnings10yearsLaterPercentile?: Maybe<Scalars['Float']>;
  meanEarnings10yearsLaterPercentileN?: Maybe<Scalars['Float']>;
  /**
   * Median debt of completers in US dollars, programme-level where published and
   * institution-level otherwise. Zero at master's level catalog-wide: Scorecard does
   * not publish it there, so a debt column on a master's screen is empty, not sparse.
   */
  medianDebt?: Maybe<Scalars['Int']>;
  opeid: Scalars['String'];
  openAdmissionPolicy?: Maybe<Scalars['Boolean']>;
  partTime8yrAward?: Maybe<Scalars['Float']>;
  partTime8yrAwardN?: Maybe<Scalars['Float']>;
  partTimeRetentionRate?: Maybe<Scalars['Float']>;
  partTimeRetentionRateN?: Maybe<Scalars['Float']>;
  pctOfDistanceLearners?: Maybe<Scalars['Int']>;
  pctOfPartiallyDistanceLearners?: Maybe<Scalars['Int']>;
  pctOfTaFundedCoursesCompletedSuccessfully?: Maybe<Scalars['Int']>;
  pctOfTaFundedCoursesCompletedSuccessfullyN?: Maybe<Scalars['Int']>;
  pocEmail?: Maybe<Scalars['String']>;
  pocExt?: Maybe<Scalars['String']>;
  pocName?: Maybe<Scalars['String']>;
  pocPhone?: Maybe<Scalars['String']>;
  pocTitle?: Maybe<Scalars['String']>;
  /**
   * How many credentials this programme awarded in the cohort behind programEarnings.
   * An earnings figure over three graduates is not the evidence one over three
   * hundred is; show it wherever the earnings number is shown.
   */
  programAwards?: Maybe<Scalars['Int']>;
  /**
   * Median earnings of graduates of THIS programme at THIS school, from College
   * Scorecard field-of-study data. Null when Scorecard does not publish it, which is
   * most of the time below bachelor's level: 45% of bachelor's programme rows carry a
   * figure, 26% of associate, 21% of certificate. Render "not published" for null -
   * never zero, and never the institution-wide figure in its place.
   */
  programEarnings?: Maybe<Scalars['Int']>;
  qualityMetric?: Maybe<Scalars['Int']>;
  schoolId: Scalars['ID'];
  schoolPlacementServices?: Maybe<Scalars['Boolean']>;
  sourceOfAccreditation?: Maybe<Scalars['String']>;
  /**
   * Expiration date of the school's DoD MOU, ISO yyyy-mm-dd. Null when the school
   * has never appeared on the participating-institutions list.
   */
  taMouExpirationDate?: Maybe<Scalars['String']>;
  /**
   * ENRICH.10: this school's own name for the chosen program (schoolProgramId),
   * cleaned for display; several names join with " / ". Null when no program was
   * chosen or the school lists none at that CIP and level.
   */
  programName?: Maybe<Scalars['String']>;
  telephoneNumber?: Maybe<Scalars['String']>;
  unitid?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/**
 * OC-2. A page of institutions and the size of the set it was cut from.
 *
 * totalCount is the whole matched set, not the length of items, so the pager can
 * be drawn without a second round trip.
 */
export type CpdInstitutionPage = {
  __typename?: 'CPDInstitutionPage';
  items?: Maybe<Array<Maybe<CpdInstitution>>>;
  totalCount: Scalars['Int'];
};

export type CpdLicense = {
  __typename?: 'CPDLicense';
  fundedBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  licId?: Maybe<Scalars['String']>;
  licName?: Maybe<Scalars['String']>;
  licOrgName?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type CpdLocation = {
  __typename?: 'CPDLocation';
  cityName: Scalars['String'];
  countyFipsCode?: Maybe<Scalars['Int']>;
  countyName?: Maybe<Scalars['String']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  marketArea?: Maybe<Scalars['Int']>;
  marketAreaCityName?: Maybe<Scalars['String']>;
  marketAreaStateAbbreviation?: Maybe<Scalars['String']>;
  stateAbbreviation: Scalars['String'];
  zipCode: Scalars['String'];
};

export type CpdLocationInput = {
  fipsCode: Scalars['Int'];
  lat?: InputMaybe<Scalars['Float']>;
  lon?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type CpdOccupation = {
  __typename?: 'CPDOccupation';
  alternateTitle?: Maybe<Scalars['String']>;
  alternateTitleId?: Maybe<Scalars['Int']>;
  alternateTitles?: Maybe<Array<Maybe<Scalars['String']>>>;
  annualWageHighest?: Maybe<Scalars['Float']>;
  annualWageLower?: Maybe<Scalars['Float']>;
  /** @deprecated Burning Glass data, user skills field instead */
  bgSkills?: Maybe<Array<Maybe<Skill>>>;
  canStartImmediately?: Maybe<Scalars['Boolean']>;
  careerCluster?: Maybe<Scalars['String']>;
  certificates: Array<Maybe<CpdCertificate>>;
  cipCodes?: Maybe<Array<Maybe<Scalars['String']>>>;
  cons?: Maybe<Array<Maybe<Scalars['Int']>>>;
  cpbonetcode?: Maybe<Scalars['String']>;
  demandLevel?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  educationLevelDistribution?: Maybe<Array<Maybe<EducationLevel>>>;
  educationLevelFrequency?: Maybe<Array<Maybe<EducationLevelFrequency>>>;
  growthRateBand?: Maybe<Scalars['String']>;
  highSalary?: Maybe<Scalars['Float']>;
  hotSpots?: Maybe<Array<Maybe<HotSpotLocation>>>;
  imageName?: Maybe<Scalars['String']>;
  industryCode?: Maybe<Scalars['Int']>;
  interestsCompatibility?: Maybe<Array<Maybe<InterestsCompatibility>>>;
  interestsMatchQualityId?: Maybe<Scalars['Int']>;
  isFavorite?: Maybe<Scalars['Boolean']>;
  isMatch?: Maybe<Scalars['Boolean']>;
  isOverqualified?: Maybe<Scalars['Boolean']>;
  isPartTimeFullTimeSame?: Maybe<Scalars['Boolean']>;
  isPathway?: Maybe<Scalars['Boolean']>;
  jobId?: Maybe<Scalars['Int']>;
  jobOpenings?: Maybe<Scalars['Int']>;
  /**
   * The skill, knowledge, ability and work activity descriptors for this
   * occupation, ordered by O*NET importance descending. This is what the
   * Readiness Assessment should read. The older skills field above resolves
   * software product names out of api.onet_technical_skills, which is the wrong
   * data for that panel: technical skills must never be offered to a learner as
   * capabilities to check off.
   *
   * Roughly 91 to 161 rows per occupation, 141 on average. Populated for 997 of
   * 1,016 occupations. Empty for the other 19, which are all uniformed military
   * occupations (SOC major group 55) that O*NET publishes no scores for, and
   * empty on any environment where the SkillsDNA loader has not run. Empty is a
   * real answer, so render an honest empty state and never fall back to skills.
   */
  ksas?: Maybe<Array<OccupationKsa>>;
  licenses: Array<Maybe<CpdLicense>>;
  lifestyleMatchQualityId?: Maybe<Scalars['Int']>;
  lowSalary?: Maybe<Scalars['Float']>;
  matchSummary?: Maybe<Scalars['String']>;
  medianAnnualWage?: Maybe<Scalars['Float']>;
  medianHourlyWage?: Maybe<Scalars['Float']>;
  militaryOccupationCount?: Maybe<Scalars['Int']>;
  /** @deprecated External pathway is used */
  nextSteps?: Maybe<Array<Maybe<Step>>>;
  onetCode: Scalars['ID'];
  /** @deprecated Use onetCode instead */
  onetSocCode: Scalars['ID'];
  percentOfPeopleWithDegree?: Maybe<Scalars['Int']>;
  preferredEdLevelDescription?: Maybe<Scalars['String']>;
  projectedGrowth?: Maybe<Scalars['Int']>;
  pros?: Maybe<Array<Maybe<Scalars['Int']>>>;
  readinessEvaluation?: Maybe<Array<Maybe<Evaluation>>>;
  schoolProgramEdLevels?: Maybe<Scalars['String']>;
  showInstitutionPrograms?: Maybe<Scalars['Boolean']>;
  similarOccupations?: Maybe<Array<Maybe<CpdOccupation>>>;
  skills?: Maybe<Array<Maybe<Skill>>>;
  skillsCompatibility?: Maybe<Array<Maybe<SkillCompatibility>>>;
  skillsMatchQualityId?: Maybe<Scalars['Int']>;
  skillsMatchQualityIdAi?: Maybe<Scalars['Int']>;
  stateSalaryOverride?: Maybe<Scalars['Int']>;
  tasks: Array<Maybe<Task>>;
  timeToGetReadyFullTime?: Maybe<Scalars['String']>;
  timeToGetReadyPartTime?: Maybe<Scalars['String']>;
  timeToGetReadyRangeFullTime?: Maybe<Scalars['Int']>;
  timeToGetReadyRangePartTime?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  totalMatch?: Maybe<Scalars['Int']>;
  typicalEducationLevelGroup?: Maybe<Scalars['String']>;
  typicalEducationLevelGroupId?: Maybe<Scalars['Int']>;
  typicalWorkExperienceCategoryTypeId?: Maybe<Scalars['Int']>;
  typicalWorkExperienceCategoryTypeName?: Maybe<Scalars['String']>;
  typicalWorkExperienceGroup?: Maybe<Scalars['String']>;
  typicalWorkExperienceGroupId?: Maybe<Scalars['Int']>;
  valuesMatchQualityId?: Maybe<Scalars['Int']>;
  videoId?: Maybe<Scalars['String']>;
  videoUrl?: Maybe<Scalars['String']>;
  workValuesCompatibility?: Maybe<Array<Maybe<WorkValuesCompatibility>>>;
};

export type CpdProgram = {
  __typename?: 'CPDProgram';
  alignment?: Maybe<Scalars['Int']>;
  cipCode?: Maybe<Scalars['String']>;
  definition?: Maybe<Scalars['String']>;
  isOnline?: Maybe<Scalars['Boolean']>;
  officialTitle?: Maybe<Scalars['String']>;
  /**
   * ENRICH.10: how many schools offer this program's CIP at its level, which is
   * the size of the school list the row opens with no filters. Null when unknown.
   */
  schoolCount?: Maybe<Scalars['Int']>;
  opeid: Scalars['ID'];
  programName?: Maybe<Scalars['String']>;
  qualityMetric?: Maybe<Scalars['Int']>;
  schoolId?: Maybe<Scalars['Int']>;
  schoolProgramEdLevelId?: Maybe<Scalars['Int']>;
  schoolProgramId?: Maybe<Scalars['Int']>;
};

export type CareerGoalAlignmentInput = {
  interestsAnalysis: Scalars['String'];
  lifestyleAnalysis: Scalars['String'];
  skillsAnalysis: Scalars['String'];
  valuesAnalysis: Scalars['String'];
};

/**
 * One KSA row of the career goal, with the learner's match. AI-5 added every
 * field after isUserMatch; all optional, so an older client still validates.
 */
export type CareerGoalSkillCompatibilityInput = {
  /** O*NET importance, 1 to 5 */
  importance?: InputMaybe<Scalars['Float']>;
  isUserMatch: Scalars['Boolean'];
  /** MET, NAMED or GAP; null when the record was not compared */
  matchStatus?: InputMaybe<Scalars['String']>;
  /** What in the record meets it, e.g. military experience: 17C Cyber Operations Specialist */
  matchedBy?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  /** knowledge, skill, ability or work_activity */
  type?: InputMaybe<Scalars['String']>;
};

export type CareerPathway = {
  __typename?: 'CareerPathway';
  category?: Maybe<Scalars['String']>;
  descr?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  devPublish?: Maybe<Scalars['Boolean']>;
  growthRate?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  interestsmatch?: Maybe<Scalars['Float']>;
  jobEducationOptions?: Maybe<JobEducationOptions>;
  jobs?: Maybe<Array<Maybe<PathwayJob>>>;
  levels?: Maybe<Array<Maybe<PathwayLevel>>>;
  lifestylematch?: Maybe<Scalars['Float']>;
  maxSalary?: Maybe<Scalars['Float']>;
  minSalary?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  occupationCount?: Maybe<Scalars['Int']>;
  pathwayId: Scalars['ID'];
  prodPublish?: Maybe<Scalars['Boolean']>;
  skillsmatch?: Maybe<Scalars['Float']>;
  sponsorshipCompany?: Maybe<SponsorshipCompany>;
  stepConnections?: Maybe<Array<Maybe<PathwayConnection>>>;
  valuesmatch?: Maybe<Scalars['Float']>;
  videoUrl?: Maybe<Scalars['String']>;
};

export type ChatbotMetadata = {
  __typename?: 'ChatbotMetadata';
  conversationGoals?: Maybe<ConversationGoals>;
  learningSuggestions?: Maybe<LearningSuggestions>;
  processingTime: Scalars['Int'];
  rateLimit: RateLimitResult;
  retrieval: RetrievalMetadata;
};

export type ChatbotResponse = {
  __typename?: 'ChatbotResponse';
  conversationId: Scalars['Int'];
  metadata: ChatbotMetadata;
  response: Scalars['String'];
};

export type CipCode = {
  __typename?: 'CipCode';
  cipCode?: Maybe<Scalars['String']>;
  cipTitle?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  jobId?: Maybe<Scalars['ID']>;
};

export enum CipCodeCutoffFilter {
  Any = 'ANY',
  CloselyRelated = 'CLOSELY_RELATED',
  Recommended = 'RECOMMENDED',
  RelatedField = 'RELATED_FIELD',
  SomewhatRelated = 'SOMEWHAT_RELATED'
}

export type CipCodeForGoal = {
  __typename?: 'CipCodeForGoal';
  cipCode?: Maybe<Scalars['String']>;
  cipTitle?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  jobId?: Maybe<Scalars['ID']>;
};

export type CognitoBindingResult = {
  __typename?: 'CognitoBindingResult';
  profile: Profile;
  refreshToken: Scalars['String'];
  token: Scalars['ID'];
};

export type Competency = {
  __typename?: 'Competency';
  cnt?: Maybe<Scalars['Int']>;
  code?: Maybe<Scalars['String']>;
  competencyDescription?: Maybe<Scalars['String']>;
  competencyLabel?: Maybe<Scalars['String']>;
  skillId?: Maybe<Scalars['String']>;
  sourceType?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  typeId?: Maybe<Scalars['Int']>;
};

export type CompetencyInput = {
  cnt?: InputMaybe<Scalars['Int']>;
  code?: InputMaybe<Scalars['String']>;
  competencyDescription?: InputMaybe<Scalars['String']>;
  competencyLabel?: InputMaybe<Scalars['String']>;
  skillId?: InputMaybe<Scalars['String']>;
  sourceType?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  typeId?: InputMaybe<Scalars['Int']>;
};

export type CompletionBranchRow = {
  __typename?: 'CompletionBranchRow';
  byBranch: Array<AnalyticsNamedValue>;
  construct: SurveyConstruct;
  /**
   * Completions recorded since capture began, NOT since the start of the program.
   * Always render this next to CompletionReport.captureStartedAt.
   */
  cumulative: Scalars['Int'];
  label: Scalars['String'];
  /** periodTotal against the same elapsed slice of the previous period. */
  periodDelta?: Maybe<PeriodDelta>;
  periodTotal: Scalars['Int'];
};

export type CompletionReport = {
  __typename?: 'CompletionReport';
  /**
   * When completion events started being recorded: the earliest row in
   * analytics.survey_completions, as an ISO timestamp, or null if there are none.
   *
   * The event log was added in August 2026. Hundreds of thousands of learners hold
   * survey answers from before it existed and are not counted, so `cumulative`
   * without this date beside it reads as a program-to-date figure and understates
   * history by roughly fortyfold. Nothing is backfilled: inventing completion
   * timestamps we never observed would be worse than the caveat.
   */
  captureStartedAt?: Maybe<Scalars['String']>;
  period: ReportPeriod;
  rows: Array<CompletionBranchRow>;
  series: Array<AnalyticsTimePoint>;
};

export type ConnectActionResult = {
  __typename?: 'ConnectActionResult';
  connectedCount: Scalars['Int'];
};

export type ConnectOrganizationSearchResult = {
  __typename?: 'ConnectOrganizationSearchResult';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  logo?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  organizationType: OrganizationType;
  website?: Maybe<Scalars['String']>;
};

export type ConnectUserGoal = {
  __typename?: 'ConnectUserGoal';
  userGoal: ConnectUserGoalDetail;
  userProfile: ConnectUserProfileSnapshot;
};

export type ConnectUserGoalDetail = {
  __typename?: 'ConnectUserGoalDetail';
  certificationId?: Maybe<Scalars['String']>;
  licenseId?: Maybe<Scalars['String']>;
  onetCode?: Maybe<Scalars['String']>;
  pathwayId?: Maybe<Scalars['String']>;
  schoolId?: Maybe<Scalars['String']>;
  schoolProgramEdLevelId?: Maybe<Scalars['String']>;
  schoolProgramId?: Maybe<Scalars['String']>;
};

export type ConnectUserGoalDetailInput = {
  certificationId?: InputMaybe<Scalars['String']>;
  licenseId?: InputMaybe<Scalars['String']>;
  onetCode: Scalars['String'];
  pathwayId?: InputMaybe<Scalars['String']>;
  schoolId?: InputMaybe<Scalars['String']>;
  schoolProgramEdLevelId?: InputMaybe<Scalars['String']>;
  schoolProgramId?: InputMaybe<Scalars['String']>;
};

export type ConnectUserGoalInput = {
  userGoal: ConnectUserGoalDetailInput;
  userProfile: ConnectUserProfileSnapshotInput;
};

export type ConnectUserProfileSnapshot = {
  __typename?: 'ConnectUserProfileSnapshot';
  branchCode?: Maybe<Scalars['String']>;
  profileType?: Maybe<Scalars['Int']>;
  serveTypeId?: Maybe<Scalars['Int']>;
};

export type ConnectUserProfileSnapshotInput = {
  branchCode?: InputMaybe<Scalars['String']>;
  profileType?: InputMaybe<Scalars['Int']>;
  serveTypeId?: InputMaybe<Scalars['Int']>;
};

export type ContextExtractionResult = {
  __typename?: 'ContextExtractionResult';
  errors: Scalars['Int'];
  processed: Scalars['Int'];
};

export type Conversation = {
  __typename?: 'Conversation';
  conversationGoals?: Maybe<ConversationGoals>;
  createdAt: Scalars['String'];
  id: Scalars['Int'];
  lastMessage?: Maybe<Scalars['String']>;
  messageCount: Scalars['Int'];
  title: Scalars['String'];
  updatedAt: Scalars['String'];
};

export type ConversationContextStats = {
  __typename?: 'ConversationContextStats';
  conversationsNeedingUpdates: Scalars['Int'];
  conversationsWithContext: Scalars['Int'];
  lastContextUpdate?: Maybe<Scalars['String']>;
  totalConversations: Scalars['Int'];
};

export type ConversationGoals = {
  __typename?: 'ConversationGoals';
  certificationId?: Maybe<Scalars['String']>;
  edlevelId?: Maybe<Scalars['String']>;
  hasChanged?: Maybe<Scalars['Boolean']>;
  onetCode?: Maybe<Scalars['String']>;
  programId?: Maybe<Scalars['String']>;
  schoolId?: Maybe<Scalars['String']>;
};

export type ConversationList = {
  __typename?: 'ConversationList';
  conversationCount: Scalars['Int'];
  conversations: Array<Conversation>;
};

export type ConversationNamingResult = {
  __typename?: 'ConversationNamingResult';
  errors: Scalars['Int'];
  processed: Scalars['Int'];
};

export type ConversationNamingStats = {
  __typename?: 'ConversationNamingStats';
  conversationsEligibleForNaming: Scalars['Int'];
  conversationsNotRenamed: Scalars['Int'];
  conversationsRenamed: Scalars['Int'];
  totalConversations: Scalars['Int'];
};

export type ConversationWithMessages = {
  __typename?: 'ConversationWithMessages';
  conversation: Conversation;
  messageCount?: Maybe<Scalars['Int']>;
  messages: Array<Message>;
};

export type Course = {
  __typename?: 'Course';
  description: Scalars['String'];
  source_type: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type CourseSuggestionResponse = {
  __typename?: 'CourseSuggestionResponse';
  courseSummary: Scalars['String'];
  courses: Array<Course>;
  narrative: Scalars['String'];
};

export type Credential = {
  __typename?: 'Credential';
  /**
   * Skill statements this resource teaches or requires. Often empty: 1.9% of
   * credentials and 24.3% of courses carry any.
   */
  competencies: Array<CredentialCompetency>;
  costs: Array<CredentialCost>;
  /** The CTDL class with its prefix stripped, e.g. "Certification". */
  credentialType?: Maybe<Scalars['String']>;
  ctid: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  /**
   * ISO 8601 durations exactly as published, e.g. "P4M". Not converted to months
   * or hours on purpose: publishers use different precisions and converting would
   * claim one they did not.
   */
  durations: Array<Scalars['String']>;
  /** The human-facing Credential Finder page. Always present. */
  finderUrl: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  occupations: Array<CredentialOccupation>;
  offeredBy: Array<CredentialOrganization>;
  ownedBy: Array<CredentialOrganization>;
  /**
   * Which rule put this credential where it is in an occupation's list.
   *
   * NULL on every live lookup, and that is deliberate rather than an oversight: a
   * tier is a statement about one credential's standing against one occupation,
   * decided by the weekly refresh with the whole shortlist in front of it. A
   * single-record lookup has neither the occupation nor the comparison set.
   *
   * A client renders the tier as a sentence about what we checked. It is NOT a
   * quality score and there is no such thing in this schema: the Registry
   * publishes no demand, value, earnings or holder data, and CPD's agreement with
   * Credential Engine forbids representations as to the quality of a credential.
   */
  rankTier?: Maybe<CredentialRankTier>;
  /**
   * How many of the occupation's required O*NET skills this credential publishes
   * teaching. Null on a live lookup, for the same reason as rankTier.
   *
   * Usually 0, and a 0 is honest: only about 1.9% of credentials publish any
   * competency at all, so most say nothing about what they teach. Never present
   * 0 as "teaches none of them" — it means "told us nothing".
   */
  skillOverlap?: Maybe<Scalars['Int']>;
  /** e.g. "Active". */
  status?: Maybe<Scalars['String']>;
  /** The publisher's own page for this credential. */
  subjectWebpage?: Maybe<Scalars['String']>;
};

/**
 * One skill statement, with the body that defines it.
 *
 * frameworkName is kept because it is what makes the statement attributable:
 * "Microsoft Skills Measured" and "Comprehensive WGU Competencies" are claims by
 * different organisations and should not be flattened into one anonymous list.
 *
 * via says how it was asserted: TEACHES means a course states it teaches this,
 * REQUIRES means a credential states it demands this. They are different claims
 * and a learner-facing surface should not present them identically.
 */
export type CredentialCompetency = {
  __typename?: 'CredentialCompetency';
  frameworkName?: Maybe<Scalars['String']>;
  text: Scalars['String'];
  via: CredentialCompetencySource;
};

export enum CredentialCompetencySource {
  Requires = 'REQUIRES',
  Teaches = 'TEACHES'
}

export type CredentialCost = {
  __typename?: 'CredentialCost';
  currency?: Maybe<Scalars['String']>;
  detailsUrl?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
};

export type CredentialLookupResult = {
  __typename?: 'CredentialLookupResult';
  credential?: Maybe<Credential>;
  /** Set only when status is ERROR. */
  message?: Maybe<Scalars['String']>;
  status: CredentialLookupStatus;
};

/**
 * Why a lookup returned no credential.
 *
 * Separate values rather than one null, because these need different handling and
 * must never look alike to whoever is debugging:
 *   DISABLED      the flag is off in this environment
 *   NOT_FOUND     the Registry has no such CTID
 *   INVALID_CTID  the CTID was malformed and was never sent upstream
 *   ERROR         upstream failure, timeout, or an unparseable body
 */
export enum CredentialLookupStatus {
  Disabled = 'DISABLED',
  Error = 'ERROR',
  InvalidCtid = 'INVALID_CTID',
  NotFound = 'NOT_FOUND',
  Ok = 'OK'
}

/**
 * An occupation the credential is FOR.
 *
 * socCode is an O*NET SOC code as the publisher supplied it, which makes it the
 * join key to CPD occupations and to SkillsDNA anchors.
 */
export type CredentialOccupation = {
  __typename?: 'CredentialOccupation';
  socCode?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** An organisation that owns or offers a credential. */
export type CredentialOrganization = {
  __typename?: 'CredentialOrganization';
  ctid?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

/**
 * Why a credential sits where it does. Strongest claim first.
 *
 * Only TEACHES_NEEDED_SKILLS says anything about usefulness to this learner. The
 * other two say what we know about the credential, which is less, and a client
 * must not flatten them into one "recommended" badge.
 */
export enum CredentialRankTier {
  /** The publisher listed it for this occupation. Nothing more is known. */
  ListedForOccupation = 'LISTED_FOR_OCCUPATION',
  /** Publishes what it teaches, but none of it matches this occupation. */
  PublishesSkills = 'PUBLISHES_SKILLS',
  /** Publishes skills, and some are skills this occupation requires. */
  TeachesNeededSkills = 'TEACHES_NEEDED_SKILLS'
}

/**
 * PWS 4.1.7 and 4.1.19. What a credential is worth, and who says so.
 *
 * The record behind a badge, not the badge. A credential nobody can check is
 * decoration, so every figure here carries its source and its date.
 */
export type CredentialRecord = {
  __typename?: 'CredentialRecord';
  aceCriteria?: Maybe<Scalars['String']>;
  aceReviewedOn?: Maybe<Scalars['Date']>;
  /**
   * Block 2: who checked it, and what they asked.
   *
   * ACE and the employer are two claims by two bodies and must never collapse
   * into one "verified" badge. They are separate fields for that reason, and a
   * client that renders one pill from both is wrong.
   */
  aceValidated: Scalars['Boolean'];
  /**
   * Block 3: what happened to people who took it.
   *
   * Null means nobody knows, and the surface says so. There are no zeros standing
   * in for missing data.
   */
  completionRate?: Maybe<Scalars['Float']>;
  /** Stable, and the target of the #cred-<key> deep link on the pathway board. */
  credentialKey: Scalars['String'];
  /** Block 1: what it is worth. */
  creditHours?: Maybe<Scalars['Float']>;
  creditLevel?: Maybe<Scalars['String']>;
  creditRecommendation?: Maybe<Scalars['String']>;
  employerConfirmed: Scalars['Boolean'];
  employerCriteria?: Maybe<Scalars['String']>;
  employerName?: Maybe<Scalars['String']>;
  employerReviewedOn?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  issuer: Scalars['String'];
  medianEarnings?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  outcomesAsOf?: Maybe<Scalars['Date']>;
  outcomesSource?: Maybe<Scalars['String']>;
  pathwayNote?: Maybe<Scalars['String']>;
  /** Block 4: where it sits relative to the rest of a pathway. */
  pathwayPosition?: Maybe<Scalars['Int']>;
  placementRate?: Maybe<Scalars['Float']>;
};

/**
 * A page of search results.
 *
 * totalCount is the Registry's total, not the page size, and it is routinely in the
 * hundreds. A surface must say "the first N of totalCount" rather than implying it
 * has them all.
 */
export type CredentialSearchResult = {
  __typename?: 'CredentialSearchResult';
  credentials: Array<Credential>;
  /** Set only when status is ERROR. */
  message?: Maybe<Scalars['String']>;
  status: CredentialSearchStatus;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum CredentialSearchStatus {
  Disabled = 'DISABLED',
  /** The search ran and matched nothing. A normal answer. */
  Empty = 'EMPTY',
  Error = 'ERROR',
  /** No Credential Engine API key in this environment, so nothing can be discovered. */
  NotConfigured = 'NOT_CONFIGURED',
  Ok = 'OK'
}

export type CurrentUserConnections = {
  __typename?: 'CurrentUserConnections';
  academic: Array<Scalars['ID']>;
  employer: Array<Scalars['ID']>;
  nonprofit: Array<Scalars['ID']>;
  totalCount: Scalars['Int'];
};

export type Degree = {
  __typename?: 'Degree';
  cipCode: Scalars['ID'];
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type DegreeTitle = {
  __typename?: 'DegreeTitle';
  cipCode?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  title?: Maybe<Scalars['String']>;
};

export type DegreeTitleInput = {
  cipCode?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
  title?: InputMaybe<Scalars['String']>;
};

export type DismissNotificationResponse = {
  __typename?: 'DismissNotificationResponse';
  /** The row as it now stands, so a client can reconcile without a refetch. */
  notification?: Maybe<Notification>;
  success: Scalars['Boolean'];
};

export type Education = {
  __typename?: 'Education';
  /**
   * GR-1. True when the member holds this qualification, false when they are
   * still working toward it. Rows written before GR-1 are all true, because the
   * survey did not ask and the app has always read them as attainment.
   */
  completed?: Maybe<Scalars['Boolean']>;
  degreeInfo?: Maybe<DegreeTitle>;
  educationLevelId: Scalars['Int'];
  educationLevelShortDescr?: Maybe<Scalars['String']>;
  valid?: Maybe<Scalars['Boolean']>;
};

export type EducationData = {
  __typename?: 'EducationData';
  level?: Maybe<Scalars['String']>;
  requirements?: Maybe<Scalars['String']>;
};

export type EducationInput = {
  /**
   * GR-1. Whether the member holds this or is still working toward it. Omitted
   * means held, which is how every row written before GR-1 reads.
   */
  completed?: InputMaybe<Scalars['Boolean']>;
  degreeInfo?: InputMaybe<DegreeTitleInput>;
  educationLevelId: Scalars['Int'];
  educationLevelShortDescr?: InputMaybe<Scalars['String']>;
  valid?: InputMaybe<Scalars['Boolean']>;
};

export type EducationLevel = {
  __typename?: 'EducationLevel';
  altLabel?: Maybe<Scalars['String']>;
  educationAdj?: Maybe<Scalars['String']>;
  educationLevelId: Scalars['Int'];
  educationLevelName?: Maybe<Scalars['String']>;
  educationLevelShortDescr?: Maybe<Scalars['String']>;
  percentage?: Maybe<Scalars['Int']>;
};

export enum EducationLevelFilter {
  Any = 'ANY',
  Associates = 'ASSOCIATES',
  Bachelors = 'BACHELORS',
  Certificate = 'CERTIFICATE',
  Masters = 'MASTERS'
}

export type EducationLevelFrequency = {
  __typename?: 'EducationLevelFrequency';
  educationLevelGroup?: Maybe<Scalars['String']>;
  educationLevelGroupId?: Maybe<Scalars['Int']>;
  frequency?: Maybe<Scalars['Float']>;
};

export type EmailNotificationTriggerResult = {
  __typename?: 'EmailNotificationTriggerResult';
  failed: Array<Scalars['String']>;
  success: Array<Scalars['String']>;
};

export type EmbedConfig = {
  __typename?: 'EmbedConfig';
  defaultPage?: Maybe<Scalars['String']>;
  embedToken: EmbedToken;
  embedUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  minutesToExpiration?: Maybe<Scalars['Int']>;
  mobileDefaultPage?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type EmbedToken = {
  __typename?: 'EmbedToken';
  expiration?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  tokenId?: Maybe<Scalars['String']>;
};

export type EnableFeatureFlagsInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<FeatureEnum>;
};

export type Evaluation = {
  __typename?: 'Evaluation';
  isPositiveOutcome?: Maybe<Scalars['Boolean']>;
  itemType?: Maybe<Scalars['Int']>;
  occupationRequires?: Maybe<Scalars['String']>;
  occupationRequiresObject?: Maybe<Array<Maybe<EvaluationObject>>>;
  otherAlignments?: Maybe<Array<Maybe<EvaluationOtherAlignments>>>;
  outcomeFullTime?: Maybe<Scalars['String']>;
  outcomePartTime?: Maybe<Scalars['String']>;
  userHas?: Maybe<Scalars['String']>;
  userHasObject?: Maybe<Array<Maybe<EvaluationObject>>>;
};

export type EvaluationItem = {
  __typename?: 'EvaluationItem';
  id?: Maybe<Scalars['ID']>;
  isMatched?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type EvaluationObject = {
  __typename?: 'EvaluationObject';
  details?: Maybe<Scalars['String']>;
  detailsArray?: Maybe<Array<Maybe<Scalars['String']>>>;
  id?: Maybe<Scalars['Int']>;
  isMatched?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<Maybe<EvaluationItem>>>;
  title?: Maybe<Scalars['String']>;
};

export type EvaluationOtherAlignments = {
  __typename?: 'EvaluationOtherAlignments';
  id: Scalars['ID'];
  title: Scalars['String'];
};

export type ExtendedMilitaryBranch = {
  __typename?: 'ExtendedMilitaryBranch';
  branchCode?: Maybe<Scalars['String']>;
  extendedBranchCode: Scalars['String'];
  extendedBranchTitle: Scalars['String'];
  mocSubstitute?: Maybe<Scalars['String']>;
};

export type FavoriteMilitaryOccupation = {
  __typename?: 'FavoriteMilitaryOccupation';
  branchCode?: Maybe<Scalars['String']>;
  isFavorite?: Maybe<Scalars['Boolean']>;
  mocCode: Scalars['String'];
  mocTitle?: Maybe<Scalars['String']>;
};

export type FavoriteMilitaryOccupationResponse = ResponseInterface & {
  __typename?: 'FavoriteMilitaryOccupationResponse';
  code: Scalars['Int'];
  favoriteMilitaryOccupation?: Maybe<FavoriteMilitaryOccupation>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type FavoriteOccupation = {
  __typename?: 'FavoriteOccupation';
  growthRateBand?: Maybe<Scalars['String']>;
  imageName?: Maybe<Scalars['String']>;
  interestsMatchQualityId?: Maybe<Scalars['Int']>;
  isFavorite?: Maybe<Scalars['Boolean']>;
  isMatch?: Maybe<Scalars['Boolean']>;
  isOverqualified?: Maybe<Scalars['Boolean']>;
  jobId?: Maybe<Scalars['Int']>;
  lifestyleMatchQualityId?: Maybe<Scalars['Int']>;
  medianAnnualWage?: Maybe<Scalars['Float']>;
  medianHourlyWage?: Maybe<Scalars['Float']>;
  onetSocCode: Scalars['ID'];
  preferredEdLevelDescription?: Maybe<Scalars['String']>;
  skillsMatchQualityId?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  valuesMatchQualityId?: Maybe<Scalars['Int']>;
};

export type FavoriteOccupationResponse = ResponseInterface & {
  __typename?: 'FavoriteOccupationResponse';
  code: Scalars['Int'];
  favoriteOccupation?: Maybe<FavoriteOccupation>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type FeatureAdoptionReport = {
  __typename?: 'FeatureAdoptionReport';
  /**
   * The earliest event in the whole table: when capture demonstrably began.
   *
   * Every figure on this page starts here. A zero before this date means we were
   * not recording, not that nobody did it -- the same distinction the assessment
   * figures carry, and for the same reason: events cannot be backfilled.
   */
  captureStartedAt?: Maybe<Scalars['String']>;
  eventsDelta?: Maybe<PeriodDelta>;
  learnersDelta?: Maybe<PeriodDelta>;
  period: ReportPeriod;
  periodEvents: Scalars['Int'];
  periodLearners: Scalars['Int'];
  rows: Array<FeatureAdoptionRow>;
  /** Every feature's events over time, for the trend. */
  series: Array<AnalyticsTimePoint>;
  /** The same, split by feature. */
  seriesByFeature: Array<AnalyticsTimePoint>;
  /**
   * Registry entries that have produced NO event at all.
   *
   * Listed rather than omitted, because a capability with no row and a capability
   * with a zero are the same picture to a reader and mean different things to us:
   * unused, or unwired. This page is the only place either becomes visible.
   */
  silentFeatures: Array<Scalars['String']>;
  totalEvents: Scalars['Int'];
  totalLearners: Scalars['Int'];
};

/** ANALYTICS.21. One capability, and whether anybody is using it. */
export type FeatureAdoptionRow = {
  __typename?: 'FeatureAdoptionRow';
  /** Which actions, e.g. created vs downloaded. A feature can be made and never used. */
  byAction: Array<AnalyticsNamedValue>;
  byBranch: Array<AnalyticsNamedValue>;
  /** This period against the one before. Null when there is nothing to compare. */
  delta?: Maybe<PeriodDelta>;
  /** Events over the whole capture window, not the selected period. */
  events: Scalars['Int'];
  /** The registry key, e.g. 'resume'. Stable; the label is not. */
  feature: Scalars['String'];
  /**
   * The first event ever recorded for this feature, or null if there are none.
   *
   * Null is the important case and it is AMBIGUOUS: it means either nobody has
   * used the feature or nothing is emitting for it. The page must say both; this
   * data cannot tell them apart and neither can anyone reading it.
   */
  firstSeenAt?: Maybe<Scalars['String']>;
  /** What a reader calls it. */
  label: Scalars['String'];
  /** Distinct learners over the whole capture window. */
  learners: Scalars['Int'];
  /** Events inside the selected period. */
  periodEvents: Scalars['Int'];
  periodLearners: Scalars['Int'];
};

export enum FeatureEnum {
  OpenaiApiCalling = 'OPENAI_API_CALLING'
}

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  description?: Maybe<Scalars['String']>;
  isEnabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type FeatureFlags = {
  __typename?: 'FeatureFlags';
  featureFlags?: Maybe<Array<Maybe<FeatureFlag>>>;
};

export type Feedback = {
  comment?: Maybe<Scalars['String']>;
  createdtimestamp?: Maybe<Scalars['String']>;
  recommendrating?: Maybe<Scalars['Int']>;
  routeurl?: Maybe<Scalars['String']>;
};

export type FeedbackAnalytics = {
  __typename?: 'FeedbackAnalytics';
  avarageRating?: Maybe<Scalars['Int']>;
  avarageRatingIncreased?: Maybe<Scalars['Boolean']>;
  percentDfferenceAvarageRating?: Maybe<Scalars['Int']>;
  percentDifferenceTotal?: Maybe<Scalars['Int']>;
  totalFeedback?: Maybe<Scalars['Int']>;
  totalIncreased?: Maybe<Scalars['Boolean']>;
};

export type FeedbackForAdmin = Feedback & {
  __typename?: 'FeedbackForAdmin';
  comment?: Maybe<Scalars['String']>;
  createdtimestamp?: Maybe<Scalars['String']>;
  moctitle?: Maybe<Scalars['String']>;
  recommendrating?: Maybe<Scalars['Int']>;
  routeurl?: Maybe<Scalars['String']>;
};

export type FeedbackInput = {
  comment?: InputMaybe<Scalars['String']>;
  recommendRating: Scalars['Int'];
  routeUrl?: InputMaybe<Scalars['String']>;
};

/**
 * FD-1. What the visitor told the front door they came to do.
 *
 * Replaces the retired profile-work-type question. One answer per user, guest or
 * member; a guest's answer carries into their account when they sign in.
 */
export type FrontDoorAnswers = {
  __typename?: 'FrontDoorAnswers';
  /** When they first answered, as an ISO 8601 timestamp. */
  answeredAt?: Maybe<Scalars['String']>;
  /** benefit, job, explore, degree, credit, return or other. */
  intent: Scalars['String'];
  /** Their own words, when none of the tiles fit. At most 280 characters. */
  intentText?: Maybe<Scalars['String']>;
};

export type FrontDoorInput = {
  /** benefit, job, explore, degree, credit, return or other. Anything else is refused. */
  intent: Scalars['String'];
  /** Trimmed and cut to 280 characters. */
  intentText?: InputMaybe<Scalars['String']>;
  /** military or civilian: which wording the door was shown in. */
  voice?: InputMaybe<Scalars['String']>;
};

export type Goals = {
  __typename?: 'Goals';
  certificationId?: Maybe<Scalars['Int']>;
  certificationTitle?: Maybe<Scalars['String']>;
  /**
   * CRED.1. A Credential Registry credential the learner is working toward.
   *
   * NOT certificationId. That is CPD's own certification catalogue; this is a
   * CTID in the national Credential Registry, and the two are separate
   * catalogues that happen to describe similar things. A client that merges them
   * into one field will show the wrong title the first time a learner has both.
   */
  credentialCtid?: Maybe<Scalars['String']>;
  /**
   * Stored on the goal rather than joined, because nothing in CPD is a catalogue
   * of Registry credentials to join against. See the migration for why.
   */
  credentialTitle?: Maybe<Scalars['String']>;
  customOnetCode?: Maybe<Scalars['String']>;
  customPathwayId?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['ID']>;
  licenseId?: Maybe<Scalars['String']>;
  licenseTitle?: Maybe<Scalars['String']>;
  occupationTitle?: Maybe<Scalars['String']>;
  onetCode?: Maybe<Scalars['ID']>;
  schoolId?: Maybe<Scalars['Int']>;
  schoolProgramEdLevelId?: Maybe<Scalars['Int']>;
  schoolProgramId?: Maybe<Scalars['Int']>;
  /**
   * DATA-6e: true when datastop listed this program before but not in the most
   * recent weekly sync, i.e. the school appears to have stopped offering it. The
   * goal itself is unaffected and keeps working. False also covers "we have never
   * had confirmation either way", so a false is never a promise that the program
   * is still offered -- only a true is a claim.
   */
  schoolProgramRetired?: Maybe<Scalars['Boolean']>;
  schoolProgramTitle?: Maybe<Scalars['String']>;
  schoolTitle?: Maybe<Scalars['String']>;
};

export type GoalsInput = {
  certificationId?: InputMaybe<Scalars['String']>;
  certificationTitle?: InputMaybe<Scalars['String']>;
  /** CRED.1. A Credential Registry CTID. See the note on type Goals. */
  credentialCtid?: InputMaybe<Scalars['String']>;
  credentialTitle?: InputMaybe<Scalars['String']>;
  customOnetCode?: InputMaybe<Scalars['String']>;
  hasLoaded?: InputMaybe<Scalars['Boolean']>;
  jobId?: InputMaybe<Scalars['ID']>;
  licenseId?: InputMaybe<Scalars['String']>;
  licenseTitle?: InputMaybe<Scalars['String']>;
  occupationTitle?: InputMaybe<Scalars['String']>;
  onetCode?: InputMaybe<Scalars['ID']>;
  pathwayId?: InputMaybe<Scalars['String']>;
  schoolId?: InputMaybe<Scalars['Int']>;
  schoolProgramEdLevelId?: InputMaybe<Scalars['Int']>;
  schoolProgramId?: InputMaybe<Scalars['Int']>;
  schoolProgramTitle?: InputMaybe<Scalars['String']>;
  schoolTitle?: InputMaybe<Scalars['String']>;
};

export type GoalsReportDegreeDetails = {
  __typename?: 'GoalsReportDegreeDetails';
  cipCode?: Maybe<Scalars['String']>;
  isRecommendedProgram?: Maybe<Scalars['Boolean']>;
  occupationsRelatedToDegree?: Maybe<Array<Maybe<GoalsReportOccupationListItem>>>;
  programName?: Maybe<Scalars['String']>;
  schoolProgramEdLevelName?: Maybe<Scalars['String']>;
};

export type GoalsReportDetails = {
  __typename?: 'GoalsReportDetails';
  certification?: Maybe<CpdCertificate>;
  certificationId?: Maybe<Scalars['Int']>;
  /** @deprecated renamed use certificationId */
  certificationid?: Maybe<Scalars['Int']>;
  degree?: Maybe<GoalsReportDegreeDetails>;
  generatedReportDate?: Maybe<Scalars['String']>;
  /** @deprecated not used */
  jobId?: Maybe<Scalars['Int']>;
  lastLogin?: Maybe<Scalars['String']>;
  lastUpdated?: Maybe<Scalars['String']>;
  license?: Maybe<CpdLicense>;
  licenseId?: Maybe<Scalars['String']>;
  license_id?: Maybe<Scalars['String']>;
  /** @deprecated renamed use licenseId */
  licenseid?: Maybe<Scalars['String']>;
  occupation?: Maybe<GoalsReportOccupationDetails>;
  onetCode?: Maybe<Scalars['String']>;
  /** @deprecated use sessionId */
  publicSessionId?: Maybe<Scalars['String']>;
  returnLink?: Maybe<Scalars['String']>;
  school?: Maybe<GoalsReportSchoolDetails>;
  schoolId?: Maybe<Scalars['Int']>;
  sessionId?: Maybe<Scalars['String']>;
};

export type GoalsReportOccupationDetails = {
  __typename?: 'GoalsReportOccupationDetails';
  demand?: Maybe<Scalars['Int']>;
  edLevelDescription?: Maybe<Scalars['String']>;
  edLevelPercent?: Maybe<Scalars['Float']>;
  matches?: Maybe<GoalsReportOccupationDetailsMatches>;
  medianAnnualWage?: Maybe<Scalars['Float']>;
  projectedGrowth?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
};

export type GoalsReportOccupationDetailsMatches = {
  __typename?: 'GoalsReportOccupationDetailsMatches';
  interestsMatchQuality?: Maybe<Scalars['String']>;
  lifestyleMatchQuality?: Maybe<Scalars['String']>;
  skillsMatchQuality?: Maybe<Scalars['String']>;
  valuesMatchQuality?: Maybe<Scalars['String']>;
};

export type GoalsReportOccupationListItem = {
  __typename?: 'GoalsReportOccupationListItem';
  title: Scalars['String'];
};

export type GoalsReportSchoolDetails = {
  __typename?: 'GoalsReportSchoolDetails';
  address?: Maybe<Scalars['String']>;
  ageEntry?: Maybe<Scalars['Int']>;
  averageCostSH?: Maybe<Scalars['Float']>;
  creditForLifeExperiences?: Maybe<Scalars['Boolean']>;
  creditForMilitaryTraining?: Maybe<Scalars['Boolean']>;
  dedicatedPOCforServiceMembers?: Maybe<Scalars['Boolean']>;
  institutionName?: Maybe<Scalars['String']>;
  opeid?: Maybe<Scalars['String']>;
  openAdmissionPolicy?: Maybe<Scalars['Boolean']>;
  partTimeRetentionRate?: Maybe<Scalars['Float']>;
  percentOfDistanceLearners?: Maybe<Scalars['Float']>;
  schoolPlacementServices?: Maybe<Scalars['Boolean']>;
  telephoneNumber?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type GrowthData = {
  __typename?: 'GrowthData';
  outlook?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
};

/**
 * PWS 4.1.3 and 4.5. Help content for the Learner and Counselor Resources page.
 *
 * Content rather than markup: spec 08 acceptance criterion 5 is that this is
 * editable without a deploy, because the people who answer support questions are
 * not the people who deploy.
 */
export type HelpArticle = {
  __typename?: 'HelpArticle';
  /** member, counselor or both. Separate from panel: accessibility serves both. */
  audience: Scalars['String'];
  body: Scalars['String'];
  /** PWS 4.5. Both of these are required of a video by a database constraint. */
  captionsUrl?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /** article or video. */
  kind: Scalars['String'];
  /** start, account, counselors or accessibility. */
  panel: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  transcript?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  videoUrl?: Maybe<Scalars['String']>;
};

export type HotSpotLocation = {
  __typename?: 'HotSpotLocation';
  demand?: Maybe<Scalars['String']>;
  demandLevel?: Maybe<Scalars['String']>;
  fipsCode?: Maybe<Scalars['String']>;
  isHomeArea?: Maybe<Scalars['Boolean']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  realSalary?: Maybe<Scalars['String']>;
  salary?: Maybe<Scalars['String']>;
  z?: Maybe<Scalars['Int']>;
};

export type InsightCategory = {
  __typename?: 'InsightCategory';
  strengths?: Maybe<Array<InsightKey>>;
  weaknesses?: Maybe<Array<InsightKey>>;
};

export type InsightKey = {
  __typename?: 'InsightKey';
  description: Scalars['String'];
  title: Scalars['String'];
};

/** GR.5. The career, school and program goal names a Goals Report was written for. */
export type InsightWrittenFor = {
  __typename?: 'InsightWrittenFor';
  careerGoal?: Maybe<Scalars['String']>;
  institutionGoal?: Maybe<Scalars['String']>;
  programGoal?: Maybe<Scalars['String']>;
};

/**
 * DATA-1 (DANTES.A1): one row of api.installation. branchcode null means the
 * installation is offered to every branch (joint bases, HQ/agency sites).
 */
export type InstallationLocation = {
  __typename?: 'InstallationLocation';
  active?: Maybe<Scalars['Boolean']>;
  aliases?: Maybe<Scalars['String']>;
  branchcode?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isnotlisted?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  nationalguard?: Maybe<Scalars['Boolean']>;
  reserve?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
};

export type Interest = {
  __typename?: 'Interest';
  interestsId: Scalars['Int'];
  question: Scalars['String'];
};

export type InterestInput = {
  abbreviation?: InputMaybe<Scalars['String']>;
  interestId?: InputMaybe<Scalars['Int']>;
  level?: InputMaybe<Scalars['Float']>;
};

export type InterestReportInput = {
  level: Scalars['Float'];
  name: Scalars['String'];
};

export type InterestsCompatibility = {
  __typename?: 'InterestsCompatibility';
  id?: Maybe<Scalars['Int']>;
  level?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
};

export type InterestsCompatibilityInput = {
  goalInterests: Array<InterestReportInput>;
  userInterests: Array<InterestReportInput>;
};

export type JobCompetency = {
  __typename?: 'JobCompetency';
  advancedCompetencies: Array<Competency>;
  coreCompetencies: Array<Competency>;
  title?: Maybe<Scalars['String']>;
};

export type JobCompetencyInput = {
  advancedCompetencies: Array<CompetencyInput>;
  coreCompetencies: Array<CompetencyInput>;
  title?: InputMaybe<Scalars['String']>;
};

export type JobEducation = {
  __typename?: 'JobEducation';
  educationLevel?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  job?: Maybe<Scalars['String']>;
  jobId: Scalars['ID'];
  option?: Maybe<Scalars['Int']>;
};

export type JobEducationOptions = {
  __typename?: 'JobEducationOptions';
  cipCodes?: Maybe<Array<Maybe<CipCode>>>;
  educationLevels?: Maybe<Array<Maybe<JobEducation>>>;
  jobToEducationXrefs?: Maybe<Array<Maybe<JobEducationXRef>>>;
};

export type JobEducationXRef = {
  __typename?: 'JobEducationXRef';
  cerT_ID?: Maybe<Scalars['ID']>;
  from?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  job?: Maybe<Scalars['String']>;
  jobId: Scalars['ID'];
  kind?: Maybe<Scalars['Int']>;
  licenseId?: Maybe<Scalars['ID']>;
  schoolId?: Maybe<Scalars['ID']>;
  schoolProgramId?: Maybe<Scalars['ID']>;
  title?: Maybe<Scalars['String']>;
};

export type KeyPoints = {
  __typename?: 'KeyPoints';
  academicGoal?: Maybe<InsightCategory>;
  careerGoal?: Maybe<InsightCategory>;
  compatibility?: Maybe<InsightCategory>;
  constraints?: Maybe<InsightCategory>;
  currentStage?: Maybe<InsightCategory>;
  decisionProcess?: Maybe<InsightCategory>;
  experience?: Maybe<InsightCategory>;
  funding?: Maybe<InsightCategory>;
  interests?: Maybe<InsightCategory>;
  lifestylePreferences?: Maybe<InsightCategory>;
  location?: Maybe<InsightCategory>;
  motivations?: Maybe<InsightCategory>;
  supports?: Maybe<InsightCategory>;
  values?: Maybe<InsightCategory>;
};

/**
 * The channel a claim came from. Held channels (MILITARY, WORK) carry a level and
 * can cover a requirement; attested channels (EDUCATION, CREDENTIAL, TRAINING)
 * name a topic and never close a gap.
 */
export enum KsaMatchChannel {
  Credential = 'CREDENTIAL',
  Education = 'EDUCATION',
  Military = 'MILITARY',
  Training = 'TRAINING',
  Work = 'WORK'
}

/**
 * One record behind a mark.
 *
 * The NAME is the point. "Met by your military experience" is true of a third of
 * a veteran record at once; "Met by your military experience: Electronics
 * Technician" names the thing they can act on. Null only if an anchor somehow has
 * no display name, which is not a case the data produces today.
 */
export type KsaMatchSource = {
  __typename?: 'KsaMatchSource';
  channel: KsaMatchChannel;
  name?: Maybe<Scalars['String']>;
};

/**
 * How a learner's record rates one element of an occupation's profile.
 *
 * FIVE STATES, AND THEY ARE FIVE CLAIMS. Collapsing UNMEASURED into GAP tells a
 * learner they lack something nothing has ever looked at, which is the single
 * failure the skills model exists to prevent. BASELINE is the opposite failure:
 * something we did measure and will not report, because naming it as a
 * deficiency either insults a working adult or describes an aptitude that no
 * course can raise.
 */
export enum KsaMatchStatus {
  /**
   * OCC.4. Measured short, and deliberately not reported as a gap: either an
   * O*NET ability, which is an enduring aptitude with no next step, or an element
   * on the baseline floor. The row leaves both columns AND leaves the counts, so
   * a surface that draws this anywhere has a bug.
   */
  Baseline = 'BASELINE',
  /**
   * Held evidence rates this materially below what the occupation asks, or at
   * zero.
   */
  Gap = 'GAP',
  /**
   * Held evidence rates this at or above what the occupation asks for, or within
   * the element tier's tolerance of it. A shortfall of 0.13 on a scale running to
   * 7 is measurement noise, not a deficiency.
   */
  Met = 'MET',
  /**
   * A completed programme's parsed curriculum names this element. It carries no
   * level, so it is NOT met and must never be drawn as met.
   */
  Named = 'NAMED',
  /** Nothing on the learner's record rates this element. NOT the same as GAP. */
  Unmeasured = 'UNMEASURED'
}

export type LearningSuggestions = {
  __typename?: 'LearningSuggestions';
  certificates?: Maybe<Array<SuggestionItem>>;
  courses?: Maybe<Array<SuggestionItem>>;
};

export type LifestyleInput = {
  aspirations: AspirationInput;
  currentLocations?: InputMaybe<Array<InputMaybe<CpdLocationInput>>>;
  preferredLocations: Array<CpdLocationInput>;
};

export type LocationAttribute = {
  __typename?: 'LocationAttribute';
  costOfLiving?: Maybe<Scalars['Float']>;
  crimeRate?: Maybe<Scalars['Float']>;
  demand?: Maybe<Scalars['Float']>;
  fipsCode: Scalars['String'];
  housingCostIndex?: Maybe<Scalars['Float']>;
  lat?: Maybe<Scalars['Float']>;
  lon?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  pctOfGoodAirQualityDays?: Maybe<Scalars['Float']>;
  unemploymentRate?: Maybe<Scalars['Float']>;
  veteranPopulation?: Maybe<Scalars['Float']>;
};

export type LogoutResponse = {
  __typename?: 'LogoutResponse';
  success: Scalars['Boolean'];
};

/**
 * INFRA-4 write side. Every field is optional and null means "leave unchanged",
 * so the admin form can save one toggle without resending the others.
 *
 * Deliberately narrower than MaintanceStatusReponse: `id` and `isactive` are not
 * accepted. The service always targets the single active row, so there is no id to
 * choose, and isactive is row lifecycle rather than an admin control. Exposing it
 * would let someone switch off the only active row, which makes
 * getMaintanceStatus return null and leaves the admin page showing empty state
 * with no way back other than SQL.
 */
export type MaintanceStatusInput = {
  banneractive?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  siteblocked?: InputMaybe<Scalars['Boolean']>;
};

export type MaintanceStatusReponse = {
  __typename?: 'MaintanceStatusReponse';
  banneractive?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  isactive?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  siteblocked?: Maybe<Scalars['Boolean']>;
};

export type Major = {
  __typename?: 'Major';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

export type MatchedOrganizations = {
  __typename?: 'MatchedOrganizations';
  academic: Array<Scalars['ID']>;
  employer: Array<Scalars['ID']>;
  nonprofit: Array<Scalars['ID']>;
  totalCount: Scalars['Int'];
};

export type Message = {
  __typename?: 'Message';
  content: Scalars['String'];
  createdAt: Scalars['String'];
  disliked?: Maybe<Scalars['Boolean']>;
  id: Scalars['Int'];
  liked?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<MessageMetadata>;
  role: Scalars['String'];
};

export type MessageMetadata = {
  __typename?: 'MessageMetadata';
  confidence?: Maybe<Scalars['Float']>;
  conversationGoals?: Maybe<ConversationGoals>;
  learningSuggestions?: Maybe<LearningSuggestions>;
  retrieval?: Maybe<RetrievalMetadata>;
};

export type MilitaryBackgroundReportInput = {
  branch?: InputMaybe<Scalars['String']>;
  payGrade?: InputMaybe<Scalars['String']>;
  rank?: InputMaybe<Scalars['String']>;
};

export type MilitaryBranch = {
  __typename?: 'MilitaryBranch';
  branchCode?: Maybe<Scalars['String']>;
  branchLabel?: Maybe<Scalars['String']>;
  branchTitle?: Maybe<Scalars['String']>;
  mocSubstitute?: Maybe<Scalars['String']>;
};

export type MilitaryBranchInput = {
  branchCode?: InputMaybe<Scalars['String']>;
  branchLabel?: InputMaybe<Scalars['String']>;
  branchTitle?: InputMaybe<Scalars['String']>;
  mocSubstitute?: InputMaybe<Scalars['String']>;
};

export type MilitaryServeType = {
  __typename?: 'MilitaryServeType';
  branchCode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type Moc = {
  __typename?: 'Moc';
  branchCode?: Maybe<Scalars['String']>;
  extendedBranchCode?: Maybe<Scalars['String']>;
  hasCommissionOfficer?: Maybe<Scalars['Boolean']>;
  hasEnlisted?: Maybe<Scalars['Boolean']>;
  hasWarrantOfficer?: Maybe<Scalars['Boolean']>;
  mocCode: Scalars['String'];
  mocTitle?: Maybe<Scalars['String']>;
  mpcCode?: Maybe<Scalars['String']>;
  numberOfMonthsOfWorkExperience?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export type MocInput = {
  branchCode?: InputMaybe<Scalars['String']>;
  extendedBranchCode?: InputMaybe<Scalars['String']>;
  mocCode: Scalars['String'];
  mocTitle?: InputMaybe<Scalars['String']>;
  mpcCode?: InputMaybe<Scalars['String']>;
  mpcCodeList?: InputMaybe<Array<InputMaybe<MpcCodeInput>>>;
  numberOfMonthsOfWorkExperience?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Scalars['String']>;
};

export type MpcCodeInput = {
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptPrivacyPolicy?: Maybe<UpdateProfileResponse>;
  acknowledgeOutdatedConnections: UserConnectPreferences;
  addPreferredLocation?: Maybe<UpdateProfileResponse>;
  /**
   * T.6. Ask Via about a published portfolio.
   *
   * UNAUTHENTICATED on purpose: the asker is a visitor with no account, which is
   * the whole point of a published page. Throttled per caller like the two public
   * reads, and budgeted against the page OWNER -- there is no visitor to bill, and
   * the member funds answers about themselves.
   *
   * A mutation rather than a query because it SPENDS: it reserves one of the
   * owner's monthly allowance before it generates, and refunds it if the answer
   * never arrives.
   */
  askPortfolioVia?: Maybe<PortfolioViaAnswer>;
  /**
   * S.5. Ask Via about a shared goals report.
   *
   * UNAUTHENTICATED, like the read it accompanies: the counselor has no account
   * and the token is the whole authorization. Budgeted against the LEARNER,
   * because there is nobody else to bill -- a per-counselor quota needs the
   * counselor signed in, and this route deliberately has no guard.
   *
   * Never errors for a reader. Every way a question can end is an outcome.
   *
   * S.6. history is the counselor sidebar's own earlier turns, optional. The
   * server keeps the newest few within a size cap, uses them only to read a
   * follow-up, keys the cache on them, and still charges one unit per question.
   */
  askSharedReportVia: SharedReportViaAnswer;
  submitSharedReportFeedback: Scalars['Boolean'];
  connectWithOrganizations: ConnectActionResult;
  connectWithPremiumPartner: UserPremiumPartnerConnection;
  /** PWS 4.1.8. */
  createActionItem: ActionItem;
  createNews?: Maybe<Array<Maybe<NewsItem>>>;
  createSystemStatusReport?: Maybe<SystemStatusReport>;
  deleteActionItem: Scalars['Boolean'];
  deleteConversation: Scalars['Boolean'];
  deletePreferredLocation?: Maybe<UpdateProfileResponse>;
  deletePublishedSystemStatusReports?: Maybe<Scalars['Boolean']>;
  deleteUser?: Maybe<Scalars['Boolean']>;
  /** PWS 4.3.4. Dismissing is a timestamp, so it is idempotent and reversible. */
  dismissNotification: DismissNotificationResponse;
  exectueArchiveUser?: Maybe<Scalars['Boolean']>;
  exectueEnableOpenAICalling?: Maybe<Scalars['Boolean']>;
  exectueGetExternalPathways?: Maybe<Scalars['Boolean']>;
  exectueOnetFipsUpdate?: Maybe<Scalars['Boolean']>;
  exectueOnetOpeningsUpdate?: Maybe<Scalars['Boolean']>;
  exectueOnetUpdate?: Maybe<Scalars['Boolean']>;
  executeArchiveConversations?: Maybe<Scalars['Boolean']>;
  executeCareerGoalReminder: EmailNotificationTriggerResult;
  executeConversationContextExtraction: ContextExtractionResult;
  executeConversationNaming: ConversationNamingResult;
  executeDioInstitutionSync?: Maybe<Scalars['JSON']>;
  executeEncourageConnectWithTrustedAdvisor: EmailNotificationTriggerResult;
  executeNewPathwayNotification: EmailNotificationTriggerResult;
  executeSchoolQualityRefresh?: Maybe<Scalars['JSON']>;
  extractContextForConversation: Scalars['Boolean'];
  favoriteMilitaryOccupation?: Maybe<FavoriteMilitaryOccupationResponse>;
  favoriteOccupation?: Maybe<FavoriteOccupationResponse>;
  feedback?: Maybe<Response>;
  genAiGoalsReport?: Maybe<AiGoalsReportInsight>;
  generateReturnSessionLink?: Maybe<Scalars['String']>;
  inviteUsers?: Maybe<Scalars['Boolean']>;
  login: User;
  loginAfterReset?: Maybe<User>;
  loginByEmail: User;
  logout: LogoutResponse;
  markBugReportsViewed?: Maybe<Array<Maybe<BugReport>>>;
  nameConversation: Scalars['Boolean'];
  /**
   * INFRA.7b. Remembers which of our addresses is asking for a magic link for this
   * email, so the emailed link can open there. The address comes from the request
   * itself, never from an argument. Always returns true, whether or not anything
   * was written, so the answer says nothing about the email.
   */
  noteMagicLinkRequest: Scalars['Boolean'];
  /** Copies the draft over the published document and makes the page live. */
  publishPortfolio: Portfolio;
  rateMessage: Message;
  reactOnNews?: Maybe<NewsItem>;
  /**
   * ANALYTICS.14. Record that the learner used a capability, for usage reporting.
   *
   * Exists for the two actions that genuinely never reach the server: downloading
   * a resume, which renders in the browser, and copying a portfolio link, which
   * writes to the clipboard. Everything else we count is emitted server-side at
   * the point the action already happens, which cannot be spoofed, blocked or
   * lost when a tab closes.
   *
   * `feature` and `action` are resolved against the registry in
   * feature-event.service.ts and anything else is refused, so a browser cannot
   * append arbitrary rows to an append-only analytics table.
   *
   * The learner is taken from the authenticated session and is never accepted
   * from the caller.
   *
   * Returns true when the event was recorded and false when the pair is not one
   * we emit. It does not error, and a storage failure is not reported as one:
   * losing an analytics row must never break what the learner was doing, and the
   * caller has nothing useful to do with either answer.
   */
  recordFeatureUse?: Maybe<Scalars['Boolean']>;
  registerLoginUser: User;
  renameConversation: Scalars['Boolean'];
  /** Reorders the board. Takes the whole order, so no two items can claim a slot. */
  reorderActionItems: Array<ActionItem>;
  reportBug?: Maybe<BugReport>;
  reportDownloaded?: Maybe<UpdateProfileResponse>;
  reportShared?: Maybe<UpdateProfileResponse>;
  /**
   * Public and unauthenticated: the person asking does not have an account yet.
   *
   * Always returns true, including on a duplicate or a rate-limited submission,
   * so the response can never be used to probe whether an address is already
   * known to the platform.
   */
  requestCounselorAccess: Scalars['Boolean'];
  /**
   * CONNECT.1. Adds the given schools to the member's academic connections.
   * Add-only: never removes a connection, never touches employers, non-profits
   * or the member's Connect preferences. Used by Request Info.
   */
  requestInfoFromSchools: ConnectActionResult;
  resetPassword?: Maybe<Scalars['Boolean']>;
  /** Accept or discard a Via suggestion. Discarding keeps the row. */
  resolveActionSuggestion?: Maybe<ActionItem>;
  returnSession?: Maybe<Response>;
  revokePremiumPartnerConnection?: Maybe<UserPremiumPartnerConnection>;
  /** Turns the link off. The row is kept so a revoked link can say it was turned off. */
  revokeReportShare: Scalars['Boolean'];
  /**
   * ASVAB.5. Saves scores for the scales in the payload and leaves every other
   * scale alone, so an Army member saving line scores does not wipe the Career
   * Exploration Scores they entered from a school score sheet. A null score clears
   * that one scale. The scales are the member's own branch's plus AFQT, the same
   * set in the Skills Survey and both matches panels. Saved and shown; they do
   * not change matches.
   *
   * Added alongside saveAsvabScores rather than replacing it: see asvabScoreSet on
   * Profile for why a field on that fragment cannot change shape in one release.
   */
  saveAsvabScoreSet?: Maybe<UpdateProfileResponse>;
  /**
   * PWS 4.1.12. Saves the four legacy ASVAB line-score columns (GT, EL, MM, CL).
   * A null field clears that score. No CPD screen calls it any more: the Skills
   * Survey and the matches panels save through saveAsvabScoreSet, which covers
   * every branch's scales plus AFQT and dual-writes these columns. Scores are
   * saved and shown; they do not change matches.
   */
  saveAsvabScores?: Maybe<UpdateProfileResponse>;
  /** Records the caller's front door answer, replacing any earlier one. */
  saveFrontDoor?: Maybe<FrontDoorAnswers>;
  savePathwayPageUsage?: Maybe<Scalars['Boolean']>;
  /** PWS 4.1.19. Replaces the draft. Does not publish: see publishPortfolio. */
  savePortfolio: Portfolio;
  /** PWS 4.1.10. */
  saveResume: Resume;
  saveUserAirbaseLocation?: Maybe<UpdateProfileResponse>;
  saveUserCreds?: Maybe<User>;
  saveUserDetails?: Maybe<User>;
  saveUserInstallation?: Maybe<UpdateProfileResponse>;
  saveUserMilitaryServeType?: Maybe<UpdateProfileResponse>;
  saveUserMilitaryTermination?: Maybe<UpdateProfileResponse>;
  saveUserPreGoals?: Maybe<UpdateProfileResponse>;
  saveUserProgramGoals?: Maybe<UpdateProfileResponse>;
  saveUserSchoolGoals?: Maybe<UpdateProfileResponse>;
  saveUserSpacebaseLocation?: Maybe<UpdateProfileResponse>;
  saveUserWorkTermination?: Maybe<UpdateProfileResponse>;
  saveVideoUsage?: Maybe<VideoUsage>;
  /**
   * ANALYTICS.15. Grant or revoke DANTES reporting access for one member.
   *
   * Separate from saveUserDetails, which is the member's own details. This is an
   * access-control decision an administrator makes about somebody else, and
   * keeping them apart means "who can change this" has one answer.
   */
  setDantesStaff?: Maybe<Scalars['Boolean']>;
  setFeatureFlag?: Maybe<Scalars['Boolean']>;
  /** T.6. Turn Via on or off for the member's own published page. */
  setPortfolioViaEnabled?: Maybe<Scalars['Boolean']>;
  /** S.5. The learner's off switch for questions on their shared report. */
  setSharedReportViaEnabled: Scalars['Boolean'];
  /**
   * Issues a share link, or returns the live one.
   *
   * Idempotent on purpose: a member pressing Share twice has not asked for two
   * links, and a second link is one they would never know to revoke.
   */
  shareReport: ReportShare;
  startInterestsTracking?: Maybe<UserInterestSurveyTrackerReponse>;
  togglePublishAllSystemStatusReport?: Maybe<Array<Maybe<SystemStatusReport>>>;
  triggerAutoShareForNewOrganizations: Scalars['Boolean'];
  unfavoriteMilitaryOccupation?: Maybe<FavoriteMilitaryOccupationResponse>;
  unfavoriteOccupation?: Maybe<FavoriteOccupationResponse>;
  /** Takes the page down. Keeps what was published, so making it live again needs no republish. */
  unpublishPortfolio: Portfolio;
  updateAIDeepInsightReport?: Maybe<AiDeepInsights>;
  updateActionItem?: Maybe<ActionItem>;
  updateCompetencies?: Maybe<UpdateProfileResponse>;
  updateGoals?: Maybe<UpdateGoalsResponse>;
  updateInterests?: Maybe<UpdateProfileResponse>;
  updateLifestyle?: Maybe<UpdateProfileResponse>;
  updateMaintanceStatus?: Maybe<MaintanceStatusReponse>;
  updateProfileWorkType?: Maybe<UpdateProfileResponse>;
  updateReclassifying?: Maybe<UserReclassifyingResponse>;
  updateSkills?: Maybe<UpdateProfileResponse>;
  updateValues?: Maybe<UpdateProfileResponse>;
  verifyEmail?: Maybe<Scalars['Boolean']>;
};


export type MutationAcceptPrivacyPolicyArgs = {
  values?: InputMaybe<Scalars['Boolean']>;
};


export type MutationAddPreferredLocationArgs = {
  location: CpdLocationInput;
};


export type MutationAskPortfolioViaArgs = {
  question: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
  slug: Scalars['ID'];
};


export type MutationAskSharedReportViaArgs = {
  history?: InputMaybe<Array<SharedReportViaTurnInput>>;
  question: Scalars['String'];
  token: Scalars['ID'];
};

export type MutationSubmitSharedReportFeedbackArgs = {
  comment?: InputMaybe<Scalars['String']>;
  rating: Scalars['Int'];
  token: Scalars['ID'];
};


export type MutationConnectWithOrganizationsArgs = {
  academicIds?: InputMaybe<Array<Scalars['ID']>>;
  autoShareEnabled?: InputMaybe<Scalars['Boolean']>;
  confirmAdult?: InputMaybe<Scalars['Boolean']>;
  employerIds?: InputMaybe<Array<Scalars['ID']>>;
  nonprofitIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationConnectWithPremiumPartnerArgs = {
  input: PremiumPartnerConnectionInput;
};


export type MutationCreateActionItemArgs = {
  input: ActionItemInput;
};


export type MutationCreateNewsArgs = {
  news?: InputMaybe<Array<InputMaybe<NewsItemInput>>>;
};


export type MutationCreateSystemStatusReportArgs = {
  input?: InputMaybe<SystemStatusReportInput>;
};


export type MutationDeleteActionItemArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteConversationArgs = {
  conversationId: Scalars['Int'];
};


export type MutationDeletePreferredLocationArgs = {
  location: CpdLocationInput;
};


export type MutationDeletePublishedSystemStatusReportsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationDeleteUserArgs = {
  userId: Scalars['Int'];
};


export type MutationDismissNotificationArgs = {
  id: Scalars['ID'];
};


export type MutationExtractContextForConversationArgs = {
  conversationId: Scalars['Int'];
};


export type MutationFavoriteMilitaryOccupationArgs = {
  mocCode: Scalars['String'];
  mocTitle: Scalars['String'];
};


export type MutationFavoriteOccupationArgs = {
  jobId?: InputMaybe<Scalars['Int']>;
  onetCode: Scalars['ID'];
};


export type MutationFeedbackArgs = {
  feedback?: InputMaybe<FeedbackInput>;
};


export type MutationGenAiGoalsReportArgs = {
  forceUpdate?: InputMaybe<Scalars['Boolean']>;
  surveyData: AiGoalsReportInput;
};


export type MutationInviteUsersArgs = {
  emails: Array<InputMaybe<Scalars['String']>>;
  role: Scalars['String'];
};


export type MutationLoginArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


export type MutationLoginAfterResetArgs = {
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationLoginByEmailArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationMarkBugReportsViewedArgs = {
  input?: InputMaybe<BugReportViewedInput>;
};


export type MutationNameConversationArgs = {
  conversationId: Scalars['Int'];
};


export type MutationNoteMagicLinkRequestArgs = {
  email: Scalars['String'];
};


export type MutationRateMessageArgs = {
  disliked?: InputMaybe<Scalars['Boolean']>;
  liked?: InputMaybe<Scalars['Boolean']>;
  messageId: Scalars['Int'];
};


export type MutationReactOnNewsArgs = {
  input?: InputMaybe<NewsReactionInput>;
};


export type MutationRecordFeatureUseArgs = {
  action: Scalars['String'];
  feature: Scalars['String'];
};


export type MutationRegisterLoginUserArgs = {
  email?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  username: Scalars['String'];
};


export type MutationRenameConversationArgs = {
  conversationId: Scalars['Int'];
  newTitle: Scalars['String'];
};


export type MutationReorderActionItemsArgs = {
  ids: Array<Scalars['ID']>;
};


export type MutationReportBugArgs = {
  input?: InputMaybe<BugReportInput>;
};


export type MutationRequestCounselorAccessArgs = {
  input: AccessRequestInput;
};


export type MutationRequestInfoFromSchoolsArgs = {
  academicIds: Array<Scalars['ID']>;
  confirmAdult?: InputMaybe<Scalars['Boolean']>;
};


export type MutationResetPasswordArgs = {
  email: Scalars['String'];
};


export type MutationResolveActionSuggestionArgs = {
  accept: Scalars['Boolean'];
  id: Scalars['ID'];
};


export type MutationReturnSessionArgs = {
  mailTo: Scalars['String'];
};


export type MutationRevokePremiumPartnerConnectionArgs = {
  premiumPartnerId: Scalars['ID'];
};


export type MutationSaveAsvabScoreSetArgs = {
  scores: Array<AsvabScoreInput>;
};


export type MutationSaveAsvabScoresArgs = {
  scores: AsvabScoresInput;
};


export type MutationSaveFrontDoorArgs = {
  input: FrontDoorInput;
};


export type MutationSavePathwayPageUsageArgs = {
  input?: InputMaybe<PathwayPageUsageInput>;
};


export type MutationSavePortfolioArgs = {
  draft: Scalars['JSON'];
};


export type MutationSaveResumeArgs = {
  document: Scalars['JSON'];
  resumeId?: InputMaybe<Scalars['ID']>;
  theme?: InputMaybe<Scalars['String']>;
};


export type MutationSaveUserAirbaseLocationArgs = {
  airbaseLocationId: Scalars['ID'];
};


export type MutationSaveUserCredsArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
};


export type MutationSaveUserDetailsArgs = {
  firstName: Scalars['String'];
  id: Scalars['Int'];
  lastName: Scalars['String'];
  status?: InputMaybe<UserActionEnum>;
};


export type MutationSaveUserInstallationArgs = {
  installationId: Scalars['ID'];
};


export type MutationSaveUserMilitaryServeTypeArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type MutationSaveUserMilitaryTerminationArgs = {
  values?: InputMaybe<UserTerminationInput>;
};


export type MutationSaveUserPreGoalsArgs = {
  values: UserPreGoalInput;
};


export type MutationSaveUserProgramGoalsArgs = {
  values: UserProgramGoalInput;
};


export type MutationSaveUserSchoolGoalsArgs = {
  values: UserSchoolGoalInput;
};


export type MutationSaveUserSpacebaseLocationArgs = {
  spacebaseLocationId: Scalars['ID'];
};


export type MutationSaveUserWorkTerminationArgs = {
  values?: InputMaybe<UserTerminationInput>;
};


export type MutationSaveVideoUsageArgs = {
  videoUsageInput?: InputMaybe<VideoUsageInput>;
};


export type MutationSetDantesStaffArgs = {
  id: Scalars['Int'];
  isDantesStaff: Scalars['Boolean'];
};


export type MutationSetFeatureFlagArgs = {
  featureFlag: EnableFeatureFlagsInput;
};


export type MutationSetPortfolioViaEnabledArgs = {
  enabled: Scalars['Boolean'];
};


export type MutationSetSharedReportViaEnabledArgs = {
  enabled: Scalars['Boolean'];
};


export type MutationTogglePublishAllSystemStatusReportArgs = {
  input?: InputMaybe<TogglePublishAllSystemStatusReportInput>;
};


export type MutationTriggerAutoShareForNewOrganizationsArgs = {
  academicIds?: InputMaybe<Array<Scalars['ID']>>;
  employerIds?: InputMaybe<Array<Scalars['ID']>>;
  nonprofitIds?: InputMaybe<Array<Scalars['ID']>>;
};


export type MutationUnfavoriteMilitaryOccupationArgs = {
  mocCode: Scalars['String'];
  mocTitle: Scalars['String'];
};


export type MutationUnfavoriteOccupationArgs = {
  jobId?: InputMaybe<Scalars['Int']>;
  onetCode: Scalars['ID'];
};


export type MutationUpdateAiDeepInsightReportArgs = {
  conversationId: Scalars['Int'];
  messageId?: InputMaybe<Scalars['Int']>;
};


export type MutationUpdateActionItemArgs = {
  id: Scalars['ID'];
  input: ActionItemInput;
};


export type MutationUpdateCompetenciesArgs = {
  jobCompetencies: Array<JobCompetencyInput>;
};


export type MutationUpdateGoalsArgs = {
  goals: GoalsInput;
};


export type MutationUpdateInterestsArgs = {
  interests: Array<InterestInput>;
  trackerId?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateLifestyleArgs = {
  lifestyle: LifestyleInput;
};


export type MutationUpdateMaintanceStatusArgs = {
  input?: InputMaybe<MaintanceStatusInput>;
};


export type MutationUpdateProfileWorkTypeArgs = {
  values?: InputMaybe<ProfileWorkTypeInput>;
};


export type MutationUpdateReclassifyingArgs = {
  stayincurrent?: InputMaybe<Scalars['Boolean']>;
  transitionfrommilitary?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateSkillsArgs = {
  skills: SkillsInput;
};


export type MutationUpdateValuesArgs = {
  values: Array<ValuesInput>;
};


export type MutationVerifyEmailArgs = {
  email: Scalars['String'];
};

export type NarrativePhrase = {
  __typename?: 'NarrativePhrase';
  content: Scalars['String'];
  identifier?: Maybe<Scalars['String']>;
  insights?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type Narratives = {
  __typename?: 'Narratives';
  academicGoal?: Maybe<Array<NarrativePhrase>>;
  careerGoal?: Maybe<Array<NarrativePhrase>>;
  compatibility?: Maybe<Array<NarrativePhrase>>;
  constraints?: Maybe<Array<NarrativePhrase>>;
  currentStage?: Maybe<Array<NarrativePhrase>>;
  decisionProcess?: Maybe<Array<NarrativePhrase>>;
  experience?: Maybe<Array<NarrativePhrase>>;
  funding?: Maybe<Array<NarrativePhrase>>;
  interests?: Maybe<Array<NarrativePhrase>>;
  lifestylePreferences?: Maybe<Array<NarrativePhrase>>;
  location?: Maybe<Array<NarrativePhrase>>;
  motivations?: Maybe<Array<NarrativePhrase>>;
  supports?: Maybe<Array<NarrativePhrase>>;
  values?: Maybe<Array<NarrativePhrase>>;
};

export type NewsItem = {
  __typename?: 'NewsItem';
  createdAt?: Maybe<Scalars['Date']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  reaction?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type NewsItemInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type NewsReactionInput = {
  newsId: Scalars['Int'];
  type: ReactionEnum;
};

export type NewsTypesItem = {
  __typename?: 'NewsTypesItem';
  id?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type Notification = {
  __typename?: 'Notification';
  body?: Maybe<Scalars['String']>;
  createdAt: Scalars['Date'];
  /**
   * Label and path are both present or both absent. A label with no path renders a
   * button that goes nowhere, which is worse than a row with no button at all.
   */
  destinationLabel?: Maybe<Scalars['String']>;
  /**
   * An application path, never an absolute URL: a stored URL pins the row to the
   * environment that wrote it, and these rows outlive deploys.
   */
  destinationPath?: Maybe<Scalars['String']>;
  dismissedAt?: Maybe<Scalars['Date']>;
  id: Scalars['ID'];
  kind: NotificationKind;
  title: Scalars['String'];
};

/**
 * PWS 4.3.4. The shell's notification drawer, on every authenticated surface.
 *
 * The four kinds are the design's row types and they are VISUAL ONLY: a kind
 * picks an icon and a grouping heading. Where a row goes is `destinationPath`,
 * which is per-row data, so the drawer never has to know what a reply or a school
 * response means.
 */
export enum NotificationKind {
  /** A school or organization responding. */
  Action = 'ACTION',
  /** A counselor answering. */
  Reply = 'REPLY',
  /** Something completing. */
  Result = 'RESULT',
  /** A standing agent between visits. */
  Signal = 'SIGNAL'
}

export type OccupationCard = {
  __typename?: 'OccupationCard';
  growthRateBand?: Maybe<Scalars['String']>;
  imageName?: Maybe<Scalars['String']>;
  industry?: Maybe<Scalars['String']>;
  /** PWS 4.1.12. The industry filter on the match list reads this. */
  industryCode?: Maybe<Scalars['Int']>;
  interestsMatchQualityId?: Maybe<Scalars['Int']>;
  isFavorite?: Maybe<Scalars['Boolean']>;
  jobId?: Maybe<Scalars['Int']>;
  lifestyleMatchQualityId?: Maybe<Scalars['Int']>;
  medianAnnualWage?: Maybe<Scalars['Float']>;
  medianHourlyWage?: Maybe<Scalars['Float']>;
  occupationCardCategoryType?: Maybe<OccupationCardCategoryType>;
  onetCode: Scalars['ID'];
  onetSocCode?: Maybe<Scalars['String']>;
  skillsMatchQualityId?: Maybe<Scalars['Int']>;
  skillsMatchQualityIdAi?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  typicalEducationLevelGroup?: Maybe<Scalars['String']>;
  userId: Scalars['Int'];
  valuesMatchQualityId?: Maybe<Scalars['Int']>;
  /**
   * The state `medianAnnualWage` is the median for, or null when it is the
   * national figure.
   *
   * 02-home section 5: pay is the median for the chosen state, and a national
   * median must not be shown beside a state filter. Not every occupation has a
   * row for every state, so a card can come back national even when a state was
   * asked for; this field is how the card says so rather than passing the
   * national figure off as the state's.
   */
  wageState?: Maybe<Scalars['String']>;
};

export enum OccupationCardCategoryType {
  AiEducation = 'AI_EDUCATION',
  AiFastestPath = 'AI_FASTEST_PATH',
  BestMatch = 'BEST_MATCH',
  CareerGoals = 'CAREER_GOALS',
  Certifications = 'CERTIFICATIONS',
  Competencies = 'COMPETENCIES',
  Education = 'EDUCATION',
  Experience = 'EXPERIENCE',
  HighGrowth = 'HIGH_GROWTH',
  HotLocations = 'HOT_LOCATIONS',
  Interests = 'INTERESTS',
  Lifestyle = 'LIFESTYLE',
  Unknown = 'UNKNOWN',
  Values = 'VALUES'
}

/**
 * One O*NET descriptor for an occupation: a skill, a knowledge area, an ability
 * or a work activity. Deliberately NOT a technology or software product, which
 * is the defect this type was added to fix.
 */
export type OccupationKsa = {
  __typename?: 'OccupationKsa';
  description?: Maybe<Scalars['String']>;
  /**
   * OCC.4. Which display tier governs this element: aptitude, baseline,
   * contextual or developmental.
   *
   * Present so a surface can say why a row is not in the gap column rather than
   * guessing from the status. Null when no match was run, and null when the
   * baseline floor flag is off.
   */
  displayTier?: Maybe<Scalars['String']>;
  /**
   * The O*NET element id, for example 2.A.2.b for Active Learning. Stable within
   * an O*NET release, so it is safe to use as the key for a learner's selections.
   */
  id: Scalars['String'];
  /** O*NET importance, 1.0 to 5.0. The list is ordered by this, descending. */
  importance?: Maybe<Scalars['Float']>;
  /** O*NET level, 0.0 to 7.0. */
  level?: Maybe<Scalars['Float']>;
  /**
   * Where the claim comes from, each with the NAME of the record behind it.
   *
   * Empty unless matchStatus is MET or NAMED. MILITARY and WORK can only ever
   * appear on MET, and EDUCATION, CREDENTIAL and TRAINING only on NAMED, because
   * an attested anchor carries no level. On MET these are the anchors that
   * reached the best level, not everything the learner holds.
   */
  matchSources?: Maybe<Array<KsaMatchSource>>;
  /**
   * OCC.3. How the learner's own record rates this element.
   *
   * NULL MEANS NO MATCH WAS RUN, and it is a common, correct answer: a logged-out
   * visitor, a learner with no resolvable held evidence, or an environment where
   * the SkillsDNA loader has not run. Null is never a gap, and a client must draw
   * no mark at all for it rather than an empty circle.
   */
  matchStatus?: Maybe<KsaMatchStatus>;
  name: Scalars['String'];
  /** One of: skill, knowledge, ability, work_activity */
  type: Scalars['String'];
};

export enum OccupationType {
  ByCounty = 'BY_COUNTY',
  ByDegree = 'BY_DEGREE',
  HighGrowth = 'HIGH_GROWTH',
  MilitaryFriendly = 'MILITARY_FRIENDLY'
}

export enum OccupationsByCategorySortEnum {
  Educationlevelasc = 'EDUCATIONLEVELASC',
  Educationleveldesc = 'EDUCATIONLEVELDESC',
  Experiencelevelasc = 'EXPERIENCELEVELASC',
  Experienceleveldesc = 'EXPERIENCELEVELDESC',
  Mostaligned = 'MOSTALIGNED',
  Projectedgrowthasc = 'PROJECTEDGROWTHASC',
  Projectedgrowthdesc = 'PROJECTEDGROWTHDESC',
  Salaryasc = 'SALARYASC',
  Salarydesc = 'SALARYDESC'
}

export enum OrganizationType {
  Academic = 'ACADEMIC',
  Employer = 'EMPLOYER',
  Nonprofit = 'NONPROFIT'
}

export type Pathway = {
  __typename?: 'Pathway';
  descr?: Maybe<Scalars['String']>;
  devPublish?: Maybe<Scalars['Boolean']>;
  growthRate?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  jobEducationOptions?: Maybe<JobEducationOptions>;
  jobs?: Maybe<Array<Maybe<PathwayJob>>>;
  name?: Maybe<Scalars['String']>;
  occupationCount?: Maybe<Scalars['Int']>;
  pathwayId: Scalars['ID'];
  prodPublish?: Maybe<Scalars['Boolean']>;
  stepConnections?: Maybe<Array<Maybe<PathwayConnection>>>;
};

export type PathwayCard = {
  __typename?: 'PathwayCard';
  devPublish?: Maybe<Scalars['Boolean']>;
  imageUrl?: Maybe<Scalars['String']>;
  interestsmatch?: Maybe<Scalars['Float']>;
  lifestylematch?: Maybe<Scalars['Float']>;
  maxSalary?: Maybe<Scalars['Float']>;
  medianSalary?: Maybe<Scalars['Float']>;
  minSalary?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  occupationCount?: Maybe<Scalars['Int']>;
  pathwayId: Scalars['ID'];
  prodPublish?: Maybe<Scalars['Boolean']>;
  skillsmatch?: Maybe<Scalars['Float']>;
  sponsorshipCompany?: Maybe<SponsorshipCompany>;
  valuesmatch?: Maybe<Scalars['Float']>;
};

export type PathwayConnection = {
  __typename?: 'PathwayConnection';
  fromJobId: Scalars['ID'];
  toJobId: Scalars['ID'];
};

export type PathwayJob = {
  __typename?: 'PathwayJob';
  descr?: Maybe<Scalars['String']>;
  edMatch?: Maybe<Scalars['Int']>;
  educationLevels?: Maybe<Array<Maybe<JobEducation>>>;
  growthRate?: Maybe<Scalars['Int']>;
  growthRateBand?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  imageName?: Maybe<Scalars['String']>;
  interestsMatch?: Maybe<Scalars['Int']>;
  interestsMatchQualityId?: Maybe<Scalars['Int']>;
  isMatch?: Maybe<Scalars['Boolean']>;
  jobCipCodes?: Maybe<Array<Maybe<CipCode>>>;
  jobToEducationXrefs?: Maybe<Array<Maybe<JobEducationXRef>>>;
  jobToOccupationCoefficient?: Maybe<Scalars['Float']>;
  lifestyleMatch?: Maybe<Scalars['Int']>;
  lifestyleMatchQualityId?: Maybe<Scalars['Int']>;
  occupationTitle?: Maybe<Scalars['String']>;
  parentOnetCode: Scalars['ID'];
  requiredWorkExperience?: Maybe<Scalars['Int']>;
  salary?: Maybe<Scalars['Float']>;
  score?: Maybe<Scalars['Int']>;
  skillsMatch?: Maybe<Scalars['Int']>;
  skillsMatchQualityId?: Maybe<Scalars['Int']>;
  step?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  valuesMatch?: Maybe<Scalars['Int']>;
  valuesMatchQualityId?: Maybe<Scalars['Int']>;
};

export type PathwayLevel = {
  __typename?: 'PathwayLevel';
  occupations?: Maybe<Array<Maybe<CpbCustomOccupation>>>;
  ordinal?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export enum PathwayPageUsageCategoryEnum {
  AboutSponsorVariant = 'AboutSponsorVariant',
  ExternalTrainingLink = 'EXTERNAL_TRAINING_LINK',
  Link = 'LINK',
  PathwaySponsorVariant = 'PathwaySponsorVariant',
  Tab = 'TAB'
}

export type PathwayPageUsageInput = {
  category: PathwayPageUsageCategoryEnum;
  pathwayid: Scalars['ID'];
};

export type PathwaySummary = {
  __typename?: 'PathwaySummary';
  descr?: Maybe<Scalars['String']>;
  devPublish?: Maybe<Scalars['Boolean']>;
  growthRate?: Maybe<Scalars['Int']>;
  image?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  occupationCount?: Maybe<Scalars['Int']>;
  pathwayId: Scalars['ID'];
  prodPublish?: Maybe<Scalars['Boolean']>;
};

/**
 * A headline figure measured against the period before it.
 *
 * Null wherever there is no earlier period of the same shape, which is the honest
 * answer for the first quarter of the contract: the card then shows the number on
 * its own rather than inventing a baseline.
 */
export type PeriodDelta = {
  __typename?: 'PeriodDelta';
  /**
   * Percentage change. Null when the prior figure was zero -- growth from nothing
   * is not a percentage and must never be rendered as one.
   */
  changePct?: Maybe<Scalars['Float']>;
  /** What the comparison is against, e.g. 'Q3 FY26' or 'start of Q4 FY26'. */
  label: Scalars['String'];
  /**
   * True when the current period is still running and the prior window was
   * therefore clipped to the same elapsed length. A like-for-like comparison and
   * a whole-period comparison are different claims; the card says which it is.
   */
  partial: Scalars['Boolean'];
  /** The prior period's figure. Carried so a percentage on a filing is auditable. */
  priorValue: Scalars['Int'];
};

/**
 * PWS 4.1.19. The member's secure electronic portfolio, and the source of the
 * public page at /p/:slug.
 *
 * `draft` and `published` are two documents, not one document and a flag. That is
 * what lets the builder say WHICH sections are unpublished rather than only that
 * something is, and it means publishing is the one thing that marks anything
 * published.
 */
export type Portfolio = {
  __typename?: 'Portfolio';
  /** What the member is editing. */
  draft: Scalars['JSON'];
  isLive: Scalars['Boolean'];
  /** What a visitor sees as of the last publish. Null before the first one. */
  published?: Maybe<Scalars['JSON']>;
  publishedAt?: Maybe<Scalars['Date']>;
  /** Issued on first save and never reissued: a link already given out must keep resolving. */
  slug: Scalars['ID'];
  /**
   * Section keys whose draft differs from what was last published.
   *
   * Empty when there is nothing to publish. Every key when nothing has been
   * published yet, because from a visitor's point of view none of it is on the
   * page.
   */
  unpublishedSections: Array<Scalars['String']>;
};

/**
 * T.6. What a visitor gets back when they ask Via about a published portfolio.
 *
 * The outcome rides with the answer rather than being inferred from a null,
 * because "the page cannot answer that", "the owner turned this off" and "the
 * owner's month is spent" are three different things and the page says something
 * different for each. A single nullable string would collapse them into one
 * shrug.
 */
export type PortfolioViaAnswer = {
  __typename?: 'PortfolioViaAnswer';
  /** The answer, or null when there is none to give. */
  answer?: Maybe<Scalars['String']>;
  /**
   * answered  - generated just now, and one of the owner's thirty was spent
   * cached    - the same question was answered before, and cost nothing
   * exhausted - the owner's month is spent; the page falls back
   * disabled  - the owner turned Via off on their page
   * unavailable - unknown slug, empty question, or the answer could not be made
   */
  outcome: Scalars['String'];
  /** What is left of the owner's month. Null when it does not apply. */
  remaining?: Maybe<Scalars['Int']>;
};

/** T.6. The owner's own view of their page's allowance. */
export type PortfolioViaUsage = {
  __typename?: 'PortfolioViaUsage';
  /** False when the owner has turned Via off on their page. */
  enabled: Scalars['Boolean'];
  limit: Scalars['Int'];
  remaining: Scalars['Int'];
  used: Scalars['Int'];
};

export type PostResponseExtractionResponse = {
  __typename?: 'PostResponseExtractionResponse';
  conversationGoals?: Maybe<ConversationGoals>;
  learningSuggestions?: Maybe<LearningSuggestions>;
};

export type PremiumPartner = {
  __typename?: 'PremiumPartner';
  additionalFieldsSchema: Scalars['JSON'];
  description: Scalars['String'];
  disclosureText: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  logoUrl?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  website?: Maybe<Scalars['String']>;
};

export type PremiumPartnerConnectionInput = {
  additionalData: Scalars['JSON'];
  /** CONNECT.1: the member ticked I'm 18 or older on this share. */
  confirmAdult?: InputMaybe<Scalars['Boolean']>;
  premiumPartnerId: Scalars['ID'];
};

export type PriorLearningItemRow = {
  __typename?: 'PriorLearningItemRow';
  aceIdentifier?: Maybe<Scalars['String']>;
  branch?: Maybe<Scalars['String']>;
  creditRange?: Maybe<Scalars['String']>;
  itemCode?: Maybe<Scalars['String']>;
  learners: Scalars['Int'];
  occurrences: Scalars['Int'];
  sharePct?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
};

export type PriorLearningReport = {
  __typename?: 'PriorLearningReport';
  aceUploads: Scalars['Int'];
  byBranch: Array<AnalyticsNamedValue>;
  byInstallation: Array<AnalyticsLocationRow>;
  coursesDelta?: Maybe<PeriodDelta>;
  coursesRecognized: Scalars['Int'];
  distinctCourseIdentifiers: Scalars['Int'];
  distinctOccupationCodes: Scalars['Int'];
  jstUploads: Scalars['Int'];
  learners: Scalars['Int'];
  learnersDelta?: Maybe<PeriodDelta>;
  occupationsDelta?: Maybe<PeriodDelta>;
  occupationsParsed: Scalars['Int'];
  topCourseIdentifiers: Array<PriorLearningItemRow>;
  topOccupationCodes: Array<PriorLearningItemRow>;
  topOccupationIdentifiers: Array<PriorLearningItemRow>;
  uploadSeries: Array<AnalyticsTimePoint>;
  uploads: Scalars['Int'];
  /** Quarter-to-date activity against the same slice of the previous quarter, as on Via Usage. */
  uploadsDelta?: Maybe<PeriodDelta>;
};

export type Profile = {
  __typename?: 'Profile';
  /**
   * ASVAB.5. Every score the member has, whichever service or score sheet it came
   * from, as scale/score pairs.
   *
   * ADDED ALONGSIDE asvabScores RATHER THAN REPLACING IT, and that is not
   * tidiness. Both fields sit in a fragment embedded in eighteen operations
   * including GetSession, RefreshSession and login, so a gateway that does not
   * know a field fails the session bootstrap and routes every member to
   * /error/403. That is an outage, not a missing feature. Replacing the field
   * would make the subgraph and the client undeployable in either order; adding
   * one keeps both directions safe. asvabScores retires in a later release, once
   * this one has been live and every client reads it.
   *
   * The four services beyond Army and the Marine Corps classify on scales that do
   * not fit gt/el/mm/cl at all: Air Force and Space Force on MAGE, Navy and Coast
   * Guard on raw subtests. Those members' scores can only appear here, as can the
   * AFQT percentile (1 to 99) that every branch is asked for.
   *
   * Saved and shown back to the member (Skills Survey, matches panels, Goals
   * Report, Via). They do not change matches: nothing ranks or filters on them.
   *
   * Never shared with organizations under the connect opt-in, and suppressed on a
   * shared Goals Report. The design tells the member "Only you see these."
   */
  asvabScoreSet?: Maybe<Array<AsvabScore>>;
  /**
   * PWS 4.1.12. The four legacy ASVAB line-score columns (GT, EL, MM, CL), each
   * nullable and independent. Kept, and dual-written by saveAsvabScoreSet, so the
   * fragments that read them keep working; asvabScoreSet is the full,
   * branch-aware set, AFQT included. Scores are saved and shown back to the
   * member. They do not change matches: nothing ranks or filters on them.
   *
   * These are never shared with organizations under the connect opt-in. The
   * design tells the member "Only you see these."
   */
  asvabScores?: Maybe<AsvabScores>;
  cognitoUserId?: Maybe<Scalars['String']>;
  experienceAnalysis?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  hasCivilianWorkExperience?: Maybe<Scalars['Boolean']>;
  hasReturnUrl?: Maybe<Scalars['Boolean']>;
  interestsAnalysis?: Maybe<Scalars['String']>;
  /**
   * ANALYTICS.15. May this counselor or administrator see DANTES contract
   * reporting: the Quarterly Report, Program Adoption, Via Usage, Prior Learning,
   * and the DANTES vocabulary in Ask the Data.
   *
   * Orthogonal to userRole, deliberately. A fifth role would have to be taught to
   * every route guard, resolver allowlist and redirect that branches on role, and
   * any it was not taught would treat a DANTES administrator as something less
   * than an administrator.
   *
   * Null for a learner profile, which is the same as false here: only counselors
   * and administrators can reach those pages at all.
   */
  isDantesStaff?: Maybe<Scalars['Boolean']>;
  isInterestsSurveyComplete?: Maybe<Scalars['Boolean']>;
  isJstUploaded?: Maybe<Scalars['Boolean']>;
  isLifestyleSurveyComplete?: Maybe<Scalars['Boolean']>;
  isSkillsSurveyComplete?: Maybe<Scalars['Boolean']>;
  isWorkValuesSurveyComplete?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  militaryBranch?: Maybe<MilitaryBranch>;
  privacyPolicyAccepted?: Maybe<Scalars['Boolean']>;
  profileType?: Maybe<Scalars['String']>;
  profileWorkType?: Maybe<ProfileWorkType>;
  reportDownloaded?: Maybe<Scalars['Boolean']>;
  reportShared?: Maybe<Scalars['Boolean']>;
  returnUrlLastSavedDate?: Maybe<Scalars['Date']>;
  serveTypeId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  userAirbaseLocation?: Maybe<AirbaseLocation>;
  userAspirations?: Maybe<UserAspiration>;
  userAspirationsPreference?: Maybe<Array<Maybe<Scalars['String']>>>;
  userCompetencies?: Maybe<UserCompetencies>;
  userCurrentLocations?: Maybe<Array<Maybe<CpdLocation>>>;
  userEducations?: Maybe<Array<Maybe<Education>>>;
  userEmail?: Maybe<Scalars['String']>;
  userHasPreGoal?: Maybe<Scalars['Boolean']>;
  userId: Scalars['Int'];
  userInstallation?: Maybe<InstallationLocation>;
  userInterests?: Maybe<Array<Maybe<UserInterest>>>;
  userMilitaryTermination?: Maybe<Scalars['Int']>;
  userMocs?: Maybe<Array<Maybe<Moc>>>;
  userName?: Maybe<Scalars['String']>;
  userPreGoalOccupation?: Maybe<Scalars['String']>;
  /**
   * The career pre-goal's O*NET code, beside the title userPreGoalOccupation
   * already returns.
   *
   * The code has been stored on api.userpregoals.onetcode since the table
   * shipped, and saveUserPreGoals writes it. It was simply never on the read
   * contract, so a client got a title and no identity. The skills survey needs
   * the identity: its work list is a list of removable rows keyed on the O*NET
   * code, and without the code the survey can only render the saved answer as a
   * read-only chip the member cannot take back out.
   *
   * A SEPARATE FIELD RATHER THAN A SUBFIELD OF userPreGoalOccupation, which is
   * not a preference. userPreGoalOccupation is a String, a leaf. Promoting it to
   * an object type to hang onetCode inside would invalidate every query already
   * selecting it as a leaf, and this profile selection is embedded in
   * GetSession: the deployed client's session bootstrap would stop composing and
   * every member would land on /error/403. A sibling scalar is what the shape
   * allows, and userHasPreGoal beside it is the existing precedent for pre-goal
   * facts as siblings on Profile.
   */
  userPreGoalOnetCode?: Maybe<Scalars['String']>;
  userPreferredLocations: Array<CpdLocation>;
  userProgramGoal?: Maybe<CipCodeForGoal>;
  /**
   * How far the member said they want to go, as an api.educationlevel id.
   *
   * The third fact of the schooling pre-goal, next to userProgramGoal (in what)
   * and userSchoolGoal (where). It had no column until
   * 20260910190000_userprogramgoals_pregoal_edlevel added
   * api.userprogramgoals.edlevelid, so the level the survey collected was
   * discarded on save and there was nothing to restore on a Back visit.
   *
   * NOT the same answer as GoalsInput.schoolProgramEdLevelId. That one is the
   * level of the academic goal the member sets after seeing their matches, it
   * lives on api.usergoals, and its write replaces that whole row. This is a
   * pre-goal, kept so the two can be compared later, and it is why the level
   * needed its own column instead of being pushed through the existing field.
   *
   * A sibling scalar rather than a field on CipCodeForGoal because it is a
   * separate answer: a member can say "a Bachelor's, I do not know in what",
   * which is exactly the case that was being dropped, and a CIP code's type is
   * not where that belongs.
   */
  userProgramGoalEdLevelId?: Maybe<Scalars['Int']>;
  userRanks?: Maybe<Array<Maybe<Rank>>>;
  userRole?: Maybe<Scalars['String']>;
  userSchoolGoal?: Maybe<School>;
  userSpacebaseLocation?: Maybe<SpacebaseLocation>;
  userWorkExperiences?: Maybe<Array<Maybe<WorkExperience>>>;
  userWorkTermination?: Maybe<Scalars['Int']>;
  userWorkValues?: Maybe<Array<Maybe<UserWorkValue>>>;
  workValueAnalysis?: Maybe<Scalars['String']>;
};

export type ProfileWorkType = {
  __typename?: 'ProfileWorkType';
  servicepolicyaccepted?: Maybe<Scalars['Boolean']>;
  type?: Maybe<ProfileWorkTypeEnum>;
};

export enum ProfileWorkTypeEnum {
  FederalEmployeeOrServicemember = 'FEDERAL_EMPLOYEE_OR_SERVICEMEMBER',
  StudentOrEarlyCareerExplorer = 'STUDENT_OR_EARLY_CAREER_EXPLORER',
  WorkingAdultOrCareerChanger = 'WORKING_ADULT_OR_CAREER_CHANGER'
}

export type ProfileWorkTypeInput = {
  servicepolicyaccepted?: InputMaybe<Scalars['Boolean']>;
  type: ProfileWorkTypeEnum;
};

export type ProgramCourse = {
  __typename?: 'ProgramCourse';
  careerConnection: Scalars['String'];
  description: Scalars['String'];
  relevanceScore: Scalars['Float'];
  skillsGained: Array<Scalars['String']>;
  source_type: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
  url: Scalars['String'];
};

export type ProgramCoursesResponse = {
  __typename?: 'ProgramCoursesResponse';
  narrative: Scalars['String'];
  nextSteps: Array<Scalars['String']>;
  programSummary: Scalars['String'];
  topCourses: Array<ProgramCourse>;
};

/**
 * An installation, for the type-ahead on the PUBLIC access-request form.
 *
 * Deliberately minimal. The authenticated installationLocations query returns
 * branch code, component flags and active status; none of that is needed to pick
 * a duty station off a list, and this endpoint is reachable without a login, so
 * it returns only what the control renders.
 */
export type PublicInstallation = {
  __typename?: 'PublicInstallation';
  id: Scalars['ID'];
  name: Scalars['String'];
  state?: Maybe<Scalars['String']>;
};

/**
 * The portfolio as an unauthenticated visitor sees it: the published document
 * only, and only while the page is live.
 *
 * There is no draft here and no member id. A visitor who guesses a slug must not
 * be able to read anything the member has not published.
 */
export type PublicPortfolio = {
  __typename?: 'PublicPortfolio';
  published: Scalars['JSON'];
  publishedAt?: Maybe<Scalars['Date']>;
  slug: Scalars['ID'];
  /** WALK-56. The month's allowance the count is out of. Null with the count. */
  viaQuestionsLimit?: Maybe<Scalars['Int']>;
  /**
   * WALK-56. How many NEW questions Via can still answer on this page this
   * month. Null when Via is off on the page, or the count could not be read.
   */
  viaQuestionsLeft?: Maybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  accessRequestReport: AccessRequestReport;
  /**
   * PWS 4.1.8. The member's action board.
   *
   * Accepted items only by default. Pending Via suggestions come back separately
   * through pendingActionSuggestions, because a suggestion is not part of the plan
   * until it is accepted and mixing the two would be the silent merge the spec
   * forbids.
   */
  actionItems: Array<ActionItem>;
  airbaseLocations: Array<Maybe<AirbaseLocation>>;
  analyticsAsk: AnalyticsNlqResult;
  analyticsCareerEducation: AnalyticsCareerEducation;
  analyticsCareerEducationOptions: AnalyticsCareerEducationOptions;
  analyticsDetail?: Maybe<AnalyticsDetail>;
  analyticsFilterOptions: AnalyticsFilterOptions;
  analyticsInsights: AnalyticsInsights;
  analyticsInsightsExploration: AnalyticsInsightsExploration;
  analyticsMeta: AnalyticsMeta;
  /** Type-ahead source for the Mil Occupation filter */
  analyticsMocSearch: Array<AnalyticsMocOption>;
  analyticsPivot: AnalyticsPivot;
  /** grain: day | month | quarter | year */
  analyticsTrafficOverview: AnalyticsTrafficOverview;
  analyticsUserData: AnalyticsUserData;
  authenticateSession?: Maybe<Scalars['String']>;
  cognitoCallback: CognitoBindingResult;
  competencies?: Maybe<UserCompetencies>;
  competenciesByName: Array<Skill>;
  completionReport: CompletionReport;
  /**
   * One credential from the Credential Engine Registry by CTID.
   *
   * Needs no Credential Engine API key: Get Record is unauthenticated. Cached for
   * 24 hours, which matches the Registry's data currency policy.
   *
   * Returns a result object rather than nullable Credential so the caller can tell
   * "switched off" from "no such credential" from "upstream broke".
   */
  credentialByCtid: CredentialLookupResult;
  /**
   * PWS 4.1.7. The credential records for an occupation's pathway, in order.
   *
   * Rendered inside the plan's Education tab and inside the occupation credential
   * drawer, from one component: spec 09 acceptance criterion 7.
   */
  credentialRecords: Array<CredentialRecord>;
  /** Free-text search, for when no O*NET code is in hand. */
  credentialSearch: CredentialSearchResult;
  /**
   * Credentials aligned to an occupation, by O*NET code.
   *
   * THIS IS HOW CPD GETS A CTID. Nothing in our own database stores one, so without
   * this query credentialByCtid has no input. Needs CREDENTIAL_ENGINE_API_KEY;
   * without it the status is NOT_CONFIGURED rather than an empty list, because
   * "never granted access" and "there are none" must not look alike.
   *
   * Matching is on the O*NET URI, which is exact. Filtering on the SOC code string
   * was measured returning ten wrong records out of ten, so do not reintroduce it.
   *
   * Served from the materialised api.credential_occupation table, which is what
   * makes this safe to put on a page: no third party in the render path, and a
   * place to rank 704 unordered results. Falls back to a live call only when the
   * cache holds nothing for this occupation, so a cold cache is slow rather than
   * empty. withCompetenciesOnly and live both force the live path.
   */
  credentialsForOccupation: CredentialSearchResult;
  educationLevels: Array<EducationLevel>;
  extendedMilitaryBranches: Array<ExtendedMilitaryBranch>;
  favoriteMilitaryOccupations: Array<FavoriteMilitaryOccupation>;
  favoriteOccupations: Array<FavoriteOccupation>;
  /**
   * ANALYTICS.21. Feature adoption, from analytics.feature_event.
   *
   * DANTES staff only, like the other four reports. It answers "is anybody using
   * what we built", which is a programme-management question rather than a
   * counseling one.
   */
  featureAdoptionReport: FeatureAdoptionReport;
  getAiDeepInsight?: Maybe<AiDeepInsights>;
  getBugReports?: Maybe<Array<Maybe<BugReport>>>;
  getConnectOrganizationState: UserConnectState;
  getConversationContextStats: ConversationContextStats;
  getConversationHistory: ConversationWithMessages;
  getConversationNamingStats: ConversationNamingStats;
  getEmailToVerify?: Maybe<Scalars['String']>;
  getFeatureFlags?: Maybe<Array<Maybe<FeatureFlag>>>;
  getFeedbackAnalytics?: Maybe<FeedbackAnalytics>;
  getFeedbacks?: Maybe<Array<Maybe<FeedbackForAdmin>>>;
  getSharedReportFeedbacks?: Maybe<Array<Maybe<SharedReportFeedbackForAdmin>>>;
  getMaintanceStatus?: Maybe<MaintanceStatusReponse>;
  getMatchedOrganizations: MatchedOrganizations;
  /**
   * PWS 4.1.11, 4.1.12. `state` is a two-letter abbreviation. When given, each
   * card's medianAnnualWage is that state's median where one exists and the card
   * says which state it is for through `wageState`.
   */
  getOccupationCards?: Maybe<Array<Maybe<OccupationCard>>>;
  getOccupationList?: Maybe<Array<Maybe<CpdOccupation>>>;
  getOrganizations: Array<ConnectOrganizationSearchResult>;
  getPathwayCards?: Maybe<Array<Maybe<PathwayCard>>>;
  getPremiumPartners: Array<PremiumPartner>;
  getRateLimit: RateLimitResult;
  getReportEmbedConfig?: Maybe<EmbedConfig>;
  getSession: Session;
  getSimilarMilitaryOccupations?: Maybe<Array<Maybe<FavoriteMilitaryOccupation>>>;
  getSystemStatusReports?: Maybe<Array<Maybe<SystemStatusReport>>>;
  getUserConversations: ConversationList;
  goals: Goals;
  goalsReportDetails?: Maybe<GoalsReportDetails>;
  goalsReportDetailsForPublic?: Maybe<GoalsReportDetails>;
  /**
   * PWS 4.1.3. Published help content, in panel and sort order.
   *
   * Unauthenticated: help about how to sign in is no use behind a sign-in.
   */
  helpArticles: Array<HelpArticle>;
  initUserMatches?: Maybe<UpdateProfileResponse>;
  installationLocations: Array<Maybe<InstallationLocation>>;
  institutionPrograms: Array<CpdProgram>;
  /**
   * OC-2. One page of schools, plus the size of the whole matched set.
   *
   * This returned every match in one list: 2,343 rows at the default relatedness
   * and 5,767 at the widest, measured on dev. Omitting limit still returns
   * everything, so a caller that does not paginate is unaffected.
   */
  institutionsByOccupation?: Maybe<CpdInstitutionPage>;
  institutionsByProgram?: Maybe<Array<Maybe<CpdInstitution>>>;
  interestQuestions: Array<Interest>;
  /**
   * Courses and programmes for an occupation that state what they TEACH.
   *
   * Separate from credentialsForOccupation because the data sits differently: a
   * credential says what it is for, a course says what it teaches, and only the
   * taught statements can be compared against a learner's gap. Thin on its own,
   * since few courses carry an O*NET code.
   */
  learningForOccupation: CredentialSearchResult;
  locationByAttribute: Array<LocationAttribute>;
  militaryBranches: Array<MilitaryBranch>;
  militaryServeType?: Maybe<Array<Maybe<MilitaryServeType>>>;
  /**
   * ANALYTICS.15. Is the signed-in counselor or administrator DANTES staff?
   *
   * Its own query rather than a field on the session profile, because the Angular
   * app reads the session through generated types and codegen in this repo pulls
   * its schema from the DEPLOYED gateway. A standalone query can be consumed with
   * a raw document the moment the subgraph ships, which is what lets the access
   * boundary and the navigation that reflects it land together.
   *
   * Answers FALSE rather than denying, deliberately. Every counselor may ask; the
   * answer decides what they are shown. A guard here would make "are you allowed"
   * unanswerable to the people who are not.
   */
  myDantesAccess: Scalars['Boolean'];
  /** The caller's own front door answer, or null when they have not answered. */
  myFrontDoor?: Maybe<FrontDoorAnswers>;
  /** PWS 4.1.19. The signed-in member's own portfolio, draft and all. */
  myPortfolio?: Maybe<Portfolio>;
  /** T.6. The signed-in member's own Via allowance, for their builder. */
  myPortfolioViaUsage?: Maybe<PortfolioViaUsage>;
  /**
   * T-2. The learner's own knowledge, skills and abilities, most important first.
   *
   * NOT api.onet_technical_skills, which is what the resume builder was offering
   * through `userCompetencies`: that table is technology products, so a member
   * was shown "Jenkins CI", "Extensible markup language XML" and "Building
   * automation software" as the skills to put on a resume. Those are tools an
   * occupation may use, not things a person is good at.
   *
   * Read from the scored SkillsDNA spine against the anchors the learner
   * actually holds -- their military occupations and their civilian work history
   * -- and restricted to skill, knowledge, ability and work_activity. That is the
   * same source and the same exclusion the occupation KSA list uses, for the same
   * reason its comment gives: this must never fall back to technical skills.
   */
  myRecordSkills: Array<Scalars['String']>;
  /** PWS 4.1.7. The member's live share link, or null if they have not made one. */
  myReportShare?: Maybe<ReportShare>;
  /** PWS 4.1.10. The signed-in member's resume. */
  myResume?: Maybe<Resume>;
  /**
   * S.5. The learner's weekly allowance for questions asked on their shared
   * report, and whether it is switched on. Authenticated: this is the learner
   * reading their own budget.
   */
  mySharedReportViaUsage?: Maybe<SharedReportViaUsage>;
  news?: Maybe<Array<Maybe<NewsItem>>>;
  newsTypes?: Maybe<Array<Maybe<NewsTypesItem>>>;
  /**
   * PWS 4.3.4. This user's notifications, newest first. Dismissed rows are
   * excluded unless asked for: they are kept rather than deleted, because "when
   * did this stop being shown" is a question the rollups ask.
   */
  notifications: Array<Notification>;
  occupation?: Maybe<CpdOccupation>;
  pathway?: Maybe<CareerPathway>;
  pathways?: Maybe<Array<Maybe<PathwaySummary>>>;
  pendingActionSuggestions: Array<ActionItem>;
  priorLearningReport: PriorLearningReport;
  profile?: Maybe<Profile>;
  programsByOccupation?: Maybe<Array<Maybe<CpdProgram>>>;
  /**
   * Installations for the access-request type-ahead.
   *
   * PUBLIC and unauthenticated, because the form it serves is: the person filling
   * it in has no account yet, which is the entire reason the page exists. Gated
   * on DANTES_REPORTING_ENABLED alone, exactly like requestCounselorAccess, so
   * the two halves of that form appear and disappear together.
   *
   * Read-only reference data, capped server-side. Free text was the alternative,
   * and it meant duty stations arrived spelled a dozen ways and could not be
   * grouped in reporting (PWS 4.4.1.2.2).
   */
  publicInstallations: Array<PublicInstallation>;
  /**
   * PWS 4.1.19, spec 07. The public page, by slug, UNAUTHENTICATED on purpose:
   * this is what an employer opens. Returns null when the slug is unknown or the
   * page is not live, which are deliberately the same answer.
   */
  publicPortfolio?: Maybe<PublicPortfolio>;
  refreshSession: RefreshTokenResponse;
  register: User;
  registrationReport: RegistrationReport;
  /**
   * DoD fiscal years with no argument; that year's four quarters with one.
   *
   * Fiscal quarters (Oct-Dec, Jan-Mar, Apr-Jun, Jul-Sep), not contract quarters:
   * the period of performance starts on 29 August, which would cut every quarter
   * mid-month and put partial month columns on a filing.
   */
  reportPeriods: Array<ReportPeriod>;
  /**
   * Suggested rewordings for a block of resume text. Reads nothing and writes
   * nothing: a suggestion is only stored if the member saves it themselves.
   */
  resumeWording: ResumeWordingResult;
  returnSession: Scalars['String'];
  roles?: Maybe<Array<Maybe<Scalars['String']>>>;
  /**
   * CPL.1. Where a school publishes its credit for prior learning policy, or
   * null when CPD does not hold one for that school.
   *
   * The Brag Sheet linked "This school's credit for prior learning policy" at
   * `#`, which reloads the goals report. The field behind it was never populated,
   * so the link went nowhere for every school.
   *
   * Null is the honest answer and the link is hidden on it. Measured on dev:
   * api.cpl_institutions holds 644 institutions, every one with a verified source
   * URL, and joining them to api.schooldetails on OPEID reaches 647 of 6,489
   * schools. A dead link on the other 5,842 is worse than no link.
   */
  schoolCplPolicyUrl?: Maybe<Scalars['String']>;
  schoolDetails?: Maybe<CpdInstitution>;
  /** OCC.5. Does this school offer the chosen degree; if not, its closest ones. */
  schoolProgramFit: SchoolProgramFit;
  /**
   * Flat list of matching degrees. Original shape; see searchOccupations for why
   * the shape was restored rather than left changed in place.
   */
  searchDegrees: Array<Degree>;
  /** Flat list of CCAF degrees. Original shape. */
  searchDegreesForCCAF: Array<Degree>;
  /** CCAF degrees with exact and fuzzy separated. Prefer for new work. */
  searchDegreesForCCAFWithFuzzy: SearchDegreeForCcafResult;
  /** Degrees with exact and fuzzy matches separated. Prefer for new work. */
  searchDegreesWithFuzzy: SearchDegreeResult;
  searchLocations: Array<CpdLocation>;
  searchMajors: Array<Major>;
  /**
   * Job-code search. `extendedBranchCode` and `mpcCode` are both filters rather
   * than requirements: the SQL treats NULL as "no filter", and the redesigned
   * survey has neither an extended branch nor a rank to narrow by at the point
   * the member types. They were declared non-null, so passing null failed
   * variable coercion and the search returned errors instead of rows.
   *
   * The two nullable filters come LAST, after every required argument. Argument
   * order means nothing to a GraphQL caller, which names them, but it decides
   * the shape of the TypeScript that `graphql-types.ts` is generated as: Nest
   * emits a nullable argument as an OPTIONAL parameter, and an optional
   * parameter ahead of a required one does not compile. Interleaved, the
   * generated file broke the build every time it was regenerated.
   */
  searchMocs: Array<Moc>;
  /**
   * Exact-prefix occupation search. Returns a flat list.
   *
   * This is the original shape. On 2026-05-07 it was changed in place to return
   * SearchOccupationResult, which silently broke every already-deployed client:
   * the browser's query still selected occupation fields directly on this field,
   * GraphQL rejected it as invalid, and users got a 400 and an error page. That
   * went unnoticed until the backend was next deployed on 2026-07-30.
   *
   * Changing a field's shape in place only works if every client deploys in the
   * same breath. New shapes get new field names; see searchOccupationsWithFuzzy.
   */
  searchOccupations: Array<CpdOccupation>;
  /**
   * Occupation search with a fuzzy fallback, returning exact matches and
   * similarity matches separately. Prefer this for new work.
   */
  searchOccupationsWithFuzzy: SearchOccupationResult;
  searchRanks: Array<Rank>;
  /** Flat list of matching schools. Original shape. */
  searchSchools: Array<School>;
  /** Schools with exact and fuzzy matches separated. Prefer for new work. */
  searchSchoolsWithFuzzy: SearchSchoolResult;
  session: Scalars['Boolean'];
  /**
   * The report behind a share link. UNAUTHENTICATED on purpose: the reader is a
   * counselor the member sent a link to, and requiring an account would defeat
   * the whole feature. This is the read the mint-and-revoke pair existed for and
   * never had.
   *
   * Returns null for a token that is unknown, revoked, lapsed or malformed, which
   * are deliberately the same answer: none of them confirms that any of the
   * others exists.
   */
  sharedReport?: Maybe<SharedReport>;
  /**
   * S.4. The full report behind a share link. UNAUTHENTICATED on purpose, like its
   * thin sibling above: the reader is a counselor with no account, and the token
   * is the whole authorization.
   *
   * Returns null for a token that is unknown, revoked, lapsed or malformed --
   * deliberately the same answer, because none of them may confirm that any of the
   * others exists.
   */
  sharedReportFull?: Maybe<SharedReportFull>;
  /**
   * The signed-in learner's skill gap against their current target occupation,
   * and the options CPD offers that address it.
   *
   * Behind the VIA_SKILLS_GAP_ENABLED flag. Returns computable=false rather than
   * an error when the learner has no target or no held evidence, so a caller
   * never has to distinguish "not ready" from "broken".
   */
  skillGapReport?: Maybe<SkillGapReport>;
  spacebaseLocations: Array<Maybe<SpacebaseLocation>>;
  staffAccounts: Array<StaffAccountRow>;
  userReclassifying?: Maybe<UserReclassifyingResponse>;
  users?: Maybe<Array<Maybe<Profile>>>;
  viaUsageReport: ViaUsageReport;
};


export type QueryAccessRequestReportArgs = {
  grain?: InputMaybe<ReportGrain>;
  period?: InputMaybe<Scalars['String']>;
};


export type QueryAirbaseLocationsArgs = {
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryAnalyticsAskArgs = {
  filter?: InputMaybe<AnalyticsFilterInput>;
  previousPlan?: InputMaybe<Scalars['String']>;
  question: Scalars['String'];
};


export type QueryAnalyticsCareerEducationArgs = {
  alignedOccupation?: InputMaybe<Array<Scalars['String']>>;
  alignedProgram?: InputMaybe<Array<Scalars['String']>>;
  filter?: InputMaybe<AnalyticsFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  programGoal?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Array<Scalars['String']>>;
  tab: Scalars['String'];
};


export type QueryAnalyticsCareerEducationOptionsArgs = {
  tab: Scalars['String'];
};


export type QueryAnalyticsDetailArgs = {
  filter?: InputMaybe<AnalyticsFilterInput>;
  id: Scalars['String'];
  kind: Scalars['String'];
};


export type QueryAnalyticsFilterOptionsArgs = {
  additionalField?: InputMaybe<Scalars['String']>;
};


export type QueryAnalyticsInsightsArgs = {
  filter?: InputMaybe<AnalyticsFilterInput>;
};


export type QueryAnalyticsInsightsExplorationArgs = {
  filter?: InputMaybe<AnalyticsFilterInput>;
};


export type QueryAnalyticsMocSearchArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  term?: InputMaybe<Scalars['String']>;
};


export type QueryAnalyticsPivotArgs = {
  columns: Scalars['String'];
  filter?: InputMaybe<AnalyticsFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  rows: Scalars['String'];
};


export type QueryAnalyticsTrafficOverviewArgs = {
  filter?: InputMaybe<AnalyticsFilterInput>;
  grain?: InputMaybe<Scalars['String']>;
};


export type QueryAnalyticsUserDataArgs = {
  filter?: InputMaybe<AnalyticsFilterInput>;
};


export type QueryCognitoCallbackArgs = {
  cognitoIdToken: Scalars['String'];
};


export type QueryCompetenciesByNameArgs = {
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryCompletionReportArgs = {
  filter?: InputMaybe<AnalyticsFilterInput>;
  grain?: InputMaybe<ReportGrain>;
  period?: InputMaybe<Scalars['String']>;
};


export type QueryCredentialByCtidArgs = {
  ctid: Scalars['ID'];
  withOrganisations?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCredentialRecordsArgs = {
  onetCode?: InputMaybe<Scalars['String']>;
};


export type QueryCredentialSearchArgs = {
  keyword: Scalars['String'];
  learningOpportunities?: InputMaybe<Scalars['Boolean']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCredentialsForOccupationArgs = {
  live?: InputMaybe<Scalars['Boolean']>;
  onetCode: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
  withCompetenciesOnly?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFeatureAdoptionReportArgs = {
  filter?: InputMaybe<AnalyticsFilterInput>;
  grain?: InputMaybe<ReportGrain>;
  period?: InputMaybe<Scalars['String']>;
};


export type QueryGetConversationHistoryArgs = {
  conversationId: Scalars['Int'];
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
};


export type QueryGetEmailToVerifyArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type QueryGetOccupationCardsArgs = {
  state?: InputMaybe<Scalars['String']>;
};


export type QueryGetOccupationListArgs = {
  param?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<OccupationType>;
};


export type QueryGetOrganizationsArgs = {
  query?: InputMaybe<Scalars['String']>;
  type: OrganizationType;
};


export type QueryGetSessionArgs = {
  token?: InputMaybe<Scalars['String']>;
};


export type QueryGetSimilarMilitaryOccupationsArgs = {
  onetCode?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetUserConversationsArgs = {
  limit?: Scalars['Int'];
  offset?: Scalars['Int'];
};


export type QueryInstallationLocationsArgs = {
  branchCode: Scalars['String'];
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryInstitutionProgramsArgs = {
  cipCodeCutoff: CipCodeCutoffFilter;
  educationLevel?: InputMaybe<EducationLevelFilter>;
  medianEarnings?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  onetCode: Scalars['ID'];
  online?: InputMaybe<Scalars['Boolean']>;
  schoolId: Scalars['Int'];
};


export type QueryInstitutionsByOccupationArgs = {
  allSchools?: InputMaybe<Scalars['Boolean']>;
  avarageCost?: InputMaybe<Scalars['Boolean']>;
  cipCodeCutoff: CipCodeCutoffFilter;
  educationLevel?: InputMaybe<EducationLevelFilter>;
  graduationRate?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  limit?: InputMaybe<Scalars['Int']>;
  medianDebt?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  onetCode: Scalars['ID'];
  online?: InputMaybe<Scalars['Boolean']>;
  openAdmission?: InputMaybe<Scalars['Boolean']>;
  regionalAccreditation?: InputMaybe<Scalars['Boolean']>;
  schoolProgramId?: InputMaybe<Scalars['Int']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taApproved?: InputMaybe<Scalars['Boolean']>;
};


export type QueryInstitutionsByProgramArgs = {
  educationLevel: EducationLevelFilter;
  online?: InputMaybe<Scalars['Boolean']>;
  openAdmission?: InputMaybe<Scalars['Boolean']>;
  programCipCode: Scalars['String'];
  programName: Scalars['String'];
  regionalAccreditation?: InputMaybe<Scalars['Boolean']>;
  searchTerm?: InputMaybe<Scalars['String']>;
  taApproved?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLearningForOccupationArgs = {
  onetCode: Scalars['String'];
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryLocationByAttributeArgs = {
  affordableRealEstate?: InputMaybe<Scalars['Boolean']>;
  goodAirQuality?: InputMaybe<Scalars['Boolean']>;
  highVetPercent?: InputMaybe<Scalars['Boolean']>;
  lowCostOfLiving?: InputMaybe<Scalars['Boolean']>;
  lowCrimeRate?: InputMaybe<Scalars['Boolean']>;
  lowUnemployment?: InputMaybe<Scalars['Boolean']>;
  onetCodeDemand?: InputMaybe<Scalars['ID']>;
};


export type QueryMilitaryServeTypeArgs = {
  branchCode: Scalars['String'];
};


export type QueryNotificationsArgs = {
  includeDismissed?: InputMaybe<Scalars['Boolean']>;
};


export type QueryOccupationArgs = {
  jobId?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  onetCode: Scalars['ID'];
};


export type QueryPathwayArgs = {
  pathwayId: Scalars['ID'];
};


export type QueryPriorLearningReportArgs = {
  filter?: InputMaybe<AnalyticsFilterInput>;
  grain?: InputMaybe<ReportGrain>;
  source?: InputMaybe<Scalars['String']>;
};


export type QueryProfileArgs = {
  sessionToken?: InputMaybe<Scalars['String']>;
};


export type QueryProgramsByOccupationArgs = {
  cipCodeCutoff: CipCodeCutoffFilter;
  educationLevel?: InputMaybe<EducationLevelFilter>;
  jobId?: InputMaybe<Scalars['ID']>;
  onetCode: Scalars['ID'];
  online?: InputMaybe<Scalars['Boolean']>;
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryPublicInstallationsArgs = {
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryPublicPortfolioArgs = {
  slug: Scalars['ID'];
};


export type QueryRefreshSessionArgs = {
  refreshToken: Scalars['String'];
};


export type QueryRegisterArgs = {
  anonymous?: InputMaybe<Scalars['Boolean']>;
};


export type QueryRegistrationReportArgs = {
  filter?: InputMaybe<AnalyticsFilterInput>;
  grain?: InputMaybe<ReportGrain>;
  period?: InputMaybe<Scalars['String']>;
};


export type QueryReportPeriodsArgs = {
  fiscalYear?: InputMaybe<Scalars['Int']>;
};


export type QueryResumeWordingArgs = {
  input: ResumeWordingInput;
};


export type QueryReturnSessionArgs = {
  returnToken: Scalars['String'];
};


export type QuerySchoolCplPolicyUrlArgs = {
  schoolId: Scalars['Int'];
};


export type QuerySchoolDetailsArgs = {
  schoolId: Scalars['ID'];
};


export type QuerySchoolProgramFitArgs = {
  onetCode: Scalars['ID'];
  schoolId: Scalars['Int'];
  schoolProgramEdLevelId?: InputMaybe<Scalars['Int']>;
  schoolProgramId: Scalars['Int'];
};


export type QuerySearchDegreesArgs = {
  searchTerm: Scalars['String'];
};


export type QuerySearchDegreesForCcafArgs = {
  searchTerm: Scalars['String'];
};


export type QuerySearchDegreesForCcafWithFuzzyArgs = {
  searchTerm: Scalars['String'];
};


export type QuerySearchDegreesWithFuzzyArgs = {
  searchTerm: Scalars['String'];
};


export type QuerySearchLocationsArgs = {
  searchTerm: Scalars['String'];
};


export type QuerySearchMajorsArgs = {
  searchTerm: Scalars['String'];
};


export type QuerySearchMocsArgs = {
  activeType: Scalars['String'];
  branchCode: Scalars['String'];
  extendedBranchCode?: InputMaybe<Scalars['String']>;
  mpcCode?: InputMaybe<Scalars['String']>;
  searchTerm: Scalars['String'];
};


export type QuerySearchOccupationsArgs = {
  searchTerm: Scalars['String'];
};


export type QuerySearchOccupationsWithFuzzyArgs = {
  searchTerm: Scalars['String'];
};


export type QuerySearchRanksArgs = {
  branchCode: Scalars['String'];
  searchTerm: Scalars['String'];
};


export type QuerySearchSchoolsArgs = {
  searchTerm: Scalars['String'];
};


export type QuerySearchSchoolsWithFuzzyArgs = {
  searchTerm: Scalars['String'];
};


export type QuerySharedReportArgs = {
  token: Scalars['ID'];
};


export type QuerySharedReportFullArgs = {
  token: Scalars['ID'];
};


export type QuerySkillGapReportArgs = {
  gapLimit?: InputMaybe<Scalars['Int']>;
  onetCode?: InputMaybe<Scalars['String']>;
  optionLimit?: InputMaybe<Scalars['Int']>;
  requirementLimit?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
};


export type QuerySpacebaseLocationsArgs = {
  searchTerm?: InputMaybe<Scalars['String']>;
};


export type QueryStaffAccountsArgs = {
  period?: InputMaybe<Scalars['String']>;
};


export type QueryViaUsageReportArgs = {
  filter?: InputMaybe<AnalyticsFilterInput>;
  grain?: InputMaybe<ReportGrain>;
};

export type Rank = {
  __typename?: 'Rank';
  abbreviation?: Maybe<Scalars['String']>;
  branchCode?: Maybe<Scalars['String']>;
  mpcCode?: Maybe<Scalars['String']>;
  payGrade?: Maybe<Scalars['String']>;
  payGradeLevel?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
};

export type RankInput = {
  abbreviation?: InputMaybe<Scalars['String']>;
  branchCode?: InputMaybe<Scalars['String']>;
  mpcCode?: InputMaybe<Scalars['String']>;
  payGrade?: InputMaybe<Scalars['String']>;
  payGradeLevel?: InputMaybe<Scalars['Int']>;
  title?: InputMaybe<Scalars['String']>;
};

export type RateLimitResult = {
  __typename?: 'RateLimitResult';
  allowed: Scalars['Boolean'];
  limit: Scalars['Int'];
  remaining: Scalars['Int'];
  resetTime: Scalars['Date'];
};

export enum ReactionEnum {
  Dislike = 'DISLIKE',
  Like = 'LIKE'
}

export type ReadinessAreaReportInput = {
  /** Education, Work experience, Training, Certification or Licensing */
  area: Scalars['String'];
  isMatched?: InputMaybe<Scalars['Boolean']>;
  learnerHas: Array<Scalars['String']>;
  required: Array<Scalars['String']>;
};

export type RefreshTokenResponse = {
  __typename?: 'RefreshTokenResponse';
  refreshToken: Scalars['String'];
  token: Scalars['ID'];
};

export type RegistrationBranchRow = {
  __typename?: 'RegistrationBranchRow';
  branch: Scalars['String'];
  cumulative: Scalars['Int'];
  /** One entry per month bucket, aligned with RegistrationReport.monthLabels. */
  months: Array<Scalars['Int']>;
  periodTotal: Scalars['Int'];
  /**
   * V7. Twelve monthly totals for this branch, oldest first, aligned with
   * RegistrationReport.trailingMonths. Deliberately NOT bounded by the selected
   * period: three points is not a trend, and a column that rescaled every time
   * the period changed would mean something different on every view.
   */
  trailing12: Array<Scalars['Int']>;
};

/**
 * New registrations.
 *
 * NOT an account count: everyone who completed the Skills Survey and told us
 * their branch, whether or not they registered. Staff are excluded.
 */
export type RegistrationReport = {
  __typename?: 'RegistrationReport';
  cumulative: Scalars['Int'];
  /**
   * cumulative against the same running total as it stood when this period opened.
   * Comparing a running total against the previous period would merely restate
   * periodDelta; what a reader wants is how much of the total arrived recently.
   */
  cumulativeDelta?: Maybe<PeriodDelta>;
  cumulativeSince?: Maybe<Scalars['String']>;
  monthLabels: Array<Scalars['String']>;
  period: ReportPeriod;
  /** periodTotal against the same elapsed slice of the previous period. */
  periodDelta?: Maybe<PeriodDelta>;
  periodTotal: Scalars['Int'];
  rows: Array<RegistrationBranchRow>;
  /** Trend for the selected grain, so the View-by control drives something. */
  series: Array<AnalyticsTimePoint>;
  /** Same trend split by branch, for the chart's By Branch tab. */
  seriesByBranch: Array<AnalyticsTimePoint>;
  /** The twelve month keys the trailing12 arrays are aligned to, oldest first. */
  trailingMonths: Array<Scalars['String']>;
};

/** How a period is cut. Extends the ANALYTICS.1 grain vocabulary. */
export enum ReportGrain {
  ContractYear = 'CONTRACT_YEAR',
  FiscalYear = 'FISCAL_YEAR',
  Month = 'MONTH',
  Quarter = 'QUARTER'
}

/** One reporting period, computed from the contract period of performance. */
export type ReportPeriod = {
  __typename?: 'ReportPeriod';
  /** Exclusive. Half-open ranges compose without an off-by-one at the boundary. */
  endsAt: Scalars['String'];
  /** False before the period has begun, so the page can say so instead of showing zeros. */
  hasStarted: Scalars['Boolean'];
  isCurrent: Scalars['Boolean'];
  key: Scalars['String'];
  label: Scalars['String'];
  startsAt: Scalars['String'];
};

/**
 * PWS 4.1.7, spec 05 section 8. A link that lets somebody read a member's goals
 * report.
 *
 * A capability, not a permission. Holding the link grants a read and nothing
 * else; a counselor's actual access is granted elsewhere.
 */
export type ReportShare = {
  __typename?: 'ReportShare';
  createdAt: Scalars['Date'];
  /**
   * When the link stops working on its own.
   *
   * A share is a bearer credential over the member's whole report, so it lapses
   * whether or not anybody remembers it exists. Revocation is still the immediate
   * off switch; this is the one that does not need the member to act.
   */
  expiresAt: Scalars['Date'];
  isLive: Scalars['Boolean'];
  /** Set when the member turns the link off. The row is kept. */
  revokedAt?: Maybe<Scalars['Date']>;
  /** The secret. Whoever has it can read the report. */
  token: Scalars['ID'];
};

export type Response = ResponseInterface & {
  __typename?: 'Response';
  code: Scalars['Int'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type ResponseInterface = {
  code: Scalars['Int'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

/** PWS 4.1.10. The resume builder's document. */
export type Resume = {
  __typename?: 'Resume';
  document: Scalars['JSON'];
  /** WALK-44. Which of the member's resumes this is; saveResume sends it back. */
  id?: Maybe<Scalars['ID']>;
  /** classic, modern or compact. How the document prints, not part of what it says. */
  theme: Scalars['String'];
};

export type ResumeWordingInput = {
  /** Which resume block this text came from, e.g. summary or work. */
  section: Scalars['String'];
  /** The role the resume targets, when one is set. */
  targetRole?: InputMaybe<Scalars['String']>;
  /** What the member wrote. Returned unchanged when it is empty. */
  text: Scalars['String'];
};

export type ResumeWordingResult = {
  __typename?: 'ResumeWordingResult';
  /**
   * Set when the member is over their daily allowance. The panel shows this
   * instead of suggestions rather than failing silently.
   */
  limitReached: Scalars['Boolean'];
  suggestions: Array<ResumeWordingSuggestion>;
  /**
   * The role the wordings were written for, echoed back so the panel can say
   * "Via suggests for <role>" without guessing.
   */
  writtenFor?: Maybe<Scalars['String']>;
};

/**
 * Alternative wordings for one line or block of a member's resume.
 *
 * The design's "Enhance with Via" offers a few phrasings and lets the member page
 * through them, so this returns several rather than one, and never overwrites
 * anything: the member chooses, and can go back to what they wrote.
 */
export type ResumeWordingSuggestion = {
  __typename?: 'ResumeWordingSuggestion';
  /** The suggested text, plain prose with no markup. */
  text: Scalars['String'];
};

export type RetrievalMetadata = {
  __typename?: 'RetrievalMetadata';
  combinedResults: Scalars['Int'];
  filterSearchResults: Scalars['Int'];
  vectorSearchResults: Scalars['Int'];
};

export type SalaryAnalysis = {
  __typename?: 'SalaryAnalysis';
  geographyName?: Maybe<Scalars['String']>;
  maximumAnnualSalary?: Maybe<Scalars['Int']>;
  medianAnnualSalary?: Maybe<Scalars['Int']>;
  minimumAnnualSalary?: Maybe<Scalars['Int']>;
  salaryPrecisionType?: Maybe<Scalars['String']>;
  salarySocCode?: Maybe<Scalars['String']>;
};

export type SalaryData = {
  __typename?: 'SalaryData';
  hourly?: Maybe<Scalars['Float']>;
  median?: Maybe<Scalars['Float']>;
  range?: Maybe<Scalars['String']>;
};

export type School = {
  __typename?: 'School';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
};

/**
 * OCC.5. Whether a school offers the member's chosen degree, and if not, the
 * school's closest degrees for the occupation.
 *
 * A degree goal is stored as ONE school's program row, so pairing it with a
 * different school saved a degree that school does not teach. Jackson, 24 Sep
 * 2026: CPD must never hold a degree goal the school does not offer; ask first,
 * and offer the closest degrees the school does have.
 */
export type SchoolProgramFit = {
  __typename?: 'SchoolProgramFit';
  /** The school teaches the chosen program (same CIP) at the chosen level. */
  offered: Scalars['Boolean'];
  /** When offered: the school's OWN program row, to store instead of the goal's. */
  offeredProgramId?: Maybe<Scalars['Int']>;
  /**
   * When not offered: the school's programs ranked for the occupation, the chosen
   * level first, then the rest; one row per program and level.
   */
  suggestions: Array<SchoolProgramSuggestion>;
};

export type SchoolProgramSuggestion = {
  __typename?: 'SchoolProgramSuggestion';
  /** Catalog alignment to the occupation, 0-7. Orders the list; never displayed. */
  alignment?: Maybe<Scalars['Int']>;
  cipCode?: Maybe<Scalars['String']>;
  programName: Scalars['String'];
  schoolProgramEdLevelId?: Maybe<Scalars['Int']>;
  schoolProgramId: Scalars['Int'];
};

export type SearchDegreeForCcafResult = {
  __typename?: 'SearchDegreeForCCAFResult';
  fuzzy: Array<Degree>;
  search: Array<Degree>;
};

export type SearchDegreeResult = {
  __typename?: 'SearchDegreeResult';
  fuzzy: Array<Degree>;
  search: Array<Degree>;
};

export type SearchOccupationResult = {
  __typename?: 'SearchOccupationResult';
  fuzzy: Array<CpdOccupation>;
  search: Array<CpdOccupation>;
};

export type SearchSchoolResult = {
  __typename?: 'SearchSchoolResult';
  fuzzy: Array<School>;
  search: Array<School>;
};

export type Session = {
  __typename?: 'Session';
  isAuthenticated?: Maybe<Scalars['Boolean']>;
  profile: Profile;
  refreshToken?: Maybe<Scalars['String']>;
  token: Scalars['ID'];
};

/**
 * The goals report as the holder of a share link reads it. Spec 05 section 8.
 *
 * Deliberately NOT `GoalsReportDetails`, which is the member's own view of the
 * same report. That type carries `sessionId` and `returnLink`, which are
 * return-session credentials: serving them here would turn a read-only share into
 * a way to sign in as the member, so this type exists to make that impossible to
 * ask for rather than to remember not to select.
 *
 * Everything here is report content, and only what the report itself puts on
 * screen. No email, no user id, no login history, and nothing about the member
 * beyond the first name their own report is headed with.
 */
export type SharedReport = {
  __typename?: 'SharedReport';
  certification?: Maybe<CpdCertificate>;
  degree?: Maybe<GoalsReportDegreeDetails>;
  expiresAt: Scalars['Date'];
  /** When the report was last generated. Null when it never has been. */
  generatedReportDate?: Maybe<Scalars['String']>;
  license?: Maybe<CpdLicense>;
  /**
   * The member's first name, so a counselor holding several links knows whose
   * report is open. It is what the report's own heading shows them.
   */
  memberFirstName?: Maybe<Scalars['String']>;
  occupation?: Maybe<GoalsReportOccupationDetails>;
  onetCode?: Maybe<Scalars['String']>;
  school?: Maybe<GoalsReportSchoolDetails>;
  /** When the member made the link, and when it stops working. */
  sharedAt: Scalars['Date'];
};

/**
 * S.4. The FULL goals report behind a share link.
 *
 * Jackson, 20 Sep: counselors see the whole report as the learner sees it, and the
 * link itself stays the credential. `SharedReport` above is the thin projection
 * that answer replaces; it is kept because the old page still reads it until the
 * new one lands.
 *
 * WHY THIS IS ONE QUERY RATHER THAN FIVE OPENED UP. The member's own report is
 * assembled from five authenticated reads: profile, goals, the export-projection
 * occupation, the parsed transcript and the AI insights. Making those five
 * reachable by token would be five places to get the scoping right, five places
 * for a later change to widen what a link carries, and five chances to leak a
 * field the share was never meant to hold. One query is one place where "what a
 * link can see" is decided, and one place to read it back.
 *
 * IT RETURNS THE INPUTS, NOT THE ASSEMBLED PAGE. The view model is built by
 * plan-page.mapper.ts, ~1,400 lines deciding what a count means and what an absent
 * field means. Rebuilding that here would give the counselor's copy a second
 * answer to every one of those questions, and it would drift from the member's --
 * which is exactly the fault the classic PDF export has.
 *
 * WHAT IT CANNOT EXPRESS, by construction rather than by remembering:
 * `sessionId` and `returnLink`. Those are return-session credentials, and serving
 * them would turn a read-only share into a way to sign in AS the member. The thin
 * type excludes them for that reason and so does this one.
 */
export type SharedReportFull = {
  __typename?: 'SharedReportFull';
  expiresAt: Scalars['Date'];
  goals?: Maybe<Goals>;
  insights?: Maybe<AiDeepInsights>;
  /**
   * The parsed transcript, as the REST route hands it to the member's own page:
   * `{ success, jst_upload_id, data }`, or `{ success: false }` when there is
   * none. A scalar because the mapper reads it as the shape it already knows, and
   * restating ~15 nested types here would be a second declaration to keep in step.
   */
  jst?: Maybe<Scalars['JSON']>;
  /** The member's first name, so a counselor holding several links knows whose. */
  memberFirstName?: Maybe<Scalars['String']>;
  occupation?: Maybe<CpdOccupation>;
  /**
   * The five payloads the report is built from, exactly as the member's own page
   * receives them, so both run through the same mapper.
   */
  profile?: Maybe<Profile>;
  /** When the member made the link, and when it stops working. */
  sharedAt: Scalars['Date'];
  /**
   * Via's READING of this report: the key points, the narratives behind them and
   * the topics to raise in a session. This is what the "Insights from Via" panel
   * shows, and until it existed a counselor opening a live link was told "There
   * is no Via reading on this report yet" for a report that had one.
   *
   * NOT the same thing as `insights` above, which is AIDeepInsights: course and
   * certificate suggestions. Two fields, two payloads, and the shared report was
   * feeding the second into the panel that renders the first.
   *
   * Read-only by construction. It carries no rate limit and no credit balance,
   * because a counselor can neither generate nor refresh a reading -- that spends
   * the member's credits, and the offer stays on the member's own page.
   *
   * JSON for the same reason `jst` is: the member's own page already receives
   * this shape, so the one mapper reads both and there is no second declaration
   * of ~10 nested types to keep in step.
   */
  viaInsights?: Maybe<Scalars['JSON']>;
};

/**
 * S.5. What one counselor question produced.
 *
 * The OUTCOME rides with the answer rather than being inferred from a null,
 * because "the report cannot answer that", "the learner turned this off" and
 * "the learner's week is spent" are three different facts. A nullable answer
 * string would collapse them into one shrug.
 */
export type SharedReportFeedbackForAdmin = {
  __typename?: 'SharedReportFeedbackForAdmin';
  careergoal?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  createdtimestamp?: Maybe<Scalars['String']>;
  moctitle?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Int']>;
};

export type SharedReportViaAnswer = {
  __typename?: 'SharedReportViaAnswer';
  /** The answer, or null when there is none to give. */
  answer?: Maybe<Scalars['String']>;
  /** One of: answered, cached, exhausted, disabled, unavailable. */
  outcome: Scalars['String'];
  /** What is left of the learner's week. Null when it does not apply. */
  remaining?: Maybe<Scalars['Int']>;
};

/** S.6. One earlier exchange in the counselor's Via sidebar on a shared report. */
export type SharedReportViaTurnInput = {
  answer: Scalars['String'];
  question: Scalars['String'];
};

/** S.5. The learner's own view of what their shared report is spending. */
export type SharedReportViaUsage = {
  __typename?: 'SharedReportViaUsage';
  enabled: Scalars['Boolean'];
  limit: Scalars['Int'];
  remaining: Scalars['Int'];
  used: Scalars['Int'];
};

export type Skill = {
  __typename?: 'Skill';
  count?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  skillId?: Maybe<Scalars['String']>;
  skillType?: Maybe<Scalars['Int']>;
  source?: Maybe<Scalars['String']>;
};

export type SkillCompatibility = {
  __typename?: 'SkillCompatibility';
  matchesUser?: Maybe<Scalars['Boolean']>;
  text?: Maybe<Scalars['String']>;
};

/**
 * How much of a report rests on measured evidence rather than inference.
 *
 * Exists because a fully derived report currently looks exactly as authoritative
 * as a measured one. Measured on dev: every one of the 152 rows for an Air Force
 * Security Forces learner carries weakest_method='composition_including_derived',
 * meaning none of it was measured for that code and all of it was inferred from
 * component anchors. That mechanism is legitimate and is the only reason the
 * learner gets a report at all, which is precisely why it must be labelled rather
 * than suppressed.
 */
export enum SkillConfidence {
  /**
   * The TARGET occupation is one of the civilian occupations that DEFINE the
   * learner's military profile, so the comparison is circular and the gap is not a
   * measurement of anything.
   *
   * 91.6% of military profiles are inherited from exactly ONE civilian occupation
   * through the DoD crosswalk. When a learner then aims at that same occupation,
   * the engine compares it against itself and returns almost no gap. Measured on
   * dev: 42 of the 2,105 learners holding both a military occupation and a target
   * are in this position, and sampled real-gap counts were 0, 0, 0 and 2 against a
   * non-circular baseline of 15 to 88.
   *
   * This outranks MEASURED and DERIVED, because no amount of measurement elsewhere
   * rescues a self-comparison. Never render this as "you are ready": say that the
   * DoD crosswalk maps their military role onto this same occupation, so CPD
   * cannot measure a distance between the two.
   */
  Circular = 'CIRCULAR',
  /** Every covered element was inferred through anchor composition. */
  Derived = 'DERIVED',
  /** At least one covered element was measured directly for a held anchor. */
  Measured = 'MEASURED'
}

/** How the claim that an option leads to the target occupation was established. */
export enum SkillDestinationBasis {
  /**
   * Inferred from the CIP crosswalk because the occupation carries no composition
   * at all. The destination weight is an assumption. 122 of 1,016 occupations are
   * in this position and would otherwise return no options at all.
   */
  CipCrosswalkFallback = 'CIP_CROSSWALK_FALLBACK',
  /** A measured Layer B composition edge. */
  Composition = 'COMPOSITION'
}

/** Where a claim about the learner came from. */
export enum SkillEvidenceBasis {
  /** Records exist but none carried a published curriculum to read. */
  NoParsedCurriculum = 'NO_PARSED_CURRICULUM',
  /** A curriculum was published and read. */
  ParsedCurriculum = 'PARSED_CURRICULUM'
}

/** An anchor the learner targets, holds, has attested, or plans. */
export type SkillEvidenceItem = {
  __typename?: 'SkillEvidenceItem';
  anchorType: Scalars['String'];
  displayName?: Maybe<Scalars['String']>;
  naturalKey: Scalars['String'];
  /**
   * How the code on the learner record reached this anchor: direct, work_history,
   * education_completed, credential_held, licence_held and so on.
   *
   * Two values carry a warning rather than a route, and both exist so an inexact
   * match can never pass as an exact one:
   *
   *   education_completed_aliased_cip
   *     The cipcode was substituted through skills.cip_alias before it matched.
   *
   *   excluded:<reason>
   *     The code resolved to an anchor the catalogue marks as NOT AN OCCUPATION,
   *     so it was deliberately left unresolved. These arrive in the `excluded`
   *     list, never in `held`. The commonest is
   *     excluded:not_a_military_occupation:military_spouse_or_partner, carried by
   *     1,556 dev learners.
   */
  resolvedVia?: Maybe<Scalars['String']>;
};

/** One element of the occupation's profile, measured against the learner. */
export type SkillGapElement = {
  __typename?: 'SkillGapElement';
  attestedBasis?: Maybe<SkillEvidenceBasis>;
  /**
   * Something the learner has already COMPLETED or HOLDS named this skill:
   * a finished degree, a credential, a licence. Carries NO level, so it never
   * reduces gapLevel and never resolves an UNKNOWN. It exists so the platform can
   * say "you have studied this" instead of nothing at all.
   */
  attestedNamesSkill?: Maybe<Scalars['Boolean']>;
  elementId: Scalars['ID'];
  elementName: Scalars['String'];
  /** skill, knowledge, ability or work_activity. */
  elementType: Scalars['String'];
  gapLevel?: Maybe<Scalars['Float']>;
  /** Null when nothing the learner holds rates this element. */
  heldLevel?: Maybe<Scalars['Float']>;
  /** The same banding applied to what the learner evidence supports. */
  heldLevelBand?: Maybe<SkillLevelBand>;
  /**
   * Layer A. The learner's PLANNED programme names this skill in its published
   * curriculum, and they are short of it. Three-valued: null means no curriculum
   * was published to read. Read planBasis rather than treating null as false.
   * A plan never reduces gapLevel.
   */
  planAddressesGap?: Maybe<Scalars['Boolean']>;
  planBasis?: Maybe<SkillEvidenceBasis>;
  /** Importance multiplied by shortfall. Ranks what to do first. */
  priority?: Maybe<Scalars['Float']>;
  /**
   * The raw O*NET importance. Prefer requiredImportanceBand for anything a learner
   * reads, for the same reason as the level.
   */
  requiredImportance?: Maybe<Scalars['Float']>;
  /**
   * How much this occupation RELIES on the element, against every other
   * occupation. A DIFFERENT CLAIM from requiredLevelBand, and the two disagree on
   * 33 of the 158 elements of Firefighters alone: a job can want a high level of
   * something it barely leans on. Only this field supports the word "important".
   * Saying it from the level band would be wrong about a fifth of the time, and
   * wrong invisibly.
   */
  requiredImportanceBand?: Maybe<SkillLevelBand>;
  /**
   * The raw O*NET level, 0 to 7. Prefer requiredLevelBand in anything a learner
   * reads: a bare decimal is misread as a mark out of seven, and 5.8 is beyond the
   * 95th percentile of what any occupation asks.
   */
  requiredLevel?: Maybe<Scalars['Float']>;
  /** What this level MEANS against every other occupation, for THIS element. */
  requiredLevelBand?: Maybe<SkillLevelBand>;
  status: SkillStatus;
  /** The weakest derivation behind this row, so confidence can be shown honestly. */
  weakestMethod?: Maybe<Scalars['String']>;
};

/** An option on CPD, ranked by how well it addresses this learner's gap. */
export type SkillGapOption = {
  __typename?: 'SkillGapOption';
  /**
   * The 2-digit CIP family. NULL for an option carrying no CIP, which is most
   * credentials and every military course, so a caller must not read NULL as a
   * family that failed a check.
   */
  cipFamily?: Maybe<Scalars['String']>;
  /** Credential levels this option is offered at, when it has more than one. */
  credentialLevels: Array<Scalars['String']>;
  /**
   * How many occupations this option's crosswalk edge claims. LOWER IS MORE
   * SPECIFIC. A high value means the edge is generic, and is the reason an option
   * is demoted inside a tie band rather than a reason to hide it.
   */
  crosswalkFanOut?: Maybe<Scalars['Int']>;
  /**
   * False means a curriculum was read and this learner's gap is not in it.
   * Null means no curriculum was ever published. Never rank a null as a zero.
   */
  curriculumPublished?: Maybe<Scalars['Boolean']>;
  /**
   * Where the claim "this option leads to the target" came from.
   *
   * COMPOSITION is the measured Layer B edge. CIP_CROSSWALK_FALLBACK means the
   * occupation had NO composition at all, so the option was found through the CIP
   * crosswalk instead and its destinationWeight is an assumption (the CIP's
   * destination mass split evenly across the occupations it feeds) rather than a
   * measurement.
   *
   * A fallback option is still a real programme with a real curriculum, and the
   * alternative for these 105 occupations was showing nothing whatever. But a
   * surface should not present its destinationWeight as evidence of where
   * graduates actually go.
   */
  destinationBasis?: Maybe<SkillDestinationBasis>;
  /**
   * Layer B. How strongly this option's graduates enter the target occupation.
   * This is the SELECTION criterion: options that do not lead to the target are
   * not returned at all, however well their curriculum happens to match.
   */
  destinationWeight?: Maybe<Scalars['Float']>;
  displayName: Scalars['String'];
  /**
   * ISO 8601 duration, when the publisher stated one. NULL is neutral and never a
   * zero: only Credential Engine options carry a duration at all, so ranking a
   * null as "instant" or as "forever" would both be inventions.
   */
  durationIso?: Maybe<Scalars['String']>;
  /**
   * Whether the learner can actually ENROL. False is NOT a judgement about
   * ambition: certificate, associate and bachelor options are all eligible for
   * somebody holding only a high school diploma. False means a condition of entry
   * is unmet, or cannot be confirmed from the record.
   */
  eligible: Scalars['Boolean'];
  gapElementsNamed?: Maybe<Scalars['Int']>;
  gapElementsTotal?: Maybe<Scalars['Int']>;
  /** Why not, when eligible is false. Null when eligible. */
  ineligibleReason?: Maybe<SkillIneligibleReason>;
  /** The highest-priority gap skills this option names, for showing the why. */
  namedTop: Array<Scalars['String']>;
  /** Stable key for the option: the CIP for a programme, the natural key otherwise. */
  optionKey: Scalars['ID'];
  /** education_program, military_course, industry_credential or licence. */
  optionType: Scalars['String'];
  /**
   * Share of the learner's evidenced gap priority whose skills this option's
   * curriculum NAMES. A ranking signal for building a shortlist. It is NOT a
   * completion percentage and must not be rendered as one.
   */
  priorityShareNamed?: Maybe<Scalars['Float']>;
  /**
   * True when this option is ONE course rather than a programme or credential.
   * A course is never ranked above an eligible programme; it leads only when
   * nothing else is eligible. Null means the database did not say.
   */
  singleCourse?: Maybe<Scalars['Boolean']>;
};

/** Everything CPD knows about one learner's position against their goal. */
export type SkillGapReport = {
  __typename?: 'SkillGapReport';
  /**
   * Aptitude requirements the learner falls short on: O*NET ABILITY elements such
   * as Far Vision, Finger Dexterity or Multilimb Coordination.
   *
   * SEPARATE FROM gaps ON PURPOSE, and NEVER a to-learn list. CPD infers a level
   * for every element from the OCCUPATIONS the learner has held. For a practised
   * skill that is a fair proxy; for a physical or perceptual trait it is a category
   * error, because a person eyesight is not set by their job. So a value here means
   * "roles like theirs typically require this much", not "this person has this
   * much". Render them as requirements OF THE ROLE, never as a personal
   * shortcoming, and never as something to improve.
   */
  aptitudes: Array<SkillGapElement>;
  /** Education completed, credentials, licences. These name skills without a level. */
  attested: Array<SkillEvidenceItem>;
  /** False when there is no target, or no held evidence to measure against. */
  computable: Scalars['Boolean'];
  /**
   * Whether the covered elements behind this report were measured or inferred.
   * Null when the gap is not computable.
   */
  confidence?: Maybe<SkillConfidence>;
  /**
   * Codes on the record that the catalogue says are NOT AN OCCUPATION: a military
   * spouse placeholder, a trainee or candidate status, an unassigned billet, a
   * designator rather than a job.
   *
   * Held apart from `held` on purpose, because they are the opposite of evidence
   * and `held` is documented as the occupations that can close a gap. They are
   * surfaced rather than dropped so a learner is told "we have this on your record
   * and it is not a job" instead of silently seeing nothing. 1,722 dev learners
   * carry one, 1,556 of them the military spouse placeholder, and 795 have nothing
   * else on file at all: for those, this list plus an invitation to add their work
   * history is the entire useful content of the report.
   *
   * Read resolvedVia for the reason. None of these ever contributes a skill: all
   * 3,631 excluded anchors carry no profile and no composition.
   */
  excluded: Array<SkillEvidenceItem>;
  /**
   * Elements ordered by priority. UNKNOWN elements are EXCLUDED here and returned
   * separately, because an unrated element scores a full shortfall and therefore
   * outranks every genuine gap.
   */
  gaps: Array<SkillGapElement>;
  /** Occupations worked or served. These carry levels and are what close a gap. */
  held: Array<SkillEvidenceItem>;
  /**
   * The recommendation: ONE ordered sequence, requirements first, and at most one
   * education step.
   *
   * EMPTY when the learner cannot be assessed, or when no option survives the
   * eligibility and relevance policy. An empty sequence with a stated reason is a
   * valid answer and is preferred to a confident wrong one; the options array is
   * still returned so a caller can show what exists without recommending it.
   */
  nextStep: Array<SkillNextStep>;
  /** What CPD offers that addresses this gap, best first. */
  options: Array<SkillGapOption>;
  /** Programmes the learner intends. Alignment only. */
  planned: Array<SkillEvidenceItem>;
  /**
   * True when the learner's held evidence rates NOTHING the target requires, so
   * every element is UNKNOWN. There is no gap report to give; say so rather than
   * listing skills they may already have.
   */
  profileUnrated: Scalars['Boolean'];
  /**
   * Certificates and licences the target requires, most specific first. Separate
   * from options on purpose: an option is something that TEACHES you, a
   * requirement is a condition on the job. Capped, so read requirementsTotal.
   */
  requirements: Array<SkillRequirement>;
  /** Total requirements before the cap, so nothing is silently truncated. */
  requirementsTotal: Scalars['Int'];
  /** What remains open after the recommended education step. Null when there is none. */
  residual?: Maybe<SkillResidual>;
  /**
   * What the TARGET OCCUPATION requires, most important first. Populated ONLY when
   * the learner cannot be placed against it yet, and it is the point of that case
   * rather than a consolation prize.
   *
   * A job's requirements are known regardless of what the learner has told us, so
   * "we cannot rate you" is the wrong place to stop. Render this as what the role
   * needs, at what level, paired with an invitation to complete the skills survey.
   * It is NOT a list of things they lack: they may already have all of them.
   */
  roleRequirements: Array<SkillRoleElement>;
  summary: SkillGapSummary;
  targetOnetCode?: Maybe<Scalars['String']>;
  targetTitle?: Maybe<Scalars['String']>;
  /** Elements nothing the learner holds rates. Present as 'we cannot say'. */
  unknowns: Array<SkillRoleElement>;
  /**
   * Why they cannot be placed, when profileUnrated is true. NO_EVIDENCE means
   * nothing is on file at all; EVIDENCE_UNSCORED means something is, but it carries
   * no skill ratings. Null when they can be placed.
   */
  unratedReason?: Maybe<SkillUnratedReason>;
  /**
   * Codes on the record that reached no anchor, so coverage can be stated honestly.
   *
   * Counts TWO different things, which resolvedVia distinguishes. A code CPD could
   * not place at all, and a code CPD placed onto something the catalogue says is
   * not an occupation: a military spouse placeholder, a trainee or candidate
   * status, an unassigned billet. Both correctly contribute no skills, but only the
   * first is a lookup failure. The second is the record being accurate about
   * somebody who has not served in a speciality.
   */
  unresolvedCount: Scalars['Int'];
};

/** Counts across the whole profile. Computed by CPD, never by a model. */
export type SkillGapSummary = {
  __typename?: 'SkillGapSummary';
  /** Gap elements the learner's planned programme names. */
  addressedByPlan: Scalars['Int'];
  /** Shortfalls that are APTITUDE requirements, excluded from gaps on purpose. */
  aptitude: Scalars['Int'];
  /** Elements something the learner already completed or holds named. */
  attested: Scalars['Int'];
  covered: Scalars['Int'];
  missing: Scalars['Int'];
  /** Elements with no evidence at all: the learner has told us nothing yet. */
  noEvidence: Scalars['Int'];
  partial: Scalars['Int'];
  total: Scalars['Int'];
  /** Elements nothing the learner holds rates. Never present these as gaps. */
  unknown: Scalars['Int'];
};

/** Why an option cannot be recommended to this learner right now. */
export enum SkillIneligibleReason {
  /** Entry requires an education level above what the record shows. */
  EducationLevel = 'EDUCATION_LEVEL',
  /**
   * A bridge programme, which presupposes a licence the record does not show. The
   * case this exists for is an RN-to-BSN programme offered to somebody who is not
   * a nurse: an education-level check alone passes it.
   */
  LicenceRequired = 'LICENCE_REQUIRED',
  /** The option's curriculum names none of this learner's gap. */
  NamesNoGap = 'NAMES_NO_GAP',
  /**
   * The learner's education level is unknown, so entry cannot be confirmed. NOT
   * the same as ineligible: it is a statement about our record, not about them.
   */
  Unverifiable = 'UNVERIFIABLE'
}

/**
 * How demanding a level is compared with every other occupation, FOR THAT
 * ELEMENT. Banded per element on purpose: level 2.0 is among the highest any job
 * asks for Programming and lower than most jobs for Reading Comprehension, so a
 * single global scale would be just as arbitrary as the raw number.
 */
export enum SkillLevelBand {
  AboveMost = 'ABOVE_MOST',
  AmongHighest = 'AMONG_HIGHEST',
  BelowMost = 'BELOW_MOST',
  Typical = 'TYPICAL'
}

/**
 * One step in the recommendation. Ordered, and never a peer of the others.
 *
 * The flat ranked list this replaces was the defect: it put a licence and a course
 * side by side as though they answered the same question, and it offered 51
 * options at 15% each as though the learner should choose.
 */
export type SkillNextStep = {
  __typename?: 'SkillNextStep';
  /** The learner's highest-priority gap elements this step addresses. */
  addresses: Array<Scalars['String']>;
  /**
   * Why this step, in CPD vocabulary. For an education step this states what the
   * curriculum NAMES. It never claims that finishing the option lifts the learner
   * to the level the occupation requires, because nothing measured supports that.
   */
  because: Scalars['String'];
  displayName: Scalars['String'];
  kind: SkillStepKind;
  /** Set for an EDUCATION step: the option chosen. Null on a REQUIREMENT step. */
  option?: Maybe<SkillGapOption>;
  /** 1-based. Requirements always precede education. */
  order: Scalars['Int'];
  /** The US state this requirement applies in. Null for a national certificate. */
  state?: Maybe<Scalars['String']>;
  /**
   * True when we cannot name one jurisdiction, either because the learner told us
   * nothing or because they named several places they would consider.
   */
  variesByState: Scalars['Boolean'];
};

/** A certificate or licence the target occupation requires. */
export type SkillRequirement = {
  __typename?: 'SkillRequirement';
  displayName: Scalars['String'];
  /**
   * How many DISTINCT occupations claim this same requirement. LOWER IS MORE
   * SPECIFIC, and results are ordered by it. The licence crosswalk has a junk
   * tail (one licence is claimed by 100 occupations), so a high value means "this
   * is listed against many jobs" rather than "this job needs it". Certificates
   * sit at a median of 1 and a p95 of 5; treat that as what specific looks like.
   */
  occupationFanOut?: Maybe<Scalars['Int']>;
  /**
   * TRUE means the learner record shows they hold it. FALSE means CPD has not
   * been told they hold it, which is NOT proof they lack it. Word it as "not on
   * your record", never as "you do not have this".
   */
  onRecord: Scalars['Boolean'];
  /** required (a direct relation in the crosswalk) or related. */
  relation: Scalars['String'];
  requirementKey: Scalars['ID'];
  /** industry_credential or licence. */
  requirementType: Scalars['String'];
  /**
   * The US state this licence applies in. Always set for licences, because every
   * row in the licence crosswalk is state-scoped and there are no national rows.
   * Null for certificates, which are national. Filter on the learner location
   * before presenting licences.
   */
  state?: Maybe<Scalars['String']>;
};

/**
 * What is still open after the recommended step. Stated out loud, never implied.
 *
 * A recommendation that quietly leaves most of a gap unaddressed is the same
 * failure as a percentage rendered as progress. Naming the remainder is what makes
 * the single recommended step honest.
 */
export type SkillResidual = {
  __typename?: 'SkillResidual';
  /** Gap elements the recommended option's curriculum does not name. */
  openElementCount: Scalars['Int'];
  /**
   * Share of the learner's evidenced gap priority left unaddressed. On the same
   * ranking scale as priorityShareNamed, and just as much not a percentage of
   * completion.
   */
  openPriorityShare?: Maybe<Scalars['Float']>;
  /** The highest-priority of those, so the remainder can be named and not just counted. */
  openTop: Array<Scalars['String']>;
};

/**
 * One element of the TARGET occupation's profile, for a learner who cannot be
 * placed against it.
 *
 * A separate type from SkillGapElement on purpose, and the reason is a promise the
 * old shape could not keep. roleRequirements and unknowns were declared as
 * SkillGapElement, whose `status` is non-null, but the service has never had a
 * status to give for these: there is no measurement, which is the whole point of
 * the case. Any client querying that field would have nulled the parent. Nothing
 * consumes it yet, so this corrects the contract rather than breaking one.
 *
 * It carries NO gapLevel, NO status and NO priority, deliberately. An unrated
 * element has no measured shortfall, and inventing a zero would be the exact error
 * the UNKNOWN-is-not-MISSING rule exists to prevent.
 */
export type SkillRoleElement = {
  __typename?: 'SkillRoleElement';
  attestedBasis?: Maybe<SkillEvidenceBasis>;
  /**
   * Something the learner has already COMPLETED or HOLDS names this element: a
   * military course from their JST transcript, a finished degree, a credential.
   *
   * This is the point of the field. A learner whose military occupation carries no
   * skills profile gets no gap report at all, and 2,827 dev learners are in that
   * position. But 370 of them have completed something we CAN read. Without this
   * they see only "we cannot rate you" next to a list of what the job needs; with
   * it they see which of those things their own training already named.
   *
   * It carries NO LEVEL and never will. "Your training covered this" is a
   * different and weaker claim than "you can do this to the standard the job
   * needs", and the gap engine refuses to let attested evidence close a gap
   * precisely so that the two cannot be confused. Word it as covered or studied,
   * never as met or qualified.
   */
  attestedNamesSkill?: Maybe<Scalars['Boolean']>;
  elementId: Scalars['ID'];
  elementName: Scalars['String'];
  elementType: Scalars['String'];
  /** How much the occupation RELIES on this. The only field supporting the word important. */
  requiredImportanceBand?: Maybe<SkillLevelBand>;
  /** The raw O*NET level. Prefer the band in anything a learner reads. */
  requiredLevel?: Maybe<Scalars['Float']>;
  requiredLevelBand?: Maybe<SkillLevelBand>;
};

/** How strong the evidence for an element is, from the learner's own record. */
export enum SkillStatus {
  /** Held evidence meets or exceeds what the occupation requires. */
  Covered = 'COVERED',
  /** Held evidence rates this at zero. */
  Missing = 'MISSING',
  /** The learner has no held evidence whatsoever, so nothing can be said. */
  NoEvidence = 'NO_EVIDENCE',
  /** Held evidence rates this, but below what the occupation requires. */
  Partial = 'PARTIAL',
  /**
   * Nothing the learner holds rates this element at all. NOT the same as MISSING.
   * Rendering these as gaps tells a veteran to go and learn something they may
   * already do, which is the single failure this whole model exists to prevent.
   */
  Unknown = 'UNKNOWN'
}

export enum SkillStepKind {
  /** Something that teaches you, chosen for this learner. */
  Education = 'EDUCATION',
  /**
   * A condition ON THE JOB. Not something that teaches you, and never ranked
   * against the things that do.
   */
  Requirement = 'REQUIREMENT'
}

export enum SkillUnratedReason {
  EvidenceUnscored = 'EVIDENCE_UNSCORED',
  NoEvidence = 'NO_EVIDENCE'
}

export type SkillsCompatibilityAndGoalSelectionInput = {
  academicGoals: Array<Scalars['String']>;
  careerGoal: Scalars['String'];
  careerGoalSkillCompatibility: Array<CareerGoalSkillCompatibilityInput>;
  /** AI-5. Branch, rank and pay grade. Absent for a civilian learner. */
  militaryBackground?: InputMaybe<MilitaryBackgroundReportInput>;
  /**
   * AI-5. The readiness checks the report page shows: what the occupation
   * requires in each area and what the learner's record holds.
   */
  readiness?: InputMaybe<Array<ReadinessAreaReportInput>>;
  userCivilianWorkExperiences: Array<Scalars['String']>;
  userEducationExperiences: Array<Scalars['String']>;
  userWorkExperiences: Array<Scalars['String']>;
  /** AI-5. The occupation's detailed work activities, matched to the learner. */
  workActivitiesMatch?: InputMaybe<Array<WorkActivityMatchReportInput>>;
};

export type SkillsInput = {
  hasCivilianWorkExperience?: InputMaybe<Scalars['Boolean']>;
  hasReturnUrl?: InputMaybe<Scalars['Boolean']>;
  isInterestsSurveyComplete?: InputMaybe<Scalars['Boolean']>;
  isJstUploaded?: InputMaybe<Scalars['Boolean']>;
  isLifestyleSurveyComplete?: InputMaybe<Scalars['Boolean']>;
  isSkillsSurveyComplete?: InputMaybe<Scalars['Boolean']>;
  isWorkValuesSurveyComplete?: InputMaybe<Scalars['Boolean']>;
  militaryBranch?: InputMaybe<MilitaryBranchInput>;
  profileType?: InputMaybe<Scalars['Int']>;
  returnUrlLastSavedDate?: InputMaybe<Scalars['Date']>;
  userEducations?: InputMaybe<Array<EducationInput>>;
  userId?: InputMaybe<Scalars['Int']>;
  userMocs?: InputMaybe<Array<MocInput>>;
  userRanks?: InputMaybe<Array<RankInput>>;
  userWorkExperiences?: InputMaybe<Array<WorkExperienceInput>>;
};

export type Source = {
  __typename?: 'Source';
  name: Scalars['String'];
  type: SourceType;
  url?: Maybe<Scalars['String']>;
};

export type SourceExperience = {
  __typename?: 'SourceExperience';
  advancedCompetencies?: Maybe<Array<Maybe<Competency>>>;
  coreCompetencies?: Maybe<Array<Maybe<Competency>>>;
  title: Scalars['String'];
};

export enum SourceType {
  External = 'EXTERNAL',
  Internal = 'INTERNAL'
}

export type SpacebaseLocation = {
  __typename?: 'SpacebaseLocation';
  active?: Maybe<Scalars['Boolean']>;
  assignedbase?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type SponsorshipCompany = {
  __typename?: 'SponsorshipCompany';
  about?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['Date']>;
  id?: Maybe<Scalars['ID']>;
  link?: Maybe<Scalars['String']>;
  logo?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  photo?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Date']>;
  video?: Maybe<Scalars['String']>;
};

export type StaffAccountRow = {
  __typename?: 'StaffAccountRow';
  accountType: StaffAccountType;
  label: Scalars['String'];
  periodCount: Scalars['Int'];
  totalCount: Scalars['Int'];
};

/** The real staff roles. Reported on their own, never mixed into registrations. */
export enum StaffAccountType {
  Counselor = 'COUNSELOR',
  CounselorAdmin = 'COUNSELOR_ADMIN',
  SuperAdmin = 'SUPER_ADMIN'
}

export type Step = {
  __typename?: 'Step';
  educationLevelId?: Maybe<Scalars['Int']>;
  intro?: Maybe<Scalars['String']>;
  onetSocCode?: Maybe<Scalars['ID']>;
  priority?: Maybe<Scalars['Int']>;
  startNowOccupationOnetSocCode?: Maybe<Scalars['ID']>;
  subtext?: Maybe<Scalars['String']>;
  suggestionType?: Maybe<Scalars['Int']>;
  text?: Maybe<Scalars['String']>;
};

export type SuggestionItem = {
  __typename?: 'SuggestionItem';
  description?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SupportingData = {
  __typename?: 'SupportingData';
  education?: Maybe<EducationData>;
  growth?: Maybe<GrowthData>;
  salary?: Maybe<SalaryData>;
  skills?: Maybe<Array<Scalars['String']>>;
  tasks?: Maybe<Array<Scalars['String']>>;
};

export enum SurveyConstruct {
  Interests = 'INTERESTS',
  Lifestyle = 'LIFESTYLE',
  Skills = 'SKILLS',
  Values = 'VALUES'
}

export type SystemStatusReport = {
  __typename?: 'SystemStatusReport';
  createdat?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  ispublished?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedat?: Maybe<Scalars['String']>;
};

export type SystemStatusReportInput = {
  id?: InputMaybe<Scalars['ID']>;
  ispublished?: InputMaybe<Scalars['Boolean']>;
  message?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type Task = {
  __typename?: 'Task';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  relevance?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

export type TogglePublishAllSystemStatusReportInput = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  publish?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateGoalsResponse = ResponseInterface & {
  __typename?: 'UpdateGoalsResponse';
  code: Scalars['Int'];
  goals?: Maybe<Goals>;
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type UpdateProfileResponse = ResponseInterface & {
  __typename?: 'UpdateProfileResponse';
  code: Scalars['Int'];
  message: Scalars['String'];
  profile?: Maybe<Profile>;
  success: Scalars['Boolean'];
};

export type User = {
  __typename?: 'User';
  profile: Profile;
  refreshToken?: Maybe<Scalars['ID']>;
  token: Scalars['ID'];
  userEmail?: Maybe<Scalars['String']>;
  userId: Scalars['Int'];
  userName?: Maybe<Scalars['String']>;
  userRole?: Maybe<Scalars['String']>;
};

export enum UserActionEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Invited = 'INVITED'
}

export type UserAspiration = {
  __typename?: 'UserAspiration';
  childcarePreference?: Maybe<Scalars['Int']>;
  familyTypePreference?: Maybe<Scalars['Int']>;
  foodPreference?: Maybe<Scalars['Int']>;
  housingPreference?: Maybe<Scalars['Int']>;
  numberOfChildren?: Maybe<Scalars['Int']>;
  spouseIncome?: Maybe<Scalars['Float']>;
  spouseIsEmployed?: Maybe<Scalars['Boolean']>;
  transportationPreference?: Maybe<Scalars['Int']>;
};

export type UserCompetencies = {
  __typename?: 'UserCompetencies';
  sourceExperience?: Maybe<Array<Maybe<SourceExperience>>>;
};

export type UserConnectPreferences = {
  __typename?: 'UserConnectPreferences';
  autoShareEnabled: Scalars['Boolean'];
  connectingUserGoal?: Maybe<ConnectUserGoal>;
  createdAt?: Maybe<Scalars['Date']>;
  hasOutdatedConnection: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export type UserConnectState = {
  __typename?: 'UserConnectState';
  academic: Array<Scalars['ID']>;
  /** CONNECT.1: the schools behind academic, named, newest first. */
  academicConnections: Array<AcademicConnection>;
  /** CONNECT.1: when the member confirmed they are 18 or older; null if never. */
  adultConfirmedAt?: Maybe<Scalars['Date']>;
  autoShareEnabled: Scalars['Boolean'];
  connectingUserGoal?: Maybe<ConnectUserGoal>;
  createdAt?: Maybe<Scalars['Date']>;
  employer: Array<Scalars['ID']>;
  hasOutdatedConnection: Scalars['Boolean'];
  nonprofit: Array<Scalars['ID']>;
  premiumPartnerIds: Array<Scalars['ID']>;
  totalCount: Scalars['Int'];
  updatedAt?: Maybe<Scalars['Date']>;
};

export type UserGoalsInput = {
  careerGoal: Scalars['String'];
  institutionGoal?: InputMaybe<Scalars['String']>;
  programGoal?: InputMaybe<Scalars['String']>;
};

export type UserInterest = {
  __typename?: 'UserInterest';
  abbreviation?: Maybe<Scalars['String']>;
  interestId?: Maybe<Scalars['Int']>;
  interestName?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['Float']>;
};

export type UserInterestSurveyTracker = {
  __typename?: 'UserInterestSurveyTracker';
  createdat?: Maybe<Scalars['String']>;
  finishedat?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  startedat?: Maybe<Scalars['String']>;
};

export type UserInterestSurveyTrackerReponse = ResponseInterface & {
  __typename?: 'UserInterestSurveyTrackerReponse';
  code: Scalars['Int'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
  tracker?: Maybe<UserInterestSurveyTracker>;
};

export type UserPreGoalInput = {
  onetCode?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['Int']>;
};

export type UserPremiumPartnerConnection = {
  __typename?: 'UserPremiumPartnerConnection';
  consentedAt: Scalars['Date'];
  id: Scalars['ID'];
  revokedAt?: Maybe<Scalars['Date']>;
};

export type UserProgramGoalInput = {
  cipCode?: InputMaybe<Scalars['String']>;
  cipTitle?: InputMaybe<Scalars['String']>;
  /**
   * How far the member wants to go, as an api.educationlevel id. Optional, like
   * the other two: any one of the three can be the whole answer.
   *
   * THIS INPUT REPLACES THE WHOLE ROW, which it always has. The upsert behind it
   * sets all of its columns from what is sent, so a caller must send the answer
   * it wants stored in full and never a fragment of it: sending only the level
   * clears the program. That is the same contract the two existing fields have
   * had since the table shipped, and it is safe here because the row is keyed on
   * the member and holds nothing else. It is NOT the hazard that
   * GoalsInput.schoolProgramEdLevelId carries, which replaces the separate
   * api.usergoals row holding the member's real academic goal.
   */
  edLevelId?: InputMaybe<Scalars['Int']>;
};

export type UserReclassifying = {
  __typename?: 'UserReclassifying';
  stayincurrent?: Maybe<Scalars['Boolean']>;
  transitionfrommilitary?: Maybe<Scalars['Boolean']>;
};

export type UserReclassifyingResponse = ResponseInterface & {
  __typename?: 'UserReclassifyingResponse';
  code: Scalars['Int'];
  message: Scalars['String'];
  success: Scalars['Boolean'];
  userReclassifying?: Maybe<UserReclassifying>;
};

export type UserSchoolGoalInput = {
  schoolId?: InputMaybe<Scalars['Int']>;
};

export type UserTerminationInput = {
  numberOfMonthsOfTermination?: InputMaybe<Scalars['Int']>;
};

export type UserWorkValue = {
  __typename?: 'UserWorkValue';
  level?: Maybe<Scalars['Float']>;
  workValueId: Scalars['String'];
  workValueName?: Maybe<Scalars['String']>;
};

export type ValuesInput = {
  level: Scalars['Int'];
  userId?: InputMaybe<Scalars['Int']>;
  workValueId: Scalars['String'];
};

/**
 * ANALYTICS.9a. READ THIS BEFORE QUOTING ANY FIGURE ON THIS TYPE.
 *
 * These totals are NOT all-time, however they read. api.conversations is purged
 * after ninety days by the conversation archive job (STALE_DAYS in
 * conversation-archive.service.ts, which runs at 02:00); the analytics rollup runs
 * at 03:15, reads api.conversations only, and is TRUNCATE-and-rebuild, so it
 * remembers nothing the purge removed. Every count here therefore covers roughly
 * the last ninety days of activity.
 *
 * The purge is deliberate -- data minimisation, tied to VIA-7 and the CUI posture
 * -- and is not going away. analytics.rpt_via_daily now snapshots these aggregates
 * each night so the history survives from 2026-09-17 onward; anything earlier
 * exists only as CSVs in s3://careerpathdecide-media/message-archives-<env>/.
 *
 * Long-run Via trends belong to rpt_via_daily, not to this type.
 */
export type ViaUsageReport = {
  __typename?: 'ViaUsageReport';
  byBranch: Array<AnalyticsNamedValue>;
  byInstallation: Array<AnalyticsLocationRow>;
  conversationSeries: Array<AnalyticsTimePoint>;
  /** Same trend split by branch, for the chart's By Branch tab. */
  conversationSeriesByBranch: Array<AnalyticsTimePoint>;
  conversations: Scalars['Int'];
  /**
   * These three compare ACTIVITY, not the totals above them. Each is the current
   * fiscal quarter to date against the same number of days into the quarter
   * before. Label the card accordingly.
   */
  conversationsDelta?: Maybe<PeriodDelta>;
  /** Conversation-length buckets. The tail says more than the average. */
  depthBuckets: Array<AnalyticsNamedValue>;
  dislikedMessages: Scalars['Int'];
  learnerMessages: Scalars['Int'];
  learners: Scalars['Int'];
  learnersDelta?: Maybe<PeriodDelta>;
  /**
   * DS-T15. The thumbs learners were already giving, which nothing read until
   * now: api.messages has carried liked/disliked all along and the Via report was
   * volume-only by its own admission.
   *
   * Counts of MESSAGES, not conversations, and over the same trailing window as
   * the figures above -- see the note on those. Expect them to be small
   * (production held 13 liked and 5 disliked across 9,477 messages when this
   * shipped) -- small enough that a percentage would overstate its own precision,
   * which is why the page shows counts.
   */
  likedMessages: Scalars['Int'];
  longestConversation: Scalars['Int'];
  /** Two series: asked by the learner, answered by Via. */
  messageSeries: Array<AnalyticsTimePoint>;
  messages: Scalars['Int'];
  messagesDelta?: Maybe<PeriodDelta>;
  messagesPerConversation: Scalars['Float'];
};

export type VideoUsage = {
  __typename?: 'VideoUsage';
  createdat?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Float']>;
  endtype?: Maybe<Scalars['String']>;
  spend?: Maybe<Scalars['Float']>;
  url?: Maybe<Scalars['String']>;
};

export type VideoUsageInput = {
  duration: Scalars['Float'];
  endType?: InputMaybe<Scalars['String']>;
  spend: Scalars['Float'];
  url: Scalars['String'];
};

export type WorkActivityMatchReportInput = {
  matchesUser: Scalars['Boolean'];
  text: Scalars['String'];
};

export type WorkExperience = {
  __typename?: 'WorkExperience';
  id?: Maybe<Scalars['Int']>;
  industryCode?: Maybe<Scalars['String']>;
  numberOfMonthsOfWorkExperience?: Maybe<Scalars['Int']>;
  occupationTitle?: Maybe<Scalars['String']>;
  onetSocCode?: Maybe<Scalars['String']>;
  workExperienceCategoryId?: Maybe<Scalars['String']>;
};

export type WorkExperienceInput = {
  id: Scalars['Int'];
  industryCode?: InputMaybe<Scalars['String']>;
  numberOfMonthsOfWorkExperience?: InputMaybe<Scalars['Int']>;
  occupationTitle?: InputMaybe<Scalars['String']>;
  onetSocCode: Scalars['ID'];
};

export type WorkValuesCompatibility = {
  __typename?: 'WorkValuesCompatibility';
  id?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['Float']>;
  matchesUser?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type WorkValuesCompatibilityInput = {
  goalValues: Array<WorkValuesReportInput>;
  userValues: Array<WorkValuesReportInput>;
};

export type WorkValuesReportInput = {
  level: Scalars['Float'];
  name: Scalars['String'];
};

export type ActionItemFieldsFragment = { __typename?: 'ActionItem', id: string, title: string, notes?: string | null, status: string, category: string, horizon: string, dueOn?: any | null, sortOrder: number, origin: string, suggestionState: string };

export type ActionItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActionItemsQuery = { __typename?: 'Query', actionItems: Array<{ __typename?: 'ActionItem', id: string, title: string, notes?: string | null, status: string, category: string, horizon: string, dueOn?: any | null, sortOrder: number, origin: string, suggestionState: string }>, pendingActionSuggestions: Array<{ __typename?: 'ActionItem', id: string, title: string, notes?: string | null, status: string, category: string, horizon: string, dueOn?: any | null, sortOrder: number, origin: string, suggestionState: string }> };

export type CreateActionItemMutationVariables = Exact<{
  input: ActionItemInput;
}>;


export type CreateActionItemMutation = { __typename?: 'Mutation', createActionItem: { __typename?: 'ActionItem', id: string, title: string, notes?: string | null, status: string, category: string, horizon: string, dueOn?: any | null, sortOrder: number, origin: string, suggestionState: string } };

export type UpdateActionItemMutationVariables = Exact<{
  id: Scalars['ID'];
  input: ActionItemInput;
}>;


export type UpdateActionItemMutation = { __typename?: 'Mutation', updateActionItem?: { __typename?: 'ActionItem', id: string, title: string, notes?: string | null, status: string, category: string, horizon: string, dueOn?: any | null, sortOrder: number, origin: string, suggestionState: string } | null };

export type DeleteActionItemMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteActionItemMutation = { __typename?: 'Mutation', deleteActionItem: boolean };

export type ReorderActionItemsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ReorderActionItemsMutation = { __typename?: 'Mutation', reorderActionItems: Array<{ __typename?: 'ActionItem', id: string, title: string, notes?: string | null, status: string, category: string, horizon: string, dueOn?: any | null, sortOrder: number, origin: string, suggestionState: string }> };

export type ResolveActionSuggestionMutationVariables = Exact<{
  id: Scalars['ID'];
  accept: Scalars['Boolean'];
}>;


export type ResolveActionSuggestionMutation = { __typename?: 'Mutation', resolveActionSuggestion?: { __typename?: 'ActionItem', id: string, title: string, notes?: string | null, status: string, category: string, horizon: string, dueOn?: any | null, sortOrder: number, origin: string, suggestionState: string } | null };

export type DeleteConversationMutationVariables = Exact<{
  conversationId: Scalars['Int'];
}>;


export type DeleteConversationMutation = { __typename?: 'Mutation', deleteConversation: boolean };

export type RateMessageMutationVariables = Exact<{
  messageId: Scalars['Int'];
  liked?: InputMaybe<Scalars['Boolean']>;
  disliked?: InputMaybe<Scalars['Boolean']>;
}>;


export type RateMessageMutation = { __typename?: 'Mutation', rateMessage: { __typename?: 'Message', id: number, liked?: boolean | null, disliked?: boolean | null } };

export type GetConversationHistoryQueryVariables = Exact<{
  conversationId: Scalars['Int'];
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetConversationHistoryQuery = { __typename?: 'Query', getConversationHistory: { __typename?: 'ConversationWithMessages', messageCount?: number | null, conversation: { __typename?: 'Conversation', id: number }, messages: Array<{ __typename?: 'Message', id: number, role: string, content: string, createdAt: string, disliked?: boolean | null, liked?: boolean | null, metadata?: { __typename?: 'MessageMetadata', conversationGoals?: { __typename?: 'ConversationGoals', certificationId?: string | null, schoolId?: string | null, programId?: string | null, onetCode?: string | null, hasChanged?: boolean | null, edlevelId?: string | null } | null, learningSuggestions?: { __typename?: 'LearningSuggestions', certificates?: Array<{ __typename?: 'SuggestionItem', description?: string | null, title?: string | null, url?: string | null }> | null, courses?: Array<{ __typename?: 'SuggestionItem', title?: string | null, description?: string | null, url?: string | null }> | null } | null } | null }> } };

export type GetUserConversationsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type GetUserConversationsQuery = { __typename?: 'Query', getUserConversations: { __typename?: 'ConversationList', conversationCount: number, conversations: Array<{ __typename?: 'Conversation', id: number, title: string, updatedAt: string, lastMessage?: string | null }> } };

export type GetRateLimitQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRateLimitQuery = { __typename?: 'Query', getRateLimit: { __typename?: 'RateLimitResult', allowed: boolean, remaining: number, resetTime: any, limit: number } };

export type GetMaintanceStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMaintanceStatusQuery = { __typename?: 'Query', getMaintanceStatus?: { __typename?: 'MaintanceStatusReponse', id?: string | null, message?: string | null, isactive?: boolean | null, banneractive?: boolean | null, siteblocked?: boolean | null } | null };

export type CognitoCallbackQueryVariables = Exact<{
  cognitoIdToken: Scalars['String'];
}>;


export type CognitoCallbackQuery = { __typename?: 'Query', cognitoCallback: { __typename?: 'CognitoBindingResult', token: string, refreshToken: string } };

export type CredentialRecordsQueryVariables = Exact<{
  onetCode?: InputMaybe<Scalars['String']>;
}>;


export type CredentialRecordsQuery = { __typename?: 'Query', credentialRecords: Array<{ __typename?: 'CredentialRecord', id: string, credentialKey: string, name: string, issuer: string, creditHours?: number | null, creditLevel?: string | null, creditRecommendation?: string | null, aceValidated: boolean, aceCriteria?: string | null, aceReviewedOn?: any | null, employerConfirmed: boolean, employerName?: string | null, employerCriteria?: string | null, employerReviewedOn?: any | null, completionRate?: number | null, placementRate?: number | null, medianEarnings?: number | null, outcomesSource?: string | null, outcomesAsOf?: any | null, pathwayPosition?: number | null, pathwayNote?: string | null }> };

export type ProfileFieldsFragment = { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null };

export type ProfileReportFieldsFragment = { __typename?: 'Profile', profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null };

export type MemberFieldsFragment = { __typename?: 'Profile', userId: number, firstName?: string | null, lastName?: string | null, userRole?: string | null, userEmail?: string | null, status?: string | null, userName?: string | null, isDantesStaff?: boolean | null };

export type MilitaryBranchFieldsFragment = { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null };

export type RankFieldsFragment = { __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null };

export type MocFieldsFragment = { __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null };

export type WorkExperienceFieldsFragment = { __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null };

export type EducationFieldsFragment = { __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null };

export type LocationFieldsFragment = { __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null };

export type InterestFieldsFragment = { __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null };

export type WorkValueFieldsFragment = { __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null };

export type AspirationFieldsFragment = { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null };

export type UserCompetencyFieldsFragment = { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null };

export type CompetencyFieldsFragment = { __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null };

export type AirbaseLocationFieldsFragment = { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null };

export type SpacebaseLocationFieldsFragment = { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null };

export type InstallationLocationFieldsFragment = { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null };

export type GoalsFieldsFragment = { __typename?: 'Goals', jobId?: string | null, occupationTitle?: string | null, onetCode?: string | null, schoolId?: number | null, schoolProgramEdLevelId?: number | null, schoolProgramId?: number | null, schoolProgramTitle?: string | null, schoolProgramRetired?: boolean | null, schoolTitle?: string | null, licenseId?: string | null, certificationId?: number | null, certificationTitle?: string | null, licenseTitle?: string | null, credentialCtid?: string | null, credentialTitle?: string | null, customOnetCode?: string | null, customPathwayId?: string | null };

export type CpdInstitutionFieldsFragment = { __typename?: 'CPDInstitution', schoolId: string, opeid: string, institutionName: string, telephoneNumber?: string | null, website?: string | null, unitid?: string | null, sourceOfAccreditation?: string | null, accreditationType?: string | null, institutionType?: string | null, alignment?: number | null, isOnline?: boolean | null, isOpenAdmissionPolicy?: boolean | null, isTaApproved?: boolean | null, taMouExpirationDate?: string | null, programName?: string | null, costPerSH?: number | null, qualityMetric?: number | null, ageEntry?: number | null, avgCostSH?: number | null, c3yrRepaymentRateIndependentStudents?: number | null, c3yrRepaymentRateIndependentStudentsN?: number | null, creditForLifeExperiences?: boolean | null, creditForMilitaryTraining?: boolean | null, meanEarnings10yearsLaterPercentile?: number | null, meanEarnings10yearsLaterPercentileN?: number | null, partTime8yrAward?: number | null, partTime8yrAwardN?: number | null, partTimeRetentionRate?: number | null, partTimeRetentionRateN?: number | null, pctOfDistanceLearners?: number | null, pctOfPartiallyDistanceLearners?: number | null, pctOfTaFundedCoursesCompletedSuccessfully?: number | null, pctOfTaFundedCoursesCompletedSuccessfullyN?: number | null, schoolPlacementServices?: boolean | null, is2year?: boolean | null, pocName?: string | null, pocTitle?: string | null, pocPhone?: string | null, pocExt?: string | null, pocEmail?: string | null, dedicatedPOCforServicemembers?: boolean | null, address?: { __typename?: 'Address', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null };

export type NewsFieldsFragment = { __typename?: 'NewsItem', id?: number | null, title?: string | null, description?: string | null, type?: string | null, reaction?: number | null, createdAt?: any | null };

export type NewsTypeFieldsFragment = { __typename?: 'NewsTypesItem', id?: number | null, title?: string | null };

export type PathwayFieldsFragment = { __typename?: 'CareerPathway', prodPublish?: boolean | null, devPublish?: boolean | null, pathwayId: string, name?: string | null, imageUrl?: string | null, description?: string | null, maxSalary?: number | null, skillsmatch?: number | null, interestsmatch?: number | null, valuesmatch?: number | null, lifestylematch?: number | null, videoUrl?: string | null, levels?: Array<{ __typename?: 'PathwayLevel', ordinal?: number | null, title?: string | null, occupations?: Array<{ __typename?: 'CPBCustomOccupation', onetCode: string, alternateTitle?: string | null, imageUrl?: string | null, onetTitle?: string | null, projectedGrowthRate?: string | null, relatedTo?: Array<string | null> | null, parentOnetCode?: string | null, interestsMatch?: number | null, valuesMatch?: number | null, typicalWorkExperienceGroup?: string | null, skillsMatch?: number | null, lifestyleMatch?: number | null, interestsMatchQualityId?: number | null, lifestyleMatchQualityId?: number | null, skillsMatchQualityId?: number | null, valuesMatchQualityId?: number | null, salaryAnalysis?: { __typename?: 'SalaryAnalysis', minimumAnnualSalary?: number | null, medianAnnualSalary?: number | null, maximumAnnualSalary?: number | null } | null } | null> | null } | null> | null, sponsorshipCompany?: { __typename?: 'SponsorshipCompany', about?: string | null, createdAt?: any | null, id?: string | null, link?: string | null, logo?: string | null, name?: string | null, photo?: string | null, updatedAt?: any | null, video?: string | null } | null };

export type CpdProgramFieldsFragment = { __typename?: 'CPDProgram', opeid: string, programName?: string | null, cipCode?: string | null, schoolId?: number | null, schoolProgramId?: number | null, schoolProgramEdLevelId?: number | null, isOnline?: boolean | null, qualityMetric?: number | null, alignment?: number | null, definition?: string | null, officialTitle?: string | null, schoolCount?: number | null };

export type UpdateProfileResponseFieldsFragment = { __typename?: 'UpdateProfileResponse', profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null };

export type FeedbackForAdminFieldsFragment = { __typename?: 'FeedbackForAdmin', moctitle?: string | null, recommendrating?: number | null, comment?: string | null, routeurl?: string | null, createdtimestamp?: string | null };

export type BugReportFieldsFragment = { __typename?: 'BugReport', buglocation?: string | null, createdat?: string | null, id?: string | null, isviewed?: boolean | null, message?: string | null, updatedat?: string | null };

export type SystemStatusReportFragment = { __typename?: 'SystemStatusReport', id?: string | null, title?: string | null, message?: string | null, ispublished?: boolean | null, createdat?: string | null, updatedat?: string | null };

export type OccupationFieldsFragment = { __typename?: 'CPDOccupation', onetCode: string, cpbonetcode?: string | null, isPathway?: boolean | null, medianAnnualWage?: number | null, highSalary?: number | null, lowSalary?: number | null, title?: string | null, alternateTitles?: Array<string | null> | null, jobId?: number | null, jobOpenings?: number | null, description?: string | null, projectedGrowth?: number | null, growthRateBand?: string | null, typicalWorkExperienceGroupId?: number | null, preferredEdLevelDescription?: string | null, careerCluster?: string | null, skillsMatchQualityIdAi?: number | null, skillsMatchQualityId?: number | null, interestsMatchQualityId?: number | null, valuesMatchQualityId?: number | null, lifestyleMatchQualityId?: number | null, isOverqualified?: boolean | null, showInstitutionPrograms?: boolean | null, schoolProgramEdLevels?: string | null, videoUrl?: string | null, educationLevelDistribution?: Array<{ __typename?: 'EducationLevel', educationLevelName?: string | null, percentage?: number | null } | null> | null, hotSpots?: Array<{ __typename?: 'HotSpotLocation', demand?: string | null, fipsCode?: string | null, isHomeArea?: boolean | null, lat?: number | null, lon?: number | null, name?: string | null, salary?: string | null, z?: number | null } | null> | null, certificates: Array<{ __typename?: 'CPDCertificate', certId?: string | null, certName?: string | null, certifyingOrgName?: string | null } | null>, licenses: Array<{ __typename?: 'CPDLicense', id: string, licId?: string | null, licName?: string | null, licOrgName?: string | null, state?: string | null } | null>, tasks: Array<{ __typename?: 'Task', description?: string | null } | null>, readinessEvaluation?: Array<{ __typename?: 'Evaluation', itemType?: number | null, userHas?: string | null, isPositiveOutcome?: boolean | null, occupationRequiresObject?: Array<{ __typename?: 'EvaluationObject', id?: number | null, title?: string | null, details?: string | null, detailsArray?: Array<string | null> | null, isMatched?: boolean | null, items?: Array<{ __typename?: 'EvaluationItem', id?: string | null, title?: string | null, isMatched?: boolean | null } | null> | null } | null> | null, otherAlignments?: Array<{ __typename?: 'EvaluationOtherAlignments', id: string, title: string } | null> | null } | null> | null, skills?: Array<{ __typename?: 'Skill', skillId?: string | null, skillType?: number | null, count?: number | null, label?: string | null, description?: string | null, source?: string | null } | null> | null, ksas?: Array<{ __typename?: 'OccupationKsa', id: string, name: string, description?: string | null, type: string, importance?: number | null, level?: number | null, matchStatus?: KsaMatchStatus | null, displayTier?: string | null, matchSources?: Array<{ __typename?: 'KsaMatchSource', channel: KsaMatchChannel, name?: string | null }> | null }> | null, similarOccupations?: Array<{ __typename?: 'CPDOccupation', onetCode: string, title?: string | null, isFavorite?: boolean | null, jobId?: number | null, medianAnnualWage?: number | null, medianHourlyWage?: number | null, imageName?: string | null, typicalEducationLevelGroup?: string | null, growthRateBand?: string | null, skillsMatchQualityId?: number | null, interestsMatchQualityId?: number | null, valuesMatchQualityId?: number | null, lifestyleMatchQualityId?: number | null } | null> | null };

export type OccupationCardFieldsFragment = { __typename?: 'OccupationCard', onetCode: string, title?: string | null, isFavorite?: boolean | null, jobId?: number | null, medianAnnualWage?: number | null, medianHourlyWage?: number | null, imageName?: string | null, typicalEducationLevelGroup?: string | null, growthRateBand?: string | null, skillsMatchQualityId?: number | null, interestsMatchQualityId?: number | null, valuesMatchQualityId?: number | null, lifestyleMatchQualityId?: number | null, occupationCardCategoryType?: OccupationCardCategoryType | null };

export type FavoriteOccupationFieldsFragment = { __typename?: 'FavoriteOccupation', onetSocCode: string, jobId?: number | null, title?: string | null, growthRateBand?: string | null, medianAnnualWage?: number | null, medianHourlyWage?: number | null, imageName?: string | null, skillsMatchQualityId?: number | null, interestsMatchQualityId?: number | null, valuesMatchQualityId?: number | null, lifestyleMatchQualityId?: number | null, isMatch?: boolean | null, isOverqualified?: boolean | null, isFavorite?: boolean | null, preferredEdLevelDescription?: string | null };

export type MyFrontDoorQueryVariables = Exact<{ [key: string]: never; }>;


export type MyFrontDoorQuery = { __typename?: 'Query', myFrontDoor?: { __typename?: 'FrontDoorAnswers', intent: string, intentText?: string | null, answeredAt?: string | null } | null };

export type SaveFrontDoorMutationVariables = Exact<{
  input: FrontDoorInput;
}>;


export type SaveFrontDoorMutation = { __typename?: 'Mutation', saveFrontDoor?: { __typename?: 'FrontDoorAnswers', intent: string, intentText?: string | null, answeredAt?: string | null } | null };

export type GoalsReportDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type GoalsReportDetailsQuery = { __typename?: 'Query', goalsReportDetails?: { __typename?: 'GoalsReportDetails', returnLink?: string | null, generatedReportDate?: string | null } | null };

export type SaveUserPreGoalsMutationVariables = Exact<{
  values: UserPreGoalInput;
}>;


export type SaveUserPreGoalsMutation = { __typename?: 'Mutation', saveUserPreGoals?: { __typename?: 'UpdateProfileResponse', success: boolean, profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null } | null };

export type GetGoalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetGoalsQuery = { __typename?: 'Query', goals: { __typename?: 'Goals', jobId?: string | null, occupationTitle?: string | null, onetCode?: string | null, schoolId?: number | null, schoolProgramEdLevelId?: number | null, schoolProgramId?: number | null, schoolProgramTitle?: string | null, schoolProgramRetired?: boolean | null, schoolTitle?: string | null, licenseId?: string | null, certificationId?: number | null, certificationTitle?: string | null, licenseTitle?: string | null, credentialCtid?: string | null, credentialTitle?: string | null, customOnetCode?: string | null, customPathwayId?: string | null } };

export type UpdateGoalsMutationVariables = Exact<{
  goals: GoalsInput;
}>;


export type UpdateGoalsMutation = { __typename?: 'Mutation', updateGoals?: { __typename?: 'UpdateGoalsResponse', success: boolean, message: string, code: number, goals?: { __typename?: 'Goals', jobId?: string | null, occupationTitle?: string | null, onetCode?: string | null, schoolId?: number | null, schoolProgramEdLevelId?: number | null, schoolProgramId?: number | null, schoolProgramTitle?: string | null, schoolProgramRetired?: boolean | null, schoolTitle?: string | null, licenseId?: string | null, certificationId?: number | null, certificationTitle?: string | null, licenseTitle?: string | null, credentialCtid?: string | null, credentialTitle?: string | null, customOnetCode?: string | null, customPathwayId?: string | null } | null } | null };

export type UpdateAiDeepInsightReportMutationVariables = Exact<{
  conversationId: Scalars['Int'];
  messageId: Scalars['Int'];
}>;


export type UpdateAiDeepInsightReportMutation = { __typename?: 'Mutation', updateAIDeepInsightReport?: { __typename?: 'AIDeepInsights', learningSuggestions?: { __typename?: 'LearningSuggestions', certificates?: Array<{ __typename?: 'SuggestionItem', description?: string | null, title?: string | null, url?: string | null }> | null, courses?: Array<{ __typename?: 'SuggestionItem', title?: string | null, description?: string | null, url?: string | null }> | null } | null } | null };

export type GetAiDeepInsightQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAiDeepInsightQuery = { __typename?: 'Query', getAiDeepInsight?: { __typename?: 'AIDeepInsights', learningSuggestions?: { __typename?: 'LearningSuggestions', courses?: Array<{ __typename?: 'SuggestionItem', description?: string | null, title?: string | null, url?: string | null }> | null, certificates?: Array<{ __typename?: 'SuggestionItem', description?: string | null, title?: string | null, url?: string | null }> | null } | null } | null };

export type GenAiGoalsReportMutationVariables = Exact<{
  surveyData: AiGoalsReportInput;
  forceUpdate?: InputMaybe<Scalars['Boolean']>;
}>;


export type GenAiGoalsReportMutation = { __typename?: 'Mutation', genAiGoalsReport?: { __typename: 'AIGoalsReportInsight', outdated?: boolean | null, status?: string | null, narratives?: { __typename?: 'Narratives', academicGoal?: Array<{ __typename?: 'NarrativePhrase', content: string, insights?: string | null, type: string }> | null, careerGoal?: Array<{ __typename?: 'NarrativePhrase', content: string, insights?: string | null, type: string }> | null, compatibility?: Array<{ __typename?: 'NarrativePhrase', content: string, insights?: string | null, type: string }> | null, experience?: Array<{ __typename?: 'NarrativePhrase', content: string, insights?: string | null, type: string }> | null, decisionProcess?: Array<{ __typename?: 'NarrativePhrase', content: string, insights?: string | null, type: string }> | null, interests?: Array<{ __typename?: 'NarrativePhrase', content: string, insights?: string | null, type: string }> | null, values?: Array<{ __typename?: 'NarrativePhrase', content: string, insights?: string | null, type: string }> | null, lifestylePreferences?: Array<{ __typename?: 'NarrativePhrase', content: string, insights?: string | null, type: string }> | null, motivations?: Array<{ __typename?: 'NarrativePhrase', content: string, insights?: string | null, type: string }> | null, currentStage?: Array<{ __typename?: 'NarrativePhrase', content: string, insights?: string | null, type: string }> | null, location?: Array<{ __typename?: 'NarrativePhrase', content: string, insights?: string | null, type: string }> | null, funding?: Array<{ __typename?: 'NarrativePhrase', content: string, insights?: string | null, type: string }> | null, supports?: Array<{ __typename?: 'NarrativePhrase', content: string, insights?: string | null, type: string }> | null, constraints?: Array<{ __typename?: 'NarrativePhrase', content: string, insights?: string | null, type: string }> | null } | null, relatedTopics?: Array<{ __typename?: 'InsightKey', description: string, title: string }> | null, rateLimit?: { __typename?: 'RateLimitResult', allowed: boolean, limit: number, remaining: number, resetTime: any } | null, writtenFor?: { __typename?: 'InsightWrittenFor', careerGoal?: string | null, institutionGoal?: string | null, programGoal?: string | null } | null } | null };

export type UserReclassifyingQueryVariables = Exact<{ [key: string]: never; }>;


export type UserReclassifyingQuery = { __typename?: 'Query', userReclassifying?: { __typename?: 'UserReclassifyingResponse', code: number, success: boolean, message: string, userReclassifying?: { __typename?: 'UserReclassifying', transitionfrommilitary?: boolean | null, stayincurrent?: boolean | null } | null } | null };

export type HelpArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type HelpArticlesQuery = { __typename?: 'Query', helpArticles: Array<{ __typename?: 'HelpArticle', id: string, panel: string, audience: string, kind: string, title: string, summary?: string | null, body: string, videoUrl?: string | null, captionsUrl?: string | null, transcript?: string | null, updatedAt?: any | null }> };

export type InstitutionsByOccupationQueryVariables = Exact<{
  onetCode: Scalars['ID'];
  cipCodeCutoff: CipCodeCutoffFilter;
  educationLevel?: InputMaybe<EducationLevelFilter>;
  online?: InputMaybe<Scalars['Boolean']>;
  openAdmission?: InputMaybe<Scalars['Boolean']>;
  regionalAccreditation?: InputMaybe<Scalars['Boolean']>;
  avarageCost?: InputMaybe<Scalars['Boolean']>;
  medianDebt?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  graduationRate?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
  searchTerm?: InputMaybe<Scalars['String']>;
  taApproved?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  schoolProgramId?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  allSchools?: InputMaybe<Scalars['Boolean']>;
}>;


export type InstitutionsByOccupationQuery = { __typename?: 'Query', institutionsByOccupation?: { __typename?: 'CPDInstitutionPage', totalCount: number, items?: Array<{ __typename?: 'CPDInstitution', schoolId: string, opeid: string, institutionName: string, telephoneNumber?: string | null, website?: string | null, unitid?: string | null, sourceOfAccreditation?: string | null, accreditationType?: string | null, institutionType?: string | null, alignment?: number | null, isOnline?: boolean | null, isOpenAdmissionPolicy?: boolean | null, isTaApproved?: boolean | null, taMouExpirationDate?: string | null, programName?: string | null, costPerSH?: number | null, qualityMetric?: number | null, ageEntry?: number | null, avgCostSH?: number | null, c3yrRepaymentRateIndependentStudents?: number | null, c3yrRepaymentRateIndependentStudentsN?: number | null, creditForLifeExperiences?: boolean | null, creditForMilitaryTraining?: boolean | null, meanEarnings10yearsLaterPercentile?: number | null, meanEarnings10yearsLaterPercentileN?: number | null, partTime8yrAward?: number | null, partTime8yrAwardN?: number | null, partTimeRetentionRate?: number | null, partTimeRetentionRateN?: number | null, pctOfDistanceLearners?: number | null, pctOfPartiallyDistanceLearners?: number | null, pctOfTaFundedCoursesCompletedSuccessfully?: number | null, pctOfTaFundedCoursesCompletedSuccessfullyN?: number | null, schoolPlacementServices?: boolean | null, is2year?: boolean | null, pocName?: string | null, pocTitle?: string | null, pocPhone?: string | null, pocExt?: string | null, pocEmail?: string | null, dedicatedPOCforServicemembers?: boolean | null, address?: { __typename?: 'Address', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null> | null } | null };

export type SchoolDetailsQueryVariables = Exact<{
  schoolId: Scalars['ID'];
}>;


export type SchoolDetailsQuery = { __typename?: 'Query', schoolDetails?: { __typename?: 'CPDInstitution', schoolId: string, opeid: string, institutionName: string, telephoneNumber?: string | null, website?: string | null, unitid?: string | null, sourceOfAccreditation?: string | null, accreditationType?: string | null, institutionType?: string | null, alignment?: number | null, isOnline?: boolean | null, isOpenAdmissionPolicy?: boolean | null, isTaApproved?: boolean | null, taMouExpirationDate?: string | null, programName?: string | null, costPerSH?: number | null, qualityMetric?: number | null, ageEntry?: number | null, avgCostSH?: number | null, c3yrRepaymentRateIndependentStudents?: number | null, c3yrRepaymentRateIndependentStudentsN?: number | null, creditForLifeExperiences?: boolean | null, creditForMilitaryTraining?: boolean | null, meanEarnings10yearsLaterPercentile?: number | null, meanEarnings10yearsLaterPercentileN?: number | null, partTime8yrAward?: number | null, partTime8yrAwardN?: number | null, partTimeRetentionRate?: number | null, partTimeRetentionRateN?: number | null, pctOfDistanceLearners?: number | null, pctOfPartiallyDistanceLearners?: number | null, pctOfTaFundedCoursesCompletedSuccessfully?: number | null, pctOfTaFundedCoursesCompletedSuccessfullyN?: number | null, schoolPlacementServices?: boolean | null, is2year?: boolean | null, pocName?: string | null, pocTitle?: string | null, pocPhone?: string | null, pocExt?: string | null, pocEmail?: string | null, dedicatedPOCforServicemembers?: boolean | null, address?: { __typename?: 'Address', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null };

export type InstitutionProgramsQueryVariables = Exact<{
  schoolId: Scalars['Int'];
  onetCode: Scalars['ID'];
  cipCodeCutoff: CipCodeCutoffFilter;
  educationLevel?: InputMaybe<EducationLevelFilter>;
  online?: InputMaybe<Scalars['Boolean']>;
  medianEarnings?: InputMaybe<Array<InputMaybe<Scalars['Int']>> | InputMaybe<Scalars['Int']>>;
}>;


export type InstitutionProgramsQuery = { __typename?: 'Query', institutionPrograms: Array<{ __typename?: 'CPDProgram', opeid: string, programName?: string | null, cipCode?: string | null, schoolId?: number | null, schoolProgramId?: number | null, schoolProgramEdLevelId?: number | null, isOnline?: boolean | null, qualityMetric?: number | null, alignment?: number | null, definition?: string | null, officialTitle?: string | null, schoolCount?: number | null }> };

export type InstitutionsByProgramQueryVariables = Exact<{
  programCipCode: Scalars['String'];
  programName: Scalars['String'];
  educationLevel: EducationLevelFilter;
  searchTerm?: InputMaybe<Scalars['String']>;
  online?: InputMaybe<Scalars['Boolean']>;
  openAdmission?: InputMaybe<Scalars['Boolean']>;
  regionalAccreditation?: InputMaybe<Scalars['Boolean']>;
  taApproved?: InputMaybe<Scalars['Boolean']>;
}>;


export type InstitutionsByProgramQuery = { __typename?: 'Query', institutionsByProgram?: Array<{ __typename?: 'CPDInstitution', schoolId: string, opeid: string, institutionName: string, telephoneNumber?: string | null, website?: string | null, unitid?: string | null, sourceOfAccreditation?: string | null, accreditationType?: string | null, institutionType?: string | null, alignment?: number | null, isOnline?: boolean | null, isOpenAdmissionPolicy?: boolean | null, isTaApproved?: boolean | null, taMouExpirationDate?: string | null, programName?: string | null, costPerSH?: number | null, qualityMetric?: number | null, ageEntry?: number | null, avgCostSH?: number | null, c3yrRepaymentRateIndependentStudents?: number | null, c3yrRepaymentRateIndependentStudentsN?: number | null, creditForLifeExperiences?: boolean | null, creditForMilitaryTraining?: boolean | null, meanEarnings10yearsLaterPercentile?: number | null, meanEarnings10yearsLaterPercentileN?: number | null, partTime8yrAward?: number | null, partTime8yrAwardN?: number | null, partTimeRetentionRate?: number | null, partTimeRetentionRateN?: number | null, pctOfDistanceLearners?: number | null, pctOfPartiallyDistanceLearners?: number | null, pctOfTaFundedCoursesCompletedSuccessfully?: number | null, pctOfTaFundedCoursesCompletedSuccessfullyN?: number | null, schoolPlacementServices?: boolean | null, is2year?: boolean | null, pocName?: string | null, pocTitle?: string | null, pocPhone?: string | null, pocExt?: string | null, pocEmail?: string | null, dedicatedPOCforServicemembers?: boolean | null, address?: { __typename?: 'Address', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, state?: string | null, zip?: string | null } | null } | null> | null };

export type SearchSchoolsQueryVariables = Exact<{
  searchTerm: Scalars['String'];
}>;


export type SearchSchoolsQuery = { __typename?: 'Query', searchSchools: { __typename?: 'SearchSchoolResult', search: Array<{ __typename?: 'School', id: string, name?: string | null }>, fuzzy: Array<{ __typename?: 'School', id: string, name?: string | null }> } };

export type SchoolProgramFitQueryVariables = Exact<{
  schoolId: Scalars['Int'];
  schoolProgramId: Scalars['Int'];
  schoolProgramEdLevelId?: InputMaybe<Scalars['Int']>;
  onetCode: Scalars['ID'];
}>;


export type SchoolProgramFitQuery = { __typename?: 'Query', schoolProgramFit: { __typename?: 'SchoolProgramFit', offered: boolean, offeredProgramId?: number | null, suggestions: Array<{ __typename?: 'SchoolProgramSuggestion', schoolProgramId: number, programName: string, cipCode?: string | null, schoolProgramEdLevelId?: number | null, alignment?: number | null }> } };

export type SearchLocationsQueryVariables = Exact<{
  searchTerm: Scalars['String'];
}>;


export type SearchLocationsQuery = { __typename?: 'Query', searchLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }> };

export type LocationByAttributeQueryVariables = Exact<{
  onetCodeDemand?: InputMaybe<Scalars['ID']>;
  highVetPercent?: InputMaybe<Scalars['Boolean']>;
  lowCostOfLiving?: InputMaybe<Scalars['Boolean']>;
  lowUnemployment?: InputMaybe<Scalars['Boolean']>;
  affordableRealEstate?: InputMaybe<Scalars['Boolean']>;
  lowCrimeRate?: InputMaybe<Scalars['Boolean']>;
  goodAirQuality?: InputMaybe<Scalars['Boolean']>;
}>;


export type LocationByAttributeQuery = { __typename?: 'Query', locationByAttribute: Array<{ __typename?: 'LocationAttribute', costOfLiving?: number | null, crimeRate?: number | null, demand?: number | null, fipsCode: string, housingCostIndex?: number | null, lat?: number | null, lon?: number | null, name: string, pctOfGoodAirQualityDays?: number | null, unemploymentRate?: number | null, veteranPopulation?: number | null }> };

export type NoteMagicLinkRequestMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type NoteMagicLinkRequestMutation = { __typename?: 'Mutation', noteMagicLinkRequest: boolean };

export type SearchMajorsQueryVariables = Exact<{
  searchTerm: Scalars['String'];
}>;


export type SearchMajorsQuery = { __typename?: 'Query', searchMajors: Array<{ __typename?: 'Major', id: string, name?: string | null }> };

export type AirbaseLocationsQueryVariables = Exact<{
  searchTerm: Scalars['String'];
}>;


export type AirbaseLocationsQuery = { __typename?: 'Query', airbaseLocations: Array<{ __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null> };

export type SaveUserAirbaseLocationMutationVariables = Exact<{
  airbaseLocationId: Scalars['ID'];
}>;


export type SaveUserAirbaseLocationMutation = { __typename?: 'Mutation', saveUserAirbaseLocation?: { __typename?: 'UpdateProfileResponse', success: boolean, message: string, code: number, profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null } | null };

export type InstallationLocationsQueryVariables = Exact<{
  branchCode: Scalars['String'];
  searchTerm?: InputMaybe<Scalars['String']>;
}>;


export type InstallationLocationsQuery = { __typename?: 'Query', installationLocations: Array<{ __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null> };

export type SaveUserInstallationMutationVariables = Exact<{
  installationId: Scalars['ID'];
}>;


export type SaveUserInstallationMutation = { __typename?: 'Mutation', saveUserInstallation?: { __typename?: 'UpdateProfileResponse', success: boolean, message: string, code: number, profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null } | null };

export type MilitaryServeTypeQueryVariables = Exact<{
  branchCode: Scalars['String'];
}>;


export type MilitaryServeTypeQuery = { __typename?: 'Query', militaryServeType?: Array<{ __typename?: 'MilitaryServeType', branchCode?: string | null, name?: string | null, id?: number | null } | null> | null };

export type SaveUserMilitaryServeTypeMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type SaveUserMilitaryServeTypeMutation = { __typename?: 'Mutation', saveUserMilitaryServeType?: { __typename?: 'UpdateProfileResponse', success: boolean, message: string, code: number, profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null } | null };

export type SpacebaseLocationsQueryVariables = Exact<{
  searchTerm: Scalars['String'];
}>;


export type SpacebaseLocationsQuery = { __typename?: 'Query', spacebaseLocations: Array<{ __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null> };

export type SaveUserSpacebaseLocationMutationVariables = Exact<{
  spacebaseLocationId: Scalars['ID'];
}>;


export type SaveUserSpacebaseLocationMutation = { __typename?: 'Mutation', saveUserSpacebaseLocation?: { __typename?: 'UpdateProfileResponse', success: boolean, message: string, code: number, profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null } | null };

export type NewsQueryVariables = Exact<{ [key: string]: never; }>;


export type NewsQuery = { __typename?: 'Query', news?: Array<{ __typename?: 'NewsItem', id?: number | null, title?: string | null, description?: string | null, type?: string | null, reaction?: number | null, createdAt?: any | null } | null> | null, newsTypes?: Array<{ __typename?: 'NewsTypesItem', id?: number | null, title?: string | null } | null> | null };

export type ReactOnNewsMutationVariables = Exact<{
  input?: InputMaybe<NewsReactionInput>;
}>;


export type ReactOnNewsMutation = { __typename?: 'Mutation', reactOnNews?: { __typename?: 'NewsItem', id?: number | null, title?: string | null, description?: string | null, type?: string | null, reaction?: number | null, createdAt?: any | null } | null };

export type NotificationFieldsFragment = { __typename?: 'Notification', id: string, kind: NotificationKind, title: string, body?: string | null, createdAt: any, destinationLabel?: string | null, destinationPath?: string | null, dismissedAt?: any | null };

export type GetNotificationsQueryVariables = Exact<{
  includeDismissed?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetNotificationsQuery = { __typename?: 'Query', notifications: Array<{ __typename?: 'Notification', id: string, kind: NotificationKind, title: string, body?: string | null, createdAt: any, destinationLabel?: string | null, destinationPath?: string | null, dismissedAt?: any | null }> };

export type DismissNotificationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DismissNotificationMutation = { __typename?: 'Mutation', dismissNotification: { __typename?: 'DismissNotificationResponse', success: boolean, notification?: { __typename?: 'Notification', id: string, kind: NotificationKind, title: string, body?: string | null, createdAt: any, destinationLabel?: string | null, destinationPath?: string | null, dismissedAt?: any | null } | null } };

export type OccupationListHighGrowthQueryVariables = Exact<{ [key: string]: never; }>;


export type OccupationListHighGrowthQuery = { __typename?: 'Query', getOccupationList?: Array<{ __typename?: 'CPDOccupation', onetCode: string, description?: string | null, title?: string | null, projectedGrowth?: number | null, growthRateBand?: string | null, militaryOccupationCount?: number | null, annualWageLower?: number | null, annualWageHighest?: number | null, medianAnnualWage?: number | null, imageName?: string | null, videoId?: string | null, alternateTitle?: string | null } | null> | null };

export type OccupationListMilitaryFriendlyQueryVariables = Exact<{ [key: string]: never; }>;


export type OccupationListMilitaryFriendlyQuery = { __typename?: 'Query', getOccupationList?: Array<{ __typename?: 'CPDOccupation', onetCode: string, description?: string | null, title?: string | null, projectedGrowth?: number | null, growthRateBand?: string | null, militaryOccupationCount?: number | null, annualWageLower?: number | null, annualWageHighest?: number | null, medianAnnualWage?: number | null, imageName?: string | null, videoId?: string | null, alternateTitle?: string | null } | null> | null };

export type GetOccupationListByCountyQueryVariables = Exact<{
  param: Scalars['String'];
}>;


export type GetOccupationListByCountyQuery = { __typename?: 'Query', getOccupationList?: Array<{ __typename?: 'CPDOccupation', onetCode: string, description?: string | null, title?: string | null, alternateTitle?: string | null, projectedGrowth?: number | null, growthRateBand?: string | null, militaryOccupationCount?: number | null, annualWageLower?: number | null, annualWageHighest?: number | null, medianAnnualWage?: number | null, imageName?: string | null, videoId?: string | null, typicalWorkExperienceCategoryTypeId?: number | null, typicalWorkExperienceCategoryTypeName?: string | null } | null> | null };

export type GetOccupationListByDegreeQueryVariables = Exact<{
  param: Scalars['String'];
}>;


export type GetOccupationListByDegreeQuery = { __typename?: 'Query', getOccupationList?: Array<{ __typename?: 'CPDOccupation', onetCode: string, description?: string | null, title?: string | null, alternateTitle?: string | null, projectedGrowth?: number | null, growthRateBand?: string | null, militaryOccupationCount?: number | null, annualWageLower?: number | null, annualWageHighest?: number | null, medianAnnualWage?: number | null, imageName?: string | null, videoId?: string | null, typicalWorkExperienceCategoryTypeId?: number | null, typicalWorkExperienceCategoryTypeName?: string | null } | null> | null };

export type GetOccupationCardsQueryVariables = Exact<{
  state?: InputMaybe<Scalars['String']>;
}>;

export type OccupationStatePayQueryVariables = Exact<{
  state: Scalars['String'];
  onetCodes: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type OccupationStatePayStatesQueryVariables = Exact<{
  onetCodes: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type OccupationStatePayStatesQuery = { __typename?: 'Query', occupationStatePayStates: Array<{ __typename?: 'StatePayCoverage', state: string, occupationCount: number }> };

export type OccupationStatePayQuery = { __typename?: 'Query', occupationStatePay: Array<{ __typename?: 'OccupationStatePay', onetCode: string, state: string, medianAnnualWage: number, areaCount: number }> };


export type GetOccupationCardsQuery = { __typename?: 'Query', getOccupationCards?: Array<{ __typename?: 'OccupationCard', industryCode?: number | null, industry?: string | null, wageState?: string | null, onetCode: string, title?: string | null, isFavorite?: boolean | null, jobId?: number | null, medianAnnualWage?: number | null, medianHourlyWage?: number | null, imageName?: string | null, typicalEducationLevelGroup?: string | null, growthRateBand?: string | null, skillsMatchQualityId?: number | null, interestsMatchQualityId?: number | null, valuesMatchQualityId?: number | null, lifestyleMatchQualityId?: number | null, occupationCardCategoryType?: OccupationCardCategoryType | null } | null> | null };

export type FavoriteOccupationsQueryVariables = Exact<{ [key: string]: never; }>;


export type FavoriteOccupationsQuery = { __typename?: 'Query', favoriteOccupations: Array<{ __typename?: 'FavoriteOccupation', onetSocCode: string, jobId?: number | null, title?: string | null, growthRateBand?: string | null, medianAnnualWage?: number | null, medianHourlyWage?: number | null, imageName?: string | null, skillsMatchQualityId?: number | null, interestsMatchQualityId?: number | null, valuesMatchQualityId?: number | null, lifestyleMatchQualityId?: number | null, isMatch?: boolean | null, isOverqualified?: boolean | null, isFavorite?: boolean | null, preferredEdLevelDescription?: string | null }> };

export type GetOccupationDetailQueryVariables = Exact<{
  onetCode: Scalars['ID'];
  jobId?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
}>;


export type GetOccupationDetailQuery = { __typename?: 'Query', occupation?: { __typename?: 'CPDOccupation', onetCode: string, cpbonetcode?: string | null, isPathway?: boolean | null, medianAnnualWage?: number | null, highSalary?: number | null, lowSalary?: number | null, title?: string | null, alternateTitles?: Array<string | null> | null, jobId?: number | null, jobOpenings?: number | null, description?: string | null, projectedGrowth?: number | null, growthRateBand?: string | null, typicalWorkExperienceGroupId?: number | null, preferredEdLevelDescription?: string | null, careerCluster?: string | null, skillsMatchQualityIdAi?: number | null, skillsMatchQualityId?: number | null, interestsMatchQualityId?: number | null, valuesMatchQualityId?: number | null, lifestyleMatchQualityId?: number | null, isOverqualified?: boolean | null, showInstitutionPrograms?: boolean | null, schoolProgramEdLevels?: string | null, videoUrl?: string | null, educationLevelDistribution?: Array<{ __typename?: 'EducationLevel', educationLevelName?: string | null, percentage?: number | null } | null> | null, hotSpots?: Array<{ __typename?: 'HotSpotLocation', demand?: string | null, fipsCode?: string | null, isHomeArea?: boolean | null, lat?: number | null, lon?: number | null, name?: string | null, salary?: string | null, z?: number | null } | null> | null, certificates: Array<{ __typename?: 'CPDCertificate', certId?: string | null, certName?: string | null, certifyingOrgName?: string | null } | null>, licenses: Array<{ __typename?: 'CPDLicense', id: string, licId?: string | null, licName?: string | null, licOrgName?: string | null, state?: string | null } | null>, tasks: Array<{ __typename?: 'Task', description?: string | null } | null>, readinessEvaluation?: Array<{ __typename?: 'Evaluation', itemType?: number | null, userHas?: string | null, isPositiveOutcome?: boolean | null, occupationRequiresObject?: Array<{ __typename?: 'EvaluationObject', id?: number | null, title?: string | null, details?: string | null, detailsArray?: Array<string | null> | null, isMatched?: boolean | null, items?: Array<{ __typename?: 'EvaluationItem', id?: string | null, title?: string | null, isMatched?: boolean | null } | null> | null } | null> | null, otherAlignments?: Array<{ __typename?: 'EvaluationOtherAlignments', id: string, title: string } | null> | null } | null> | null, skills?: Array<{ __typename?: 'Skill', skillId?: string | null, skillType?: number | null, count?: number | null, label?: string | null, description?: string | null, source?: string | null } | null> | null, ksas?: Array<{ __typename?: 'OccupationKsa', id: string, name: string, description?: string | null, type: string, importance?: number | null, level?: number | null, matchStatus?: KsaMatchStatus | null, displayTier?: string | null, matchSources?: Array<{ __typename?: 'KsaMatchSource', channel: KsaMatchChannel, name?: string | null }> | null }> | null, similarOccupations?: Array<{ __typename?: 'CPDOccupation', onetCode: string, title?: string | null, isFavorite?: boolean | null, jobId?: number | null, medianAnnualWage?: number | null, medianHourlyWage?: number | null, imageName?: string | null, typicalEducationLevelGroup?: string | null, growthRateBand?: string | null, skillsMatchQualityId?: number | null, interestsMatchQualityId?: number | null, valuesMatchQualityId?: number | null, lifestyleMatchQualityId?: number | null } | null> | null } | null };

export type GetSimilarMilitaryOccupationsQueryVariables = Exact<{
  onetCode?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetSimilarMilitaryOccupationsQuery = { __typename?: 'Query', getSimilarMilitaryOccupations?: Array<{ __typename?: 'FavoriteMilitaryOccupation', mocCode: string, mocTitle?: string | null, branchCode?: string | null, isFavorite?: boolean | null } | null> | null };

export type OccupationForExportPdfQueryVariables = Exact<{
  onetCode: Scalars['ID'];
  jobId?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
}>;


export type OccupationForExportPdfQuery = { __typename?: 'Query', occupation?: { __typename?: 'CPDOccupation', onetCode: string, jobId?: number | null, title?: string | null, skillsMatchQualityId?: number | null, interestsMatchQualityId?: number | null, valuesMatchQualityId?: number | null, lifestyleMatchQualityId?: number | null, skillsCompatibility?: Array<{ __typename?: 'SkillCompatibility', text?: string | null, matchesUser?: boolean | null } | null> | null, interestsCompatibility?: Array<{ __typename?: 'InterestsCompatibility', id?: number | null, name?: string | null, level?: number | null } | null> | null, workValuesCompatibility?: Array<{ __typename?: 'WorkValuesCompatibility', id?: string | null, name?: string | null, level?: number | null, matchesUser?: boolean | null } | null> | null, ksas?: Array<{ __typename?: 'OccupationKsa', id: string, name: string, description?: string | null, type: string, importance?: number | null, level?: number | null, matchStatus?: KsaMatchStatus | null, displayTier?: string | null, matchSources?: Array<{ __typename?: 'KsaMatchSource', channel: KsaMatchChannel, name?: string | null }> | null }> | null, readinessEvaluation?: Array<{ __typename?: 'Evaluation', itemType?: number | null, userHas?: string | null, isPositiveOutcome?: boolean | null, occupationRequiresObject?: Array<{ __typename?: 'EvaluationObject', id?: number | null, title?: string | null, details?: string | null, detailsArray?: Array<string | null> | null, isMatched?: boolean | null, items?: Array<{ __typename?: 'EvaluationItem', id?: string | null, title?: string | null, isMatched?: boolean | null } | null> | null } | null> | null, otherAlignments?: Array<{ __typename?: 'EvaluationOtherAlignments', id: string, title: string } | null> | null, userHasObject?: Array<{ __typename?: 'EvaluationObject', id?: number | null, title?: string | null, details?: string | null, detailsArray?: Array<string | null> | null, isMatched?: boolean | null } | null> | null } | null> | null, educationLevelDistribution?: Array<{ __typename?: 'EducationLevel', educationLevelId: number, educationLevelName?: string | null, percentage?: number | null } | null> | null } | null };

export type SearchOccupationsQueryVariables = Exact<{
  searchTerm: Scalars['String'];
}>;


export type SearchOccupationsQuery = { __typename?: 'Query', searchOccupations: { __typename?: 'SearchOccupationResult', search: Array<{ __typename?: 'CPDOccupation', onetCode: string, description?: string | null, title?: string | null, projectedGrowth?: number | null, growthRateBand?: string | null, militaryOccupationCount?: number | null, annualWageLower?: number | null, annualWageHighest?: number | null, imageName?: string | null, videoId?: string | null, alternateTitle?: string | null, alternateTitleId?: number | null, industryCode?: number | null, typicalWorkExperienceCategoryTypeId?: number | null, typicalWorkExperienceCategoryTypeName?: string | null }>, fuzzy: Array<{ __typename?: 'CPDOccupation', onetCode: string, description?: string | null, title?: string | null, projectedGrowth?: number | null, growthRateBand?: string | null, militaryOccupationCount?: number | null, annualWageLower?: number | null, annualWageHighest?: number | null, imageName?: string | null, videoId?: string | null, alternateTitle?: string | null, alternateTitleId?: number | null, industryCode?: number | null, typicalWorkExperienceCategoryTypeId?: number | null, typicalWorkExperienceCategoryTypeName?: string | null }> } };

export type UpdateFavoriteOccupationMutationVariables = Exact<{
  onetCode: Scalars['ID'];
  jobId?: InputMaybe<Scalars['Int']>;
}>;


export type UpdateFavoriteOccupationMutation = { __typename?: 'Mutation', favoriteOccupation?: { __typename?: 'FavoriteOccupationResponse', code: number, success: boolean, message: string, favoriteOccupation?: { __typename?: 'FavoriteOccupation', onetSocCode: string, jobId?: number | null, title?: string | null, growthRateBand?: string | null, medianAnnualWage?: number | null, medianHourlyWage?: number | null, imageName?: string | null, skillsMatchQualityId?: number | null, interestsMatchQualityId?: number | null, valuesMatchQualityId?: number | null, lifestyleMatchQualityId?: number | null, isMatch?: boolean | null, isOverqualified?: boolean | null, isFavorite?: boolean | null } | null } | null };

export type UnfavoriteOccupationMutationVariables = Exact<{
  onetCode: Scalars['ID'];
  jobId?: InputMaybe<Scalars['Int']>;
}>;


export type UnfavoriteOccupationMutation = { __typename?: 'Mutation', unfavoriteOccupation?: { __typename?: 'FavoriteOccupationResponse', code: number, success: boolean, message: string, favoriteOccupation?: { __typename?: 'FavoriteOccupation', onetSocCode: string, jobId?: number | null, title?: string | null, growthRateBand?: string | null, medianAnnualWage?: number | null, medianHourlyWage?: number | null, imageName?: string | null, skillsMatchQualityId?: number | null, interestsMatchQualityId?: number | null, valuesMatchQualityId?: number | null, lifestyleMatchQualityId?: number | null, isMatch?: boolean | null, isOverqualified?: boolean | null, isFavorite?: boolean | null } | null } | null };

export type FavoriteMilitaryOccupationsQueryVariables = Exact<{ [key: string]: never; }>;


export type FavoriteMilitaryOccupationsQuery = { __typename?: 'Query', favoriteMilitaryOccupations: Array<{ __typename?: 'FavoriteMilitaryOccupation', mocCode: string, mocTitle?: string | null, branchCode?: string | null, isFavorite?: boolean | null }> };

export type FavoriteMilitaryOccupationMutationVariables = Exact<{
  mocCode: Scalars['String'];
  mocTitle: Scalars['String'];
}>;


export type FavoriteMilitaryOccupationMutation = { __typename?: 'Mutation', favoriteMilitaryOccupation?: { __typename?: 'FavoriteMilitaryOccupationResponse', favoriteMilitaryOccupation?: { __typename?: 'FavoriteMilitaryOccupation', mocCode: string, mocTitle?: string | null, branchCode?: string | null, isFavorite?: boolean | null } | null } | null };

export type UnfavoriteMilitaryOccupationMutationVariables = Exact<{
  mocCode: Scalars['String'];
  mocTitle: Scalars['String'];
}>;


export type UnfavoriteMilitaryOccupationMutation = { __typename?: 'Mutation', unfavoriteMilitaryOccupation?: { __typename?: 'FavoriteMilitaryOccupationResponse', success: boolean } | null };

export type UpdateReclassifyingMutationVariables = Exact<{
  transitionfrommilitary?: InputMaybe<Scalars['Boolean']>;
  stayincurrent?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateReclassifyingMutation = { __typename?: 'Mutation', updateReclassifying?: { __typename?: 'UserReclassifyingResponse', userReclassifying?: { __typename?: 'UserReclassifying', transitionfrommilitary?: boolean | null, stayincurrent?: boolean | null } | null } | null };

export type OccupationForReportFieldsFragment = { __typename?: 'CPDOccupation', onetCode: string, jobId?: number | null, title?: string | null, skillsMatchQualityId?: number | null, interestsMatchQualityId?: number | null, valuesMatchQualityId?: number | null, lifestyleMatchQualityId?: number | null, skillsCompatibility?: Array<{ __typename?: 'SkillCompatibility', text?: string | null, matchesUser?: boolean | null } | null> | null, interestsCompatibility?: Array<{ __typename?: 'InterestsCompatibility', id?: number | null, name?: string | null, level?: number | null } | null> | null, workValuesCompatibility?: Array<{ __typename?: 'WorkValuesCompatibility', id?: string | null, name?: string | null, level?: number | null, matchesUser?: boolean | null } | null> | null, ksas?: Array<{ __typename?: 'OccupationKsa', id: string, name: string, description?: string | null, type: string, importance?: number | null, level?: number | null, matchStatus?: KsaMatchStatus | null, displayTier?: string | null, matchSources?: Array<{ __typename?: 'KsaMatchSource', channel: KsaMatchChannel, name?: string | null }> | null }> | null, readinessEvaluation?: Array<{ __typename?: 'Evaluation', itemType?: number | null, userHas?: string | null, isPositiveOutcome?: boolean | null, occupationRequiresObject?: Array<{ __typename?: 'EvaluationObject', id?: number | null, title?: string | null, details?: string | null, detailsArray?: Array<string | null> | null, isMatched?: boolean | null, items?: Array<{ __typename?: 'EvaluationItem', id?: string | null, title?: string | null, isMatched?: boolean | null } | null> | null } | null> | null, otherAlignments?: Array<{ __typename?: 'EvaluationOtherAlignments', id: string, title: string } | null> | null, userHasObject?: Array<{ __typename?: 'EvaluationObject', id?: number | null, title?: string | null, details?: string | null, detailsArray?: Array<string | null> | null, isMatched?: boolean | null } | null> | null } | null> | null, educationLevelDistribution?: Array<{ __typename?: 'EducationLevel', educationLevelId: number, educationLevelName?: string | null, percentage?: number | null } | null> | null };

export type GetConnectOrganizationStateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetConnectOrganizationStateQuery = { __typename?: 'Query', getConnectOrganizationState: { __typename?: 'UserConnectState', academic: Array<string>, employer: Array<string>, nonprofit: Array<string>, totalCount: number, autoShareEnabled: boolean, premiumPartnerIds: Array<string>, hasOutdatedConnection: boolean } };

export type GetPremiumPartnersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPremiumPartnersQuery = { __typename?: 'Query', getPremiumPartners: Array<{ __typename?: 'PremiumPartner', id: string, name: string, slug: string, description: string, logoUrl?: string | null, website?: string | null, disclosureText: string, additionalFieldsSchema: any }> };

export type ConnectWithPremiumPartnerMutationVariables = Exact<{
  input: PremiumPartnerConnectionInput;
}>;


export type ConnectWithPremiumPartnerMutation = { __typename?: 'Mutation', connectWithPremiumPartner: { __typename?: 'UserPremiumPartnerConnection', id: string, consentedAt: any, revokedAt?: any | null } };

export type RevokePremiumPartnerConnectionMutationVariables = Exact<{
  premiumPartnerId: Scalars['ID'];
}>;


export type RevokePremiumPartnerConnectionMutation = { __typename?: 'Mutation', revokePremiumPartnerConnection?: { __typename?: 'UserPremiumPartnerConnection', id: string, revokedAt?: any | null } | null };

export type GetMatchedOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMatchedOrganizationsQuery = { __typename?: 'Query', getMatchedOrganizations: { __typename?: 'MatchedOrganizations', academic: Array<string>, employer: Array<string>, nonprofit: Array<string>, totalCount: number } };

export type GetOrganizationQueryVariables = Exact<{
  type: OrganizationType;
  query?: InputMaybe<Scalars['String']>;
}>;


export type GetOrganizationQuery = { __typename?: 'Query', getOrganizations: Array<{ __typename?: 'ConnectOrganizationSearchResult', id: string, name: string, description?: string | null, logo?: string | null, website?: string | null }> };

export type GetAcademicsQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']>;
}>;


export type GetAcademicsQuery = { __typename?: 'Query', getOrganizations: Array<{ __typename?: 'ConnectOrganizationSearchResult', id: string, name: string }> };

export type ConnectWithOrganizationsMutationVariables = Exact<{
  academicIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  employerIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  nonprofitIds?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
  autoShareEnabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type ConnectWithOrganizationsMutation = { __typename?: 'Mutation', connectWithOrganizations: { __typename?: 'ConnectActionResult', connectedCount: number } };

export type AcknowledgeOutdatedConnectionsMutationVariables = Exact<{ [key: string]: never; }>;


export type AcknowledgeOutdatedConnectionsMutation = { __typename?: 'Mutation', acknowledgeOutdatedConnections: { __typename?: 'UserConnectPreferences', autoShareEnabled: boolean, hasOutdatedConnection: boolean } };

export type PathwayQueryVariables = Exact<{
  pathwayId: Scalars['ID'];
}>;


export type PathwayQuery = { __typename?: 'Query', pathway?: { __typename?: 'CareerPathway', prodPublish?: boolean | null, devPublish?: boolean | null, pathwayId: string, name?: string | null, imageUrl?: string | null, description?: string | null, maxSalary?: number | null, skillsmatch?: number | null, interestsmatch?: number | null, valuesmatch?: number | null, lifestylematch?: number | null, videoUrl?: string | null, levels?: Array<{ __typename?: 'PathwayLevel', ordinal?: number | null, title?: string | null, occupations?: Array<{ __typename?: 'CPBCustomOccupation', onetCode: string, alternateTitle?: string | null, imageUrl?: string | null, onetTitle?: string | null, projectedGrowthRate?: string | null, relatedTo?: Array<string | null> | null, parentOnetCode?: string | null, interestsMatch?: number | null, valuesMatch?: number | null, typicalWorkExperienceGroup?: string | null, skillsMatch?: number | null, lifestyleMatch?: number | null, interestsMatchQualityId?: number | null, lifestyleMatchQualityId?: number | null, skillsMatchQualityId?: number | null, valuesMatchQualityId?: number | null, salaryAnalysis?: { __typename?: 'SalaryAnalysis', minimumAnnualSalary?: number | null, medianAnnualSalary?: number | null, maximumAnnualSalary?: number | null } | null } | null> | null } | null> | null, sponsorshipCompany?: { __typename?: 'SponsorshipCompany', about?: string | null, createdAt?: any | null, id?: string | null, link?: string | null, logo?: string | null, name?: string | null, photo?: string | null, updatedAt?: any | null, video?: string | null } | null } | null };

export type GetPathwayCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPathwayCardsQuery = { __typename?: 'Query', getPathwayCards?: Array<{ __typename?: 'PathwayCard', pathwayId: string, name?: string | null, imageUrl?: string | null, minSalary?: number | null, medianSalary?: number | null, maxSalary?: number | null, occupationCount?: number | null, skillsmatch?: number | null, interestsmatch?: number | null, valuesmatch?: number | null, lifestylematch?: number | null, devPublish?: boolean | null, prodPublish?: boolean | null, sponsorshipCompany?: { __typename?: 'SponsorshipCompany', logo?: string | null } | null } | null> | null };

export type PortfolioFieldsFragment = { __typename?: 'Portfolio', slug: string, draft: any, published?: any | null, publishedAt?: any | null, isLive: boolean, unpublishedSections: Array<string> };

export type MyPortfolioQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPortfolioQuery = { __typename?: 'Query', myPortfolio?: { __typename?: 'Portfolio', slug: string, draft: any, published?: any | null, publishedAt?: any | null, isLive: boolean, unpublishedSections: Array<string> } | null };

export type PublicPortfolioQueryVariables = Exact<{
  slug: Scalars['ID'];
}>;


export type PublicPortfolioQuery = { __typename?: 'Query', publicPortfolio?: { __typename?: 'PublicPortfolio', slug: string, published: any, publishedAt?: any | null, viaQuestionsLeft?: number | null, viaQuestionsLimit?: number | null } | null };

export type SavePortfolioMutationVariables = Exact<{
  draft: Scalars['JSON'];
}>;


export type SavePortfolioMutation = { __typename?: 'Mutation', savePortfolio: { __typename?: 'Portfolio', slug: string, draft: any, published?: any | null, publishedAt?: any | null, isLive: boolean, unpublishedSections: Array<string> } };

export type PublishPortfolioMutationVariables = Exact<{ [key: string]: never; }>;


export type PublishPortfolioMutation = { __typename?: 'Mutation', publishPortfolio: { __typename?: 'Portfolio', slug: string, draft: any, published?: any | null, publishedAt?: any | null, isLive: boolean, unpublishedSections: Array<string> } };

export type UnpublishPortfolioMutationVariables = Exact<{ [key: string]: never; }>;


export type UnpublishPortfolioMutation = { __typename?: 'Mutation', unpublishPortfolio: { __typename?: 'Portfolio', slug: string, draft: any, published?: any | null, publishedAt?: any | null, isLive: boolean, unpublishedSections: Array<string> } };

export type MyResumeQueryVariables = Exact<{ [key: string]: never; }>;


export type MyResumeQuery = { __typename?: 'Query', myResume?: { __typename?: 'Resume', id?: string | null, document: any, theme: string } | null };

export type SaveResumeMutationVariables = Exact<{
  document: Scalars['JSON'];
  theme?: InputMaybe<Scalars['String']>;
  resumeId?: InputMaybe<Scalars['ID']>;
}>;


export type SaveResumeMutation = { __typename?: 'Mutation', saveResume: { __typename?: 'Resume', id?: string | null, document: any, theme: string } };

export type AskPortfolioViaMutationVariables = Exact<{
  slug: Scalars['ID'];
  question: Scalars['String'];
  role?: InputMaybe<Scalars['String']>;
}>;


export type AskPortfolioViaMutation = { __typename?: 'Mutation', askPortfolioVia?: { __typename?: 'PortfolioViaAnswer', answer?: string | null, outcome: string, remaining?: number | null } | null };

export type MyPortfolioViaUsageQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPortfolioViaUsageQuery = { __typename?: 'Query', myPortfolioViaUsage?: { __typename?: 'PortfolioViaUsage', used: number, limit: number, remaining: number, enabled: boolean } | null };

export type SetPortfolioViaEnabledMutationVariables = Exact<{
  enabled: Scalars['Boolean'];
}>;


export type SetPortfolioViaEnabledMutation = { __typename?: 'Mutation', setPortfolioViaEnabled?: boolean | null };

export type PowerBiQueryVariables = Exact<{ [key: string]: never; }>;


export type PowerBiQuery = { __typename?: 'Query', getReportEmbedConfig?: { __typename?: 'EmbedConfig', id?: string | null, embedUrl?: string | null, type?: string | null, minutesToExpiration?: number | null, defaultPage?: string | null, mobileDefaultPage?: string | null, embedToken: { __typename?: 'EmbedToken', token?: string | null, tokenId?: string | null, expiration?: string | null } } | null };

export type MilitaryBranchesQueryVariables = Exact<{ [key: string]: never; }>;


export type MilitaryBranchesQuery = { __typename?: 'Query', militaryBranches: Array<{ __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null }> };

export type ExtendedMilitaryBranchesQueryVariables = Exact<{ [key: string]: never; }>;


export type ExtendedMilitaryBranchesQuery = { __typename?: 'Query', extendedMilitaryBranches: Array<{ __typename?: 'ExtendedMilitaryBranch', branchCode?: string | null, extendedBranchCode: string, extendedBranchTitle: string, mocSubstitute?: string | null }> };

export type InterestQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type InterestQuestionsQuery = { __typename?: 'Query', interestQuestions: Array<{ __typename?: 'Interest', interestsId: number, question: string }> };

export type SearchRanksQueryVariables = Exact<{
  searchTerm: Scalars['String'];
  branchCode: Scalars['String'];
}>;


export type SearchRanksQuery = { __typename?: 'Query', searchRanks: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null }> };

export type SearchMocsQueryVariables = Exact<{
  searchTerm: Scalars['String'];
  branchCode: Scalars['String'];
  extendedBranchCode?: InputMaybe<Scalars['String']>;
  activeType: Scalars['String'];
  mpcCode?: InputMaybe<Scalars['String']>;
}>;


export type SearchMocsQuery = { __typename?: 'Query', searchMocs: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null }> };

export type EducationLevelsQueryVariables = Exact<{ [key: string]: never; }>;


export type EducationLevelsQuery = { __typename?: 'Query', educationLevels: Array<{ __typename?: 'EducationLevel', educationAdj?: string | null, educationLevelId: number, educationLevelShortDescr?: string | null, educationLevelName?: string | null, percentage?: number | null, altLabel?: string | null }> };

export type SearchDegreesQueryVariables = Exact<{
  searchTerm: Scalars['String'];
}>;


export type SearchDegreesQuery = { __typename?: 'Query', searchDegrees: { __typename?: 'SearchDegreeResult', search: Array<{ __typename?: 'Degree', cipCode: string, id?: number | null, title?: string | null }>, fuzzy: Array<{ __typename?: 'Degree', cipCode: string, id?: number | null, title?: string | null }> } };

export type SearchDegreesForCcafQueryVariables = Exact<{
  searchTerm: Scalars['String'];
}>;


export type SearchDegreesForCcafQuery = { __typename?: 'Query', searchDegreesForCCAF: { __typename?: 'SearchDegreeForCCAFResult', search: Array<{ __typename?: 'Degree', cipCode: string, id?: number | null, title?: string | null }>, fuzzy: Array<{ __typename?: 'Degree', cipCode: string, id?: number | null, title?: string | null }> } };

export type UpdateValuesMutationVariables = Exact<{
  values: Array<ValuesInput> | ValuesInput;
}>;


export type UpdateValuesMutation = { __typename?: 'Mutation', updateValues?: { __typename?: 'UpdateProfileResponse', success: boolean, message: string, code: number, profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null } | null };

export type UpdateInterestsMutationVariables = Exact<{
  interests: Array<InterestInput> | InterestInput;
  trackerId?: InputMaybe<Scalars['String']>;
}>;


export type UpdateInterestsMutation = { __typename?: 'Mutation', updateInterests?: { __typename?: 'UpdateProfileResponse', success: boolean, message: string, code: number, profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null } | null };

export type UpdateLifestyleMutationVariables = Exact<{
  lifestyle: LifestyleInput;
}>;


export type UpdateLifestyleMutation = { __typename?: 'Mutation', updateLifestyle?: { __typename?: 'UpdateProfileResponse', success: boolean, message: string, code: number, profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null } | null };

export type AddPreferredLocationMutationVariables = Exact<{
  location: CpdLocationInput;
}>;


export type AddPreferredLocationMutation = { __typename?: 'Mutation', addPreferredLocation?: { __typename?: 'UpdateProfileResponse', success: boolean, message: string, code: number, profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null } | null };

export type DeletePreferredLocationMutationVariables = Exact<{
  location: CpdLocationInput;
}>;


export type DeletePreferredLocationMutation = { __typename?: 'Mutation', deletePreferredLocation?: { __typename?: 'UpdateProfileResponse', success: boolean, message: string, code: number, profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null } | null };

export type UpdateSkillsMutationVariables = Exact<{
  skills: SkillsInput;
}>;


export type UpdateSkillsMutation = { __typename?: 'Mutation', updateSkills?: { __typename?: 'UpdateProfileResponse', success: boolean, message: string, code: number, profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null } | null };

export type ReturnSessionMutationVariables = Exact<{
  mailTo: Scalars['String'];
}>;


export type ReturnSessionMutation = { __typename?: 'Mutation', returnSession?: { __typename?: 'Response', code: number, success: boolean, message: string } | null };

export type AcceptPrivacyPolicyMutationVariables = Exact<{
  values?: InputMaybe<Scalars['Boolean']>;
}>;


export type AcceptPrivacyPolicyMutation = { __typename?: 'Mutation', acceptPrivacyPolicy?: { __typename?: 'UpdateProfileResponse', success: boolean, profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null } | null };

export type UpdateProfileWorkTypeMutationVariables = Exact<{
  values?: InputMaybe<ProfileWorkTypeInput>;
}>;


export type UpdateProfileWorkTypeMutation = { __typename?: 'Mutation', updateProfileWorkType?: { __typename?: 'UpdateProfileResponse', success: boolean, profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null } | null };

export type SaveUserProgramGoalsMutationVariables = Exact<{
  values: UserProgramGoalInput;
}>;


export type SaveUserProgramGoalsMutation = { __typename?: 'Mutation', saveUserProgramGoals?: { __typename?: 'UpdateProfileResponse', success: boolean, profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null } | null };

export type SaveUserSchoolGoalsMutationVariables = Exact<{
  values: UserSchoolGoalInput;
}>;


export type SaveUserSchoolGoalsMutation = { __typename?: 'Mutation', saveUserSchoolGoals?: { __typename?: 'UpdateProfileResponse', success: boolean, profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null } | null };

export type SaveUserMilitaryTerminationMutationVariables = Exact<{
  values?: InputMaybe<UserTerminationInput>;
}>;


export type SaveUserMilitaryTerminationMutation = { __typename?: 'Mutation', saveUserMilitaryTermination?: { __typename?: 'UpdateProfileResponse', success: boolean, profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null } | null };

export type SaveUserWorkTerminationMutationVariables = Exact<{
  values?: InputMaybe<UserTerminationInput>;
}>;


export type SaveUserWorkTerminationMutation = { __typename?: 'Mutation', saveUserWorkTermination?: { __typename?: 'UpdateProfileResponse', success: boolean, profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null } | null };

export type SaveAsvabScoresMutationVariables = Exact<{
  scores: AsvabScoresInput;
}>;


export type SaveAsvabScoresMutation = { __typename?: 'Mutation', saveAsvabScores?: { __typename?: 'UpdateProfileResponse', success: boolean, profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null } | null };

export type SaveAsvabScoreSetMutationVariables = Exact<{
  scores: Array<AsvabScoreInput> | AsvabScoreInput;
}>;


export type SaveAsvabScoreSetMutation = { __typename?: 'Mutation', saveAsvabScoreSet?: { __typename?: 'UpdateProfileResponse', success: boolean, message: string, profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null } | null };

export type ProgramsByOccupationQueryVariables = Exact<{
  onetCode: Scalars['ID'];
  cipCodeCutoff: CipCodeCutoffFilter;
  searchTerm?: InputMaybe<Scalars['String']>;
  educationLevel?: InputMaybe<EducationLevelFilter>;
  jobId?: InputMaybe<Scalars['ID']>;
  online?: InputMaybe<Scalars['Boolean']>;
}>;


export type ProgramsByOccupationQuery = { __typename?: 'Query', programsByOccupation?: Array<{ __typename?: 'CPDProgram', opeid: string, programName?: string | null, cipCode?: string | null, schoolId?: number | null, schoolProgramId?: number | null, schoolProgramEdLevelId?: number | null, isOnline?: boolean | null, qualityMetric?: number | null, alignment?: number | null, definition?: string | null, officialTitle?: string | null, schoolCount?: number | null } | null> | null };

export type ReportShareFieldsFragment = { __typename?: 'ReportShare', token: string, createdAt: any, expiresAt: any, revokedAt?: any | null, isLive: boolean };

export type MyReportShareQueryVariables = Exact<{ [key: string]: never; }>;


export type MyReportShareQuery = { __typename?: 'Query', myReportShare?: { __typename?: 'ReportShare', token: string, createdAt: any, expiresAt: any, revokedAt?: any | null, isLive: boolean } | null };

export type ShareReportMutationVariables = Exact<{ [key: string]: never; }>;


export type ShareReportMutation = { __typename?: 'Mutation', shareReport: { __typename?: 'ReportShare', token: string, createdAt: any, expiresAt: any, revokedAt?: any | null, isLive: boolean } };

export type RevokeReportShareMutationVariables = Exact<{ [key: string]: never; }>;


export type RevokeReportShareMutation = { __typename?: 'Mutation', revokeReportShare: boolean };

export type SharedReportQueryVariables = Exact<{
  token: Scalars['ID'];
}>;


export type SharedReportQuery = { __typename?: 'Query', sharedReport?: { __typename?: 'SharedReport', memberFirstName?: string | null, sharedAt: any, expiresAt: any, generatedReportDate?: string | null, onetCode?: string | null, occupation?: { __typename?: 'GoalsReportOccupationDetails', title?: string | null, medianAnnualWage?: number | null, edLevelPercent?: number | null, edLevelDescription?: string | null, matches?: { __typename?: 'GoalsReportOccupationDetailsMatches', skillsMatchQuality?: string | null, interestsMatchQuality?: string | null, lifestyleMatchQuality?: string | null, valuesMatchQuality?: string | null } | null } | null, school?: { __typename?: 'GoalsReportSchoolDetails', institutionName?: string | null, address?: string | null, telephoneNumber?: string | null, website?: string | null, creditForMilitaryTraining?: boolean | null, creditForLifeExperiences?: boolean | null, openAdmissionPolicy?: boolean | null, dedicatedPOCforServiceMembers?: boolean | null, schoolPlacementServices?: boolean | null, averageCostSH?: number | null, percentOfDistanceLearners?: number | null } | null, degree?: { __typename?: 'GoalsReportDegreeDetails', programName?: string | null, schoolProgramEdLevelName?: string | null, isRecommendedProgram?: boolean | null, occupationsRelatedToDegree?: Array<{ __typename?: 'GoalsReportOccupationListItem', title: string } | null> | null } | null, certification?: { __typename?: 'CPDCertificate', certName?: string | null, certUrl?: string | null, certifyingOrgName?: string | null } | null, license?: { __typename?: 'CPDLicense', licName?: string | null, licOrgName?: string | null, state?: string | null } | null } | null };

export type SharedReportFullQueryVariables = Exact<{
  token: Scalars['ID'];
}>;


export type SharedReportFullQuery = { __typename?: 'Query', sharedReportFull?: { __typename?: 'SharedReportFull', memberFirstName?: string | null, sharedAt: any, expiresAt: any, viaInsights?: any | null, jst?: any | null, profile?: { __typename?: 'Profile', profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null, goals?: { __typename?: 'Goals', jobId?: string | null, occupationTitle?: string | null, onetCode?: string | null, schoolId?: number | null, schoolProgramEdLevelId?: number | null, schoolProgramId?: number | null, schoolProgramTitle?: string | null, schoolProgramRetired?: boolean | null, schoolTitle?: string | null, licenseId?: string | null, certificationId?: number | null, certificationTitle?: string | null, licenseTitle?: string | null, credentialCtid?: string | null, credentialTitle?: string | null, customOnetCode?: string | null, customPathwayId?: string | null } | null, occupation?: { __typename?: 'CPDOccupation', onetCode: string, jobId?: number | null, title?: string | null, skillsMatchQualityId?: number | null, interestsMatchQualityId?: number | null, valuesMatchQualityId?: number | null, lifestyleMatchQualityId?: number | null, skillsCompatibility?: Array<{ __typename?: 'SkillCompatibility', text?: string | null, matchesUser?: boolean | null } | null> | null, interestsCompatibility?: Array<{ __typename?: 'InterestsCompatibility', id?: number | null, name?: string | null, level?: number | null } | null> | null, workValuesCompatibility?: Array<{ __typename?: 'WorkValuesCompatibility', id?: string | null, name?: string | null, level?: number | null, matchesUser?: boolean | null } | null> | null, ksas?: Array<{ __typename?: 'OccupationKsa', id: string, name: string, description?: string | null, type: string, importance?: number | null, level?: number | null, matchStatus?: KsaMatchStatus | null, displayTier?: string | null, matchSources?: Array<{ __typename?: 'KsaMatchSource', channel: KsaMatchChannel, name?: string | null }> | null }> | null, readinessEvaluation?: Array<{ __typename?: 'Evaluation', itemType?: number | null, userHas?: string | null, isPositiveOutcome?: boolean | null, occupationRequiresObject?: Array<{ __typename?: 'EvaluationObject', id?: number | null, title?: string | null, details?: string | null, detailsArray?: Array<string | null> | null, isMatched?: boolean | null, items?: Array<{ __typename?: 'EvaluationItem', id?: string | null, title?: string | null, isMatched?: boolean | null } | null> | null } | null> | null, otherAlignments?: Array<{ __typename?: 'EvaluationOtherAlignments', id: string, title: string } | null> | null, userHasObject?: Array<{ __typename?: 'EvaluationObject', id?: number | null, title?: string | null, details?: string | null, detailsArray?: Array<string | null> | null, isMatched?: boolean | null } | null> | null } | null> | null, educationLevelDistribution?: Array<{ __typename?: 'EducationLevel', educationLevelId: number, educationLevelName?: string | null, percentage?: number | null } | null> | null } | null, insights?: { __typename?: 'AIDeepInsights', learningSuggestions?: { __typename?: 'LearningSuggestions', courses?: Array<{ __typename?: 'SuggestionItem', description?: string | null, title?: string | null, url?: string | null }> | null, certificates?: Array<{ __typename?: 'SuggestionItem', description?: string | null, title?: string | null, url?: string | null }> | null } | null } | null } | null };

export type AskSharedReportViaMutationVariables = Exact<{
  token: Scalars['ID'];
  question: Scalars['String'];
  history?: InputMaybe<Array<SharedReportViaTurnInput> | SharedReportViaTurnInput>;
}>;


export type AskSharedReportViaMutation = { __typename?: 'Mutation', askSharedReportVia: { __typename?: 'SharedReportViaAnswer', answer?: string | null, outcome: string, remaining?: number | null } };

export type MySharedReportViaUsageQueryVariables = Exact<{ [key: string]: never; }>;


export type MySharedReportViaUsageQuery = { __typename?: 'Query', mySharedReportViaUsage?: { __typename?: 'SharedReportViaUsage', used: number, limit: number, remaining: number, enabled: boolean } | null };

export type SetSharedReportViaEnabledMutationVariables = Exact<{
  enabled: Scalars['Boolean'];
}>;


export type SetSharedReportViaEnabledMutation = { __typename?: 'Mutation', setSharedReportViaEnabled: boolean };

export type GetSessionQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']>;
}>;


export type GetSessionQuery = { __typename?: 'Query', getSession: { __typename?: 'Session', token: string, refreshToken?: string | null, isAuthenticated?: boolean | null, profile: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } } };

export type RefreshSessionQueryVariables = Exact<{
  refreshToken: Scalars['String'];
}>;


export type RefreshSessionQuery = { __typename?: 'Query', refreshSession: { __typename?: 'RefreshTokenResponse', token: string, refreshToken: string } };

export type FeedbackMutationVariables = Exact<{
  feedback?: InputMaybe<FeedbackInput>;
}>;


export type FeedbackMutation = { __typename?: 'Mutation', feedback?: { __typename?: 'Response', code: number, success: boolean, message: string } | null };

export type ReportBugMutationVariables = Exact<{
  input?: InputMaybe<BugReportInput>;
}>;


export type ReportBugMutation = { __typename?: 'Mutation', reportBug?: { __typename?: 'BugReport', buglocation?: string | null, createdat?: string | null, id?: string | null, isviewed?: boolean | null, message?: string | null, updatedat?: string | null } | null };

export type CreateSystemStatusReportMutationVariables = Exact<{
  input?: InputMaybe<SystemStatusReportInput>;
}>;


export type CreateSystemStatusReportMutation = { __typename?: 'Mutation', createSystemStatusReport?: { __typename?: 'SystemStatusReport', id?: string | null, title?: string | null, message?: string | null, ispublished?: boolean | null, createdat?: string | null, updatedat?: string | null } | null };

export type TogglePublishAllSystemStatusReportMutationVariables = Exact<{
  input?: InputMaybe<TogglePublishAllSystemStatusReportInput>;
}>;


export type TogglePublishAllSystemStatusReportMutation = { __typename?: 'Mutation', togglePublishAllSystemStatusReport?: Array<{ __typename?: 'SystemStatusReport', id?: string | null } | null> | null };

export type DeletePublishedSystemStatusReportsMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type DeletePublishedSystemStatusReportsMutation = { __typename?: 'Mutation', deletePublishedSystemStatusReports?: boolean | null };

export type MarkBugReportsViewedMutationVariables = Exact<{
  input?: InputMaybe<BugReportViewedInput>;
}>;


export type MarkBugReportsViewedMutation = { __typename?: 'Mutation', markBugReportsViewed?: Array<{ __typename?: 'BugReport', id?: string | null } | null> | null };

export type GetBugReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBugReportsQuery = { __typename?: 'Query', getBugReports?: Array<{ __typename?: 'BugReport', buglocation?: string | null, createdat?: string | null, id?: string | null, isviewed?: boolean | null, message?: string | null, updatedat?: string | null } | null> | null };

export type GetSystemStatusReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSystemStatusReportsQuery = { __typename?: 'Query', getSystemStatusReports?: Array<{ __typename?: 'SystemStatusReport', id?: string | null, title?: string | null, message?: string | null, ispublished?: boolean | null, createdat?: string | null, updatedat?: string | null } | null> | null };

export type GetFeedbacksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeedbacksQuery = { __typename?: 'Query', getFeedbacks?: Array<{ __typename?: 'FeedbackForAdmin', moctitle?: string | null, recommendrating?: number | null, comment?: string | null, routeurl?: string | null, createdtimestamp?: string | null } | null> | null };

export type GetFeedbackAnalyticsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeedbackAnalyticsQuery = { __typename?: 'Query', getFeedbackAnalytics?: { __typename?: 'FeedbackAnalytics', totalFeedback?: number | null, avarageRating?: number | null, percentDifferenceTotal?: number | null, percentDfferenceAvarageRating?: number | null, totalIncreased?: boolean | null, avarageRatingIncreased?: boolean | null } | null };

export type SaveVideoUsageMutationVariables = Exact<{
  videoUsageInput?: InputMaybe<VideoUsageInput>;
}>;


export type SaveVideoUsageMutation = { __typename?: 'Mutation', saveVideoUsage?: { __typename?: 'VideoUsage', url?: string | null, duration?: number | null, spend?: number | null, endtype?: string | null, createdat?: string | null } | null };

export type ReportDownloadedMutationVariables = Exact<{ [key: string]: never; }>;


export type ReportDownloadedMutation = { __typename?: 'Mutation', reportDownloaded?: { __typename?: 'UpdateProfileResponse', code: number, success: boolean, message: string } | null };

export type ReportSharedMutationVariables = Exact<{ [key: string]: never; }>;


export type ReportSharedMutation = { __typename?: 'Mutation', reportShared?: { __typename?: 'UpdateProfileResponse', code: number, success: boolean, message: string } | null };

export type StartInterestsTrackingMutationVariables = Exact<{ [key: string]: never; }>;


export type StartInterestsTrackingMutation = { __typename?: 'Mutation', startInterestsTracking?: { __typename?: 'UserInterestSurveyTrackerReponse', code: number, success: boolean, message: string, tracker?: { __typename?: 'UserInterestSurveyTracker', id?: string | null, createdat?: string | null, startedat?: string | null, finishedat?: string | null } | null } | null };

export type SavePathwayPageUsageMutationVariables = Exact<{
  input?: InputMaybe<PathwayPageUsageInput>;
}>;


export type SavePathwayPageUsageMutation = { __typename?: 'Mutation', savePathwayPageUsage?: boolean | null };

export type RegisterQueryVariables = Exact<{ [key: string]: never; }>;


export type RegisterQuery = { __typename?: 'Query', register: { __typename?: 'User', userId: number, token: string } };

export type GetUserProfileQueryVariables = Exact<{
  sessionToken?: InputMaybe<Scalars['String']>;
}>;


export type GetUserProfileQuery = { __typename?: 'Query', profile?: { __typename?: 'Profile', userId: number, profileType?: string | null, isSkillsSurveyComplete?: boolean | null, isInterestsSurveyComplete?: boolean | null, isWorkValuesSurveyComplete?: boolean | null, isLifestyleSurveyComplete?: boolean | null, isJstUploaded?: boolean | null, hasCivilianWorkExperience?: boolean | null, hasReturnUrl?: boolean | null, privacyPolicyAccepted?: boolean | null, returnUrlLastSavedDate?: any | null, serveTypeId?: number | null, reportDownloaded?: boolean | null, reportShared?: boolean | null, userAspirationsPreference?: Array<string | null> | null, experienceAnalysis?: string | null, interestsAnalysis?: string | null, workValueAnalysis?: string | null, userHasPreGoal?: boolean | null, userPreGoalOccupation?: string | null, userPreGoalOnetCode?: string | null, userWorkTermination?: number | null, userMilitaryTermination?: number | null, userProgramGoalEdLevelId?: number | null, firstName?: string | null, lastName?: string | null, userEmail?: string | null, userRole?: string | null, status?: string | null, militaryBranch?: { __typename?: 'MilitaryBranch', branchCode?: string | null, branchTitle?: string | null, branchLabel?: string | null, mocSubstitute?: string | null } | null, userRanks?: Array<{ __typename?: 'Rank', payGrade?: string | null, title?: string | null, abbreviation?: string | null, branchCode?: string | null, mpcCode?: string | null, payGradeLevel?: number | null } | null> | null, userMocs?: Array<{ __typename?: 'Moc', mocCode: string, mocTitle?: string | null, branchCode?: string | null, extendedBranchCode?: string | null, mpcCode?: string | null, status?: string | null, hasEnlisted?: boolean | null, hasWarrantOfficer?: boolean | null, hasCommissionOfficer?: boolean | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userWorkExperiences?: Array<{ __typename?: 'WorkExperience', id?: number | null, occupationTitle?: string | null, onetSocCode?: string | null, industryCode?: string | null, workExperienceCategoryId?: string | null, numberOfMonthsOfWorkExperience?: number | null } | null> | null, userEducations?: Array<{ __typename?: 'Education', educationLevelId: number, educationLevelShortDescr?: string | null, valid?: boolean | null, completed?: boolean | null, degreeInfo?: { __typename?: 'DegreeTitle', id: number, cipCode?: string | null, title?: string | null } | null } | null> | null, userPreferredLocations: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null }>, userCurrentLocations?: Array<{ __typename?: 'CPDLocation', cityName: string, stateAbbreviation: string, zipCode: string, marketArea?: number | null, marketAreaCityName?: string | null, marketAreaStateAbbreviation?: string | null, countyFipsCode?: number | null, countyName?: string | null, latitude?: number | null, longitude?: number | null } | null> | null, userInterests?: Array<{ __typename?: 'UserInterest', interestId?: number | null, interestName?: string | null, level?: number | null, abbreviation?: string | null } | null> | null, userWorkValues?: Array<{ __typename?: 'UserWorkValue', workValueId: string, workValueName?: string | null, level?: number | null } | null> | null, userAspirations?: { __typename?: 'UserAspiration', familyTypePreference?: number | null, housingPreference?: number | null, transportationPreference?: number | null, childcarePreference?: number | null, foodPreference?: number | null, spouseIsEmployed?: boolean | null, spouseIncome?: number | null, numberOfChildren?: number | null } | null, userCompetencies?: { __typename?: 'UserCompetencies', sourceExperience?: Array<{ __typename?: 'SourceExperience', title: string, coreCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null, advancedCompetencies?: Array<{ __typename?: 'Competency', sourceType?: number | null, code?: string | null, title?: string | null, skillId?: string | null, competencyLabel?: string | null, competencyDescription?: string | null, typeId?: number | null, cnt?: number | null } | null> | null } | null> | null } | null, userAirbaseLocation?: { __typename?: 'AirbaseLocation', id?: string | null, majcom?: string | null, assignedbase?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null } | null, userSpacebaseLocation?: { __typename?: 'SpacebaseLocation', id?: string | null, assignedbase?: string | null, active?: boolean | null } | null, userInstallation?: { __typename?: 'InstallationLocation', id?: string | null, name?: string | null, aliases?: string | null, state?: string | null, country?: string | null, branchcode?: string | null, active?: boolean | null, nationalguard?: boolean | null, reserve?: boolean | null, isnotlisted?: boolean | null } | null, profileWorkType?: { __typename?: 'ProfileWorkType', type?: ProfileWorkTypeEnum | null, servicepolicyaccepted?: boolean | null } | null, asvabScores?: { __typename?: 'AsvabScores', gt?: number | null, el?: number | null, mm?: number | null, cl?: number | null } | null, asvabScoreSet?: Array<{ __typename?: 'AsvabScore', scale: string, score: number }> | null, userProgramGoal?: { __typename?: 'CipCodeForGoal', id?: string | null, jobId?: string | null, cipCode?: string | null, cipTitle?: string | null } | null, userSchoolGoal?: { __typename?: 'School', id: string, name?: string | null } | null } | null };

export type GetReturnSessionQueryVariables = Exact<{
  returnToken: Scalars['String'];
}>;


export type GetReturnSessionQuery = { __typename?: 'Query', returnSession: string };

export type InitUserMatchesQueryVariables = Exact<{ [key: string]: never; }>;


export type InitUserMatchesQuery = { __typename?: 'Query', initUserMatches?: { __typename?: 'UpdateProfileResponse', success: boolean, message: string, code: number } | null };

export type UsersQueryVariables = Exact<{ [key: string]: never; }>;


export type UsersQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'Profile', userId: number, firstName?: string | null, lastName?: string | null, userRole?: string | null, userEmail?: string | null, status?: string | null, userName?: string | null, isDantesStaff?: boolean | null } | null> | null };

export type GetEmailToVerifyQueryVariables = Exact<{
  token?: InputMaybe<Scalars['String']>;
}>;


export type GetEmailToVerifyQuery = { __typename?: 'Query', getEmailToVerify?: string | null };

export type RegisterLoginUserMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
}>;


export type RegisterLoginUserMutation = { __typename?: 'Mutation', registerLoginUser: { __typename?: 'User', userId: number, userRole?: string | null, userName?: string | null, token: string } };

export type LoginMutationVariables = Exact<{
  username: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'User', userId: number, userRole?: string | null, userName?: string | null, userEmail?: string | null, token: string, profile: { __typename?: 'Profile', firstName?: string | null, lastName?: string | null } } };

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser?: boolean | null };

export type LoginByEmailMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginByEmailMutation = { __typename?: 'Mutation', loginByEmail: { __typename?: 'User', userId: number, userRole?: string | null, userName?: string | null, userEmail?: string | null, token: string, profile: { __typename?: 'Profile', firstName?: string | null, lastName?: string | null } } };

export type SaveUserDetailsMutationVariables = Exact<{
  userId: Scalars['Int'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  status?: InputMaybe<UserActionEnum>;
}>;


export type SaveUserDetailsMutation = { __typename?: 'Mutation', saveUserDetails?: { __typename?: 'User', profile: { __typename?: 'Profile', userId: number, firstName?: string | null, lastName?: string | null, userRole?: string | null, userEmail?: string | null, status?: string | null, userName?: string | null, isDantesStaff?: boolean | null } } | null };

export type InviteUsersMutationVariables = Exact<{
  emails: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  role: Scalars['String'];
}>;


export type InviteUsersMutation = { __typename?: 'Mutation', inviteUsers?: boolean | null };

export type VerifyEmailMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type VerifyEmailMutation = { __typename?: 'Mutation', verifyEmail?: boolean | null };

export type SaveUserCredsMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  token?: InputMaybe<Scalars['String']>;
}>;


export type SaveUserCredsMutation = { __typename?: 'Mutation', saveUserCreds?: { __typename?: 'User', userId: number, token: string } | null };

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: boolean | null };

export type LoginAfterResetMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginAfterResetMutation = { __typename?: 'Mutation', loginAfterReset?: { __typename?: 'User', userId: number, token: string, profile: { __typename?: 'Profile', userId: number, firstName?: string | null, lastName?: string | null, userRole?: string | null, userEmail?: string | null, status?: string | null, userName?: string | null, isDantesStaff?: boolean | null } } | null };

export type SubmitSharedReportFeedbackMutationVariables = Exact<{
  token: Scalars['ID'];
  rating: Scalars['Int'];
  comment?: InputMaybe<Scalars['String']>;
}>;


export type SubmitSharedReportFeedbackMutation = { __typename?: 'Mutation', submitSharedReportFeedback: boolean };

export type GetSharedReportFeedbacksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSharedReportFeedbacksQuery = { __typename?: 'Query', getSharedReportFeedbacks?: Array<{ __typename?: 'SharedReportFeedbackForAdmin', createdtimestamp?: string | null, rating?: number | null, comment?: string | null, moctitle?: string | null, careergoal?: string | null } | null> | null };


export const ActionItemFieldsFragmentDoc = gql`
    fragment actionItemFields on ActionItem {
  id
  title
  notes
  status
  category
  horizon
  dueOn
  sortOrder
  origin
  suggestionState
}
    `;
export const MemberFieldsFragmentDoc = gql`
    fragment memberFields on Profile {
  userId
  firstName
  lastName
  userRole
  userEmail
  status
  userName
  isDantesStaff
}
    `;
export const GoalsFieldsFragmentDoc = gql`
    fragment goalsFields on Goals {
  jobId
  occupationTitle
  onetCode
  schoolId
  schoolProgramEdLevelId
  schoolProgramId
  schoolProgramTitle
  schoolProgramRetired
  schoolTitle
  licenseId
  certificationId
  certificationTitle
  licenseTitle
  credentialCtid
  credentialTitle
  customOnetCode
  customPathwayId
}
    `;
export const CpdInstitutionFieldsFragmentDoc = gql`
    fragment cpdInstitutionFields on CPDInstitution {
  schoolId
  opeid
  institutionName
  telephoneNumber
  website
  unitid
  address {
    streetAddress1
    streetAddress2
    city
    state
    zip
  }
  sourceOfAccreditation
  accreditationType
  institutionType
  alignment
  isOnline
  isOpenAdmissionPolicy
  isTaApproved
  taMouExpirationDate
  programName
  costPerSH
  qualityMetric
  ageEntry
  avgCostSH
  c3yrRepaymentRateIndependentStudents
  c3yrRepaymentRateIndependentStudentsN
  creditForLifeExperiences
  creditForMilitaryTraining
  meanEarnings10yearsLaterPercentile
  meanEarnings10yearsLaterPercentileN
  partTime8yrAward
  partTime8yrAwardN
  partTimeRetentionRate
  partTimeRetentionRateN
  pctOfDistanceLearners
  pctOfPartiallyDistanceLearners
  pctOfTaFundedCoursesCompletedSuccessfully
  pctOfTaFundedCoursesCompletedSuccessfullyN
  schoolPlacementServices
  is2year
  pocName
  pocTitle
  pocPhone
  pocExt
  pocEmail
  dedicatedPOCforServicemembers
}
    `;
export const NewsFieldsFragmentDoc = gql`
    fragment newsFields on NewsItem {
  id
  title
  description
  type
  reaction
  createdAt
}
    `;
export const NewsTypeFieldsFragmentDoc = gql`
    fragment newsTypeFields on NewsTypesItem {
  id
  title
}
    `;
export const PathwayFieldsFragmentDoc = gql`
    fragment pathwayFields on CareerPathway {
  prodPublish
  devPublish
  pathwayId
  name
  imageUrl
  description
  levels {
    ordinal
    title
    occupations {
      onetCode
      alternateTitle
      imageUrl
      onetTitle
      projectedGrowthRate
      salaryAnalysis {
        minimumAnnualSalary
        medianAnnualSalary
        maximumAnnualSalary
      }
      relatedTo
      parentOnetCode
      interestsMatch
      valuesMatch
      typicalWorkExperienceGroup
      skillsMatch
      lifestyleMatch
      interestsMatchQualityId
      lifestyleMatchQualityId
      skillsMatchQualityId
      valuesMatchQualityId
    }
  }
  maxSalary
  skillsmatch
  interestsmatch
  valuesmatch
  lifestylematch
  videoUrl
  sponsorshipCompany {
    about
    createdAt
    id
    link
    logo
    name
    photo
    updatedAt
    video
  }
}
    `;
export const CpdProgramFieldsFragmentDoc = gql`
    fragment cpdProgramFields on CPDProgram {
  opeid
  programName
  cipCode
  schoolId
  schoolProgramId
  schoolProgramEdLevelId
  isOnline
  qualityMetric
  alignment
  definition
  officialTitle
  schoolCount
}
    `;
export const MilitaryBranchFieldsFragmentDoc = gql`
    fragment militaryBranchFields on MilitaryBranch {
  branchCode
  branchTitle
  branchLabel
  mocSubstitute
}
    `;
export const RankFieldsFragmentDoc = gql`
    fragment rankFields on Rank {
  payGrade
  title
  abbreviation
  branchCode
  mpcCode
  payGradeLevel
}
    `;
export const MocFieldsFragmentDoc = gql`
    fragment mocFields on Moc {
  mocCode
  mocTitle
  branchCode
  extendedBranchCode
  mpcCode
  status
  hasEnlisted
  hasWarrantOfficer
  hasCommissionOfficer
  numberOfMonthsOfWorkExperience
}
    `;
export const WorkExperienceFieldsFragmentDoc = gql`
    fragment workExperienceFields on WorkExperience {
  id
  occupationTitle
  onetSocCode
  industryCode
  workExperienceCategoryId
  numberOfMonthsOfWorkExperience
}
    `;
export const EducationFieldsFragmentDoc = gql`
    fragment educationFields on Education {
  educationLevelId
  educationLevelShortDescr
  degreeInfo {
    id
    cipCode
    title
  }
  valid
  completed
}
    `;
export const LocationFieldsFragmentDoc = gql`
    fragment locationFields on CPDLocation {
  cityName
  stateAbbreviation
  zipCode
  marketArea
  marketAreaCityName
  marketAreaStateAbbreviation
  countyFipsCode
  countyName
  latitude
  longitude
}
    `;
export const InterestFieldsFragmentDoc = gql`
    fragment interestFields on UserInterest {
  interestId
  interestName
  level
  abbreviation
}
    `;
export const WorkValueFieldsFragmentDoc = gql`
    fragment workValueFields on UserWorkValue {
  workValueId
  workValueName
  level
}
    `;
export const AspirationFieldsFragmentDoc = gql`
    fragment aspirationFields on UserAspiration {
  familyTypePreference
  housingPreference
  transportationPreference
  childcarePreference
  foodPreference
  spouseIsEmployed
  spouseIncome
  numberOfChildren
}
    `;
export const CompetencyFieldsFragmentDoc = gql`
    fragment competencyFields on Competency {
  sourceType
  code
  title
  skillId
  competencyLabel
  competencyDescription
  typeId
  cnt
}
    `;
export const UserCompetencyFieldsFragmentDoc = gql`
    fragment userCompetencyFields on UserCompetencies {
  sourceExperience {
    title
    coreCompetencies {
      ...competencyFields
    }
    advancedCompetencies {
      ...competencyFields
    }
  }
}
    ${CompetencyFieldsFragmentDoc}`;
export const AirbaseLocationFieldsFragmentDoc = gql`
    fragment airbaseLocationFields on AirbaseLocation {
  id
  majcom
  assignedbase
  active
  nationalguard
  reserve
}
    `;
export const SpacebaseLocationFieldsFragmentDoc = gql`
    fragment spacebaseLocationFields on SpacebaseLocation {
  id
  assignedbase
  active
}
    `;
export const InstallationLocationFieldsFragmentDoc = gql`
    fragment installationLocationFields on InstallationLocation {
  id
  name
  aliases
  state
  country
  branchcode
  active
  nationalguard
  reserve
  isnotlisted
}
    `;
export const ProfileReportFieldsFragmentDoc = gql`
    fragment profileReportFields on Profile {
  profileType
  isSkillsSurveyComplete
  isInterestsSurveyComplete
  isWorkValuesSurveyComplete
  isLifestyleSurveyComplete
  isJstUploaded
  hasCivilianWorkExperience
  hasReturnUrl
  privacyPolicyAccepted
  returnUrlLastSavedDate
  serveTypeId
  reportDownloaded
  reportShared
  militaryBranch {
    ...militaryBranchFields
  }
  userRanks {
    ...rankFields
  }
  userMocs {
    ...mocFields
  }
  userWorkExperiences {
    ...workExperienceFields
  }
  userEducations {
    ...educationFields
  }
  userPreferredLocations {
    ...locationFields
  }
  userCurrentLocations {
    ...locationFields
  }
  userInterests {
    ...interestFields
  }
  userWorkValues {
    ...workValueFields
  }
  userAspirations {
    ...aspirationFields
  }
  userAspirationsPreference
  userCompetencies {
    ...userCompetencyFields
  }
  experienceAnalysis
  interestsAnalysis
  workValueAnalysis
  userHasPreGoal
  userPreGoalOccupation
  userPreGoalOnetCode
  userAirbaseLocation {
    ...airbaseLocationFields
  }
  userSpacebaseLocation {
    ...spacebaseLocationFields
  }
  userInstallation {
    ...installationLocationFields
  }
  profileWorkType {
    type
    servicepolicyaccepted
  }
  userWorkTermination
  userMilitaryTermination
  asvabScores {
    gt
    el
    mm
    cl
  }
  asvabScoreSet {
    scale
    score
  }
  userProgramGoal {
    id
    jobId
    cipCode
    cipTitle
  }
  userProgramGoalEdLevelId
  userSchoolGoal {
    id
    name
  }
  firstName
  lastName
  userEmail
  userRole
  status
}
    ${MilitaryBranchFieldsFragmentDoc}
${RankFieldsFragmentDoc}
${MocFieldsFragmentDoc}
${WorkExperienceFieldsFragmentDoc}
${EducationFieldsFragmentDoc}
${LocationFieldsFragmentDoc}
${InterestFieldsFragmentDoc}
${WorkValueFieldsFragmentDoc}
${AspirationFieldsFragmentDoc}
${UserCompetencyFieldsFragmentDoc}
${AirbaseLocationFieldsFragmentDoc}
${SpacebaseLocationFieldsFragmentDoc}
${InstallationLocationFieldsFragmentDoc}`;
export const ProfileFieldsFragmentDoc = gql`
    fragment profileFields on Profile {
  userId
  ...profileReportFields
}
    ${ProfileReportFieldsFragmentDoc}`;
export const UpdateProfileResponseFieldsFragmentDoc = gql`
    fragment updateProfileResponseFields on UpdateProfileResponse {
  profile {
    ...profileFields
  }
}
    ${ProfileFieldsFragmentDoc}`;
export const FeedbackForAdminFieldsFragmentDoc = gql`
    fragment feedbackForAdminFields on FeedbackForAdmin {
  moctitle
  recommendrating
  comment
  routeurl
  createdtimestamp
}
    `;
export const BugReportFieldsFragmentDoc = gql`
    fragment bugReportFields on BugReport {
  buglocation
  createdat
  id
  isviewed
  message
  updatedat
}
    `;
export const SystemStatusReportFragmentDoc = gql`
    fragment systemStatusReport on SystemStatusReport {
  id
  title
  message
  ispublished
  createdat
  updatedat
}
    `;
export const OccupationFieldsFragmentDoc = gql`
    fragment occupationFields on CPDOccupation {
  onetCode
  cpbonetcode
  isPathway
  medianAnnualWage
  highSalary
  lowSalary
  title
  alternateTitles
  jobId
  jobOpenings
  description
  projectedGrowth
  growthRateBand
  typicalWorkExperienceGroupId
  preferredEdLevelDescription
  careerCluster
  educationLevelDistribution {
    educationLevelName
    percentage
  }
  hotSpots {
    demand
    fipsCode
    isHomeArea
    lat
    lon
    name
    salary
    z
  }
  skillsMatchQualityIdAi
  skillsMatchQualityId
  interestsMatchQualityId
  valuesMatchQualityId
  lifestyleMatchQualityId
  isOverqualified
  certificates {
    certId
    certName
    certifyingOrgName
  }
  licenses {
    id
    licId
    licName
    licOrgName
    state
  }
  tasks {
    description
  }
  readinessEvaluation {
    itemType
    userHas
    occupationRequiresObject {
      id
      title
      details
      detailsArray
      items {
        id
        title
        isMatched
      }
      isMatched
    }
    otherAlignments {
      id
      title
    }
    isPositiveOutcome
  }
  showInstitutionPrograms
  schoolProgramEdLevels
  skills {
    skillId
    skillType
    count
    label
    description
    source
  }
  ksas {
    id
    name
    description
    type
    importance
    level
    matchStatus
    matchSources {
      channel
      name
    }
    displayTier
  }
  videoUrl
  similarOccupations {
    onetCode
    title
    isFavorite
    jobId
    medianAnnualWage
    medianHourlyWage
    imageName
    typicalEducationLevelGroup
    growthRateBand
    skillsMatchQualityId
    interestsMatchQualityId
    valuesMatchQualityId
    lifestyleMatchQualityId
  }
}
    `;
export const OccupationCardFieldsFragmentDoc = gql`
    fragment occupationCardFields on OccupationCard {
  onetCode
  title
  isFavorite
  jobId
  medianAnnualWage
  medianHourlyWage
  imageName
  typicalEducationLevelGroup
  growthRateBand
  skillsMatchQualityId
  interestsMatchQualityId
  valuesMatchQualityId
  lifestyleMatchQualityId
  occupationCardCategoryType
}
    `;
export const FavoriteOccupationFieldsFragmentDoc = gql`
    fragment favoriteOccupationFields on FavoriteOccupation {
  onetSocCode
  jobId
  title
  growthRateBand
  medianAnnualWage
  medianHourlyWage
  imageName
  skillsMatchQualityId
  interestsMatchQualityId
  valuesMatchQualityId
  lifestyleMatchQualityId
  isMatch
  isOverqualified
  isFavorite
  preferredEdLevelDescription
}
    `;
export const NotificationFieldsFragmentDoc = gql`
    fragment notificationFields on Notification {
  id
  kind
  title
  body
  createdAt
  destinationLabel
  destinationPath
  dismissedAt
}
    `;
export const OccupationForReportFieldsFragmentDoc = gql`
    fragment occupationForReportFields on CPDOccupation {
  onetCode
  jobId
  skillsCompatibility {
    text
    matchesUser
  }
  interestsCompatibility {
    id
    name
    level
  }
  workValuesCompatibility {
    id
    name
    level
    matchesUser
  }
  ksas {
    id
    name
    description
    type
    importance
    level
    matchStatus
    matchSources {
      channel
      name
    }
    displayTier
  }
  readinessEvaluation {
    itemType
    occupationRequiresObject {
      id
      title
      details
      detailsArray
      items {
        id
        title
        isMatched
      }
      isMatched
    }
    otherAlignments {
      id
      title
    }
    userHas
    userHasObject {
      id
      title
      details
      detailsArray
      isMatched
    }
    isPositiveOutcome
  }
  educationLevelDistribution {
    educationLevelId
    educationLevelName
    percentage
  }
  title
  skillsMatchQualityId
  interestsMatchQualityId
  valuesMatchQualityId
  lifestyleMatchQualityId
}
    `;
export const PortfolioFieldsFragmentDoc = gql`
    fragment portfolioFields on Portfolio {
  slug
  draft
  published
  publishedAt
  isLive
  unpublishedSections
}
    `;
export const ReportShareFieldsFragmentDoc = gql`
    fragment reportShareFields on ReportShare {
  token
  createdAt
  expiresAt
  revokedAt
  isLive
}
    `;
export const ActionItemsDocument = gql`
    query ActionItems {
  actionItems {
    ...actionItemFields
  }
  pendingActionSuggestions {
    ...actionItemFields
  }
}
    ${ActionItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ActionItemsGQL extends Apollo.Query<ActionItemsQuery, ActionItemsQueryVariables> {
    document = ActionItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateActionItemDocument = gql`
    mutation CreateActionItem($input: ActionItemInput!) {
  createActionItem(input: $input) {
    ...actionItemFields
  }
}
    ${ActionItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateActionItemGQL extends Apollo.Mutation<CreateActionItemMutation, CreateActionItemMutationVariables> {
    document = CreateActionItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateActionItemDocument = gql`
    mutation UpdateActionItem($id: ID!, $input: ActionItemInput!) {
  updateActionItem(id: $id, input: $input) {
    ...actionItemFields
  }
}
    ${ActionItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateActionItemGQL extends Apollo.Mutation<UpdateActionItemMutation, UpdateActionItemMutationVariables> {
    document = UpdateActionItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteActionItemDocument = gql`
    mutation DeleteActionItem($id: ID!) {
  deleteActionItem(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteActionItemGQL extends Apollo.Mutation<DeleteActionItemMutation, DeleteActionItemMutationVariables> {
    document = DeleteActionItemDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReorderActionItemsDocument = gql`
    mutation ReorderActionItems($ids: [ID!]!) {
  reorderActionItems(ids: $ids) {
    ...actionItemFields
  }
}
    ${ActionItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ReorderActionItemsGQL extends Apollo.Mutation<ReorderActionItemsMutation, ReorderActionItemsMutationVariables> {
    document = ReorderActionItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResolveActionSuggestionDocument = gql`
    mutation ResolveActionSuggestion($id: ID!, $accept: Boolean!) {
  resolveActionSuggestion(id: $id, accept: $accept) {
    ...actionItemFields
  }
}
    ${ActionItemFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ResolveActionSuggestionGQL extends Apollo.Mutation<ResolveActionSuggestionMutation, ResolveActionSuggestionMutationVariables> {
    document = ResolveActionSuggestionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteConversationDocument = gql`
    mutation DeleteConversation($conversationId: Int!) {
  deleteConversation(conversationId: $conversationId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteConversationGQL extends Apollo.Mutation<DeleteConversationMutation, DeleteConversationMutationVariables> {
    document = DeleteConversationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RateMessageDocument = gql`
    mutation RateMessage($messageId: Int!, $liked: Boolean, $disliked: Boolean) {
  rateMessage(messageId: $messageId, liked: $liked, disliked: $disliked) {
    id
    liked
    disliked
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RateMessageGQL extends Apollo.Mutation<RateMessageMutation, RateMessageMutationVariables> {
    document = RateMessageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConversationHistoryDocument = gql`
    query GetConversationHistory($conversationId: Int!, $limit: Int!, $offset: Int!) {
  getConversationHistory(
    conversationId: $conversationId
    limit: $limit
    offset: $offset
  ) {
    conversation {
      id
    }
    messages {
      id
      role
      content
      createdAt
      disliked
      liked
      metadata {
        conversationGoals {
          certificationId
          schoolId
          programId
          onetCode
          hasChanged
          edlevelId
        }
        learningSuggestions {
          certificates {
            description
            title
            url
          }
          courses {
            title
            description
            url
          }
        }
      }
    }
    messageCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConversationHistoryGQL extends Apollo.Query<GetConversationHistoryQuery, GetConversationHistoryQueryVariables> {
    document = GetConversationHistoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserConversationsDocument = gql`
    query GetUserConversations($limit: Int!, $offset: Int!) {
  getUserConversations(limit: $limit, offset: $offset) {
    conversations {
      id
      title
      updatedAt
      lastMessage
    }
    conversationCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserConversationsGQL extends Apollo.Query<GetUserConversationsQuery, GetUserConversationsQueryVariables> {
    document = GetUserConversationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRateLimitDocument = gql`
    query GetRateLimit {
  getRateLimit {
    allowed
    remaining
    resetTime
    limit
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRateLimitGQL extends Apollo.Query<GetRateLimitQuery, GetRateLimitQueryVariables> {
    document = GetRateLimitDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMaintanceStatusDocument = gql`
    query GetMaintanceStatus {
  getMaintanceStatus {
    id
    message
    isactive
    banneractive
    siteblocked
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMaintanceStatusGQL extends Apollo.Query<GetMaintanceStatusQuery, GetMaintanceStatusQueryVariables> {
    document = GetMaintanceStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CognitoCallbackDocument = gql`
    query CognitoCallback($cognitoIdToken: String!) {
  cognitoCallback(cognitoIdToken: $cognitoIdToken) {
    token
    refreshToken
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CognitoCallbackGQL extends Apollo.Query<CognitoCallbackQuery, CognitoCallbackQueryVariables> {
    document = CognitoCallbackDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CredentialRecordsDocument = gql`
    query CredentialRecords($onetCode: String) {
  credentialRecords(onetCode: $onetCode) {
    id
    credentialKey
    name
    issuer
    creditHours
    creditLevel
    creditRecommendation
    aceValidated
    aceCriteria
    aceReviewedOn
    employerConfirmed
    employerName
    employerCriteria
    employerReviewedOn
    completionRate
    placementRate
    medianEarnings
    outcomesSource
    outcomesAsOf
    pathwayPosition
    pathwayNote
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CredentialRecordsGQL extends Apollo.Query<CredentialRecordsQuery, CredentialRecordsQueryVariables> {
    document = CredentialRecordsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyFrontDoorDocument = gql`
    query MyFrontDoor {
  myFrontDoor {
    intent
    intentText
    answeredAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MyFrontDoorGQL extends Apollo.Query<MyFrontDoorQuery, MyFrontDoorQueryVariables> {
    document = MyFrontDoorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveFrontDoorDocument = gql`
    mutation SaveFrontDoor($input: FrontDoorInput!) {
  saveFrontDoor(input: $input) {
    intent
    intentText
    answeredAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveFrontDoorGQL extends Apollo.Mutation<SaveFrontDoorMutation, SaveFrontDoorMutationVariables> {
    document = SaveFrontDoorDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GoalsReportDetailsDocument = gql`
    query goalsReportDetails {
  goalsReportDetails {
    returnLink
    generatedReportDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GoalsReportDetailsGQL extends Apollo.Query<GoalsReportDetailsQuery, GoalsReportDetailsQueryVariables> {
    document = GoalsReportDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveUserPreGoalsDocument = gql`
    mutation SaveUserPreGoals($values: UserPreGoalInput!) {
  saveUserPreGoals(values: $values) {
    success
    ...updateProfileResponseFields
  }
}
    ${UpdateProfileResponseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveUserPreGoalsGQL extends Apollo.Mutation<SaveUserPreGoalsMutation, SaveUserPreGoalsMutationVariables> {
    document = SaveUserPreGoalsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetGoalsDocument = gql`
    query GetGoals {
  goals {
    ...goalsFields
  }
}
    ${GoalsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGoalsGQL extends Apollo.Query<GetGoalsQuery, GetGoalsQueryVariables> {
    document = GetGoalsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateGoalsDocument = gql`
    mutation UpdateGoals($goals: GoalsInput!) {
  updateGoals(goals: $goals) {
    success
    message
    code
    goals {
      ...goalsFields
    }
  }
}
    ${GoalsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateGoalsGQL extends Apollo.Mutation<UpdateGoalsMutation, UpdateGoalsMutationVariables> {
    document = UpdateGoalsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAiDeepInsightReportDocument = gql`
    mutation UpdateAIDeepInsightReport($conversationId: Int!, $messageId: Int!) {
  updateAIDeepInsightReport(
    conversationId: $conversationId
    messageId: $messageId
  ) {
    learningSuggestions {
      certificates {
        description
        title
        url
      }
      courses {
        title
        description
        url
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAiDeepInsightReportGQL extends Apollo.Mutation<UpdateAiDeepInsightReportMutation, UpdateAiDeepInsightReportMutationVariables> {
    document = UpdateAiDeepInsightReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAiDeepInsightDocument = gql`
    query GetAiDeepInsight {
  getAiDeepInsight {
    learningSuggestions {
      courses {
        description
        title
        url
      }
      certificates {
        description
        title
        url
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAiDeepInsightGQL extends Apollo.Query<GetAiDeepInsightQuery, GetAiDeepInsightQueryVariables> {
    document = GetAiDeepInsightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenAiGoalsReportDocument = gql`
    mutation GenAiGoalsReport($surveyData: AIGoalsReportInput!, $forceUpdate: Boolean) {
  genAiGoalsReport(surveyData: $surveyData, forceUpdate: $forceUpdate) {
    narratives {
      academicGoal {
        content
        insights
        type
      }
      careerGoal {
        content
        insights
        type
      }
      compatibility {
        content
        insights
        type
      }
      experience {
        content
        insights
        type
      }
      decisionProcess {
        content
        insights
        type
      }
      interests {
        content
        insights
        type
      }
      values {
        content
        insights
        type
      }
      lifestylePreferences {
        content
        insights
        type
      }
      motivations {
        content
        insights
        type
      }
      currentStage {
        content
        insights
        type
      }
      location {
        content
        insights
        type
      }
      funding {
        content
        insights
        type
      }
      supports {
        content
        insights
        type
      }
      constraints {
        content
        insights
        type
      }
    }
    relatedTopics {
      description
      title
    }
    outdated
    status
    rateLimit {
      allowed
      limit
      remaining
      resetTime
    }
    writtenFor {
      careerGoal
      institutionGoal
      programGoal
    }
    __typename
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenAiGoalsReportGQL extends Apollo.Mutation<GenAiGoalsReportMutation, GenAiGoalsReportMutationVariables> {
    document = GenAiGoalsReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserReclassifyingDocument = gql`
    query UserReclassifying {
  userReclassifying {
    code
    success
    message
    userReclassifying {
      transitionfrommilitary
      stayincurrent
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserReclassifyingGQL extends Apollo.Query<UserReclassifyingQuery, UserReclassifyingQueryVariables> {
    document = UserReclassifyingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const HelpArticlesDocument = gql`
    query HelpArticles {
  helpArticles {
    id
    panel
    audience
    kind
    title
    summary
    body
    videoUrl
    captionsUrl
    transcript
    updatedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class HelpArticlesGQL extends Apollo.Query<HelpArticlesQuery, HelpArticlesQueryVariables> {
    document = HelpArticlesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InstitutionsByOccupationDocument = gql`
    query InstitutionsByOccupation($onetCode: ID!, $cipCodeCutoff: CipCodeCutoffFilter!, $educationLevel: EducationLevelFilter, $online: Boolean, $openAdmission: Boolean, $regionalAccreditation: Boolean, $avarageCost: Boolean, $medianDebt: [Int], $graduationRate: [Int], $searchTerm: String, $taApproved: Boolean, $limit: Int, $offset: Int, $schoolProgramId: Int, $state: String, $allSchools: Boolean) {
  institutionsByOccupation(
    onetCode: $onetCode
    cipCodeCutoff: $cipCodeCutoff
    educationLevel: $educationLevel
    online: $online
    openAdmission: $openAdmission
    regionalAccreditation: $regionalAccreditation
    avarageCost: $avarageCost
    medianDebt: $medianDebt
    graduationRate: $graduationRate
    searchTerm: $searchTerm
    taApproved: $taApproved
    limit: $limit
    offset: $offset
    schoolProgramId: $schoolProgramId
    state: $state
    allSchools: $allSchools
  ) {
    totalCount
    items {
      ...cpdInstitutionFields
    }
  }
}
    ${CpdInstitutionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InstitutionsByOccupationGQL extends Apollo.Query<InstitutionsByOccupationQuery, InstitutionsByOccupationQueryVariables> {
    document = InstitutionsByOccupationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SchoolDetailsDocument = gql`
    query SchoolDetails($schoolId: ID!) {
  schoolDetails(schoolId: $schoolId) {
    ...cpdInstitutionFields
  }
}
    ${CpdInstitutionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SchoolDetailsGQL extends Apollo.Query<SchoolDetailsQuery, SchoolDetailsQueryVariables> {
    document = SchoolDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InstitutionProgramsDocument = gql`
    query InstitutionPrograms($schoolId: Int!, $onetCode: ID!, $cipCodeCutoff: CipCodeCutoffFilter!, $educationLevel: EducationLevelFilter, $online: Boolean, $medianEarnings: [Int]) {
  institutionPrograms(
    schoolId: $schoolId
    onetCode: $onetCode
    cipCodeCutoff: $cipCodeCutoff
    educationLevel: $educationLevel
    online: $online
    medianEarnings: $medianEarnings
  ) {
    ...cpdProgramFields
  }
}
    ${CpdProgramFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InstitutionProgramsGQL extends Apollo.Query<InstitutionProgramsQuery, InstitutionProgramsQueryVariables> {
    document = InstitutionProgramsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InstitutionsByProgramDocument = gql`
    query institutionsByProgram($programCipCode: String!, $programName: String!, $educationLevel: EducationLevelFilter!, $searchTerm: String, $online: Boolean = false, $openAdmission: Boolean = false, $regionalAccreditation: Boolean = null, $taApproved: Boolean = null) {
  institutionsByProgram(
    programCipCode: $programCipCode
    programName: $programName
    educationLevel: $educationLevel
    searchTerm: $searchTerm
    online: $online
    openAdmission: $openAdmission
    regionalAccreditation: $regionalAccreditation
    taApproved: $taApproved
  ) {
    ...cpdInstitutionFields
  }
}
    ${CpdInstitutionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InstitutionsByProgramGQL extends Apollo.Query<InstitutionsByProgramQuery, InstitutionsByProgramQueryVariables> {
    document = InstitutionsByProgramDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchSchoolsDocument = gql`
    query SearchSchools($searchTerm: String!) {
  searchSchools: searchSchoolsWithFuzzy(searchTerm: $searchTerm) {
    search {
      id
      name
    }
    fuzzy {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchSchoolsGQL extends Apollo.Query<SearchSchoolsQuery, SearchSchoolsQueryVariables> {
    document = SearchSchoolsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SchoolProgramFitDocument = gql`
    query SchoolProgramFit($schoolId: Int!, $schoolProgramId: Int!, $schoolProgramEdLevelId: Int, $onetCode: ID!) {
  schoolProgramFit(
    schoolId: $schoolId
    schoolProgramId: $schoolProgramId
    schoolProgramEdLevelId: $schoolProgramEdLevelId
    onetCode: $onetCode
  ) {
    offered
    offeredProgramId
    suggestions {
      schoolProgramId
      programName
      cipCode
      schoolProgramEdLevelId
      alignment
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SchoolProgramFitGQL extends Apollo.Query<SchoolProgramFitQuery, SchoolProgramFitQueryVariables> {
    document = SchoolProgramFitDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchLocationsDocument = gql`
    query SearchLocations($searchTerm: String!) {
  searchLocations(searchTerm: $searchTerm) {
    cityName
    stateAbbreviation
    zipCode
    marketArea
    marketAreaCityName
    marketAreaStateAbbreviation
    countyFipsCode
    countyName
    latitude
    longitude
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchLocationsGQL extends Apollo.Query<SearchLocationsQuery, SearchLocationsQueryVariables> {
    document = SearchLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LocationByAttributeDocument = gql`
    query locationByAttribute($onetCodeDemand: ID, $highVetPercent: Boolean, $lowCostOfLiving: Boolean, $lowUnemployment: Boolean, $affordableRealEstate: Boolean, $lowCrimeRate: Boolean, $goodAirQuality: Boolean) {
  locationByAttribute(
    onetCodeDemand: $onetCodeDemand
    highVetPercent: $highVetPercent
    lowCostOfLiving: $lowCostOfLiving
    lowUnemployment: $lowUnemployment
    affordableRealEstate: $affordableRealEstate
    lowCrimeRate: $lowCrimeRate
    goodAirQuality: $goodAirQuality
  ) {
    costOfLiving
    crimeRate
    demand
    fipsCode
    housingCostIndex
    lat
    lon
    name
    pctOfGoodAirQualityDays
    unemploymentRate
    veteranPopulation
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LocationByAttributeGQL extends Apollo.Query<LocationByAttributeQuery, LocationByAttributeQueryVariables> {
    document = LocationByAttributeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NoteMagicLinkRequestDocument = gql`
    mutation NoteMagicLinkRequest($email: String!) {
  noteMagicLinkRequest(email: $email)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NoteMagicLinkRequestGQL extends Apollo.Mutation<NoteMagicLinkRequestMutation, NoteMagicLinkRequestMutationVariables> {
    document = NoteMagicLinkRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchMajorsDocument = gql`
    query SearchMajors($searchTerm: String!) {
  searchMajors(searchTerm: $searchTerm) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchMajorsGQL extends Apollo.Query<SearchMajorsQuery, SearchMajorsQueryVariables> {
    document = SearchMajorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AirbaseLocationsDocument = gql`
    query airbaseLocations($searchTerm: String!) {
  airbaseLocations(searchTerm: $searchTerm) {
    id
    majcom
    assignedbase
    active
    nationalguard
    reserve
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AirbaseLocationsGQL extends Apollo.Query<AirbaseLocationsQuery, AirbaseLocationsQueryVariables> {
    document = AirbaseLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveUserAirbaseLocationDocument = gql`
    mutation saveUserAirbaseLocation($airbaseLocationId: ID!) {
  saveUserAirbaseLocation(airbaseLocationId: $airbaseLocationId) {
    success
    message
    code
    ...updateProfileResponseFields
  }
}
    ${UpdateProfileResponseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveUserAirbaseLocationGQL extends Apollo.Mutation<SaveUserAirbaseLocationMutation, SaveUserAirbaseLocationMutationVariables> {
    document = SaveUserAirbaseLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InstallationLocationsDocument = gql`
    query installationLocations($branchCode: String!, $searchTerm: String) {
  installationLocations(branchCode: $branchCode, searchTerm: $searchTerm) {
    ...installationLocationFields
  }
}
    ${InstallationLocationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InstallationLocationsGQL extends Apollo.Query<InstallationLocationsQuery, InstallationLocationsQueryVariables> {
    document = InstallationLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveUserInstallationDocument = gql`
    mutation saveUserInstallation($installationId: ID!) {
  saveUserInstallation(installationId: $installationId) {
    success
    message
    code
    ...updateProfileResponseFields
  }
}
    ${UpdateProfileResponseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveUserInstallationGQL extends Apollo.Mutation<SaveUserInstallationMutation, SaveUserInstallationMutationVariables> {
    document = SaveUserInstallationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MilitaryServeTypeDocument = gql`
    query militaryServeType($branchCode: String!) {
  militaryServeType(branchCode: $branchCode) {
    branchCode
    name
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MilitaryServeTypeGQL extends Apollo.Query<MilitaryServeTypeQuery, MilitaryServeTypeQueryVariables> {
    document = MilitaryServeTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveUserMilitaryServeTypeDocument = gql`
    mutation saveUserMilitaryServeType($id: Int) {
  saveUserMilitaryServeType(id: $id) {
    success
    message
    code
    ...updateProfileResponseFields
  }
}
    ${UpdateProfileResponseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveUserMilitaryServeTypeGQL extends Apollo.Mutation<SaveUserMilitaryServeTypeMutation, SaveUserMilitaryServeTypeMutationVariables> {
    document = SaveUserMilitaryServeTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SpacebaseLocationsDocument = gql`
    query spacebaseLocations($searchTerm: String!) {
  spacebaseLocations(searchTerm: $searchTerm) {
    id
    assignedbase
    active
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SpacebaseLocationsGQL extends Apollo.Query<SpacebaseLocationsQuery, SpacebaseLocationsQueryVariables> {
    document = SpacebaseLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveUserSpacebaseLocationDocument = gql`
    mutation saveUserSpacebaseLocation($spacebaseLocationId: ID!) {
  saveUserSpacebaseLocation(spacebaseLocationId: $spacebaseLocationId) {
    success
    message
    code
    ...updateProfileResponseFields
  }
}
    ${UpdateProfileResponseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveUserSpacebaseLocationGQL extends Apollo.Mutation<SaveUserSpacebaseLocationMutation, SaveUserSpacebaseLocationMutationVariables> {
    document = SaveUserSpacebaseLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NewsDocument = gql`
    query news {
  news {
    ...newsFields
  }
  newsTypes {
    ...newsTypeFields
  }
}
    ${NewsFieldsFragmentDoc}
${NewsTypeFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class NewsGQL extends Apollo.Query<NewsQuery, NewsQueryVariables> {
    document = NewsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReactOnNewsDocument = gql`
    mutation reactOnNews($input: NewsReactionInput) {
  reactOnNews(input: $input) {
    ...newsFields
  }
}
    ${NewsFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ReactOnNewsGQL extends Apollo.Mutation<ReactOnNewsMutation, ReactOnNewsMutationVariables> {
    document = ReactOnNewsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNotificationsDocument = gql`
    query GetNotifications($includeDismissed: Boolean) {
  notifications(includeDismissed: $includeDismissed) {
    ...notificationFields
  }
}
    ${NotificationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNotificationsGQL extends Apollo.Query<GetNotificationsQuery, GetNotificationsQueryVariables> {
    document = GetNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DismissNotificationDocument = gql`
    mutation DismissNotification($id: ID!) {
  dismissNotification(id: $id) {
    success
    notification {
      ...notificationFields
    }
  }
}
    ${NotificationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DismissNotificationGQL extends Apollo.Mutation<DismissNotificationMutation, DismissNotificationMutationVariables> {
    document = DismissNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OccupationListHighGrowthDocument = gql`
    query OccupationListHighGrowth {
  getOccupationList(type: HIGH_GROWTH) {
    onetCode
    description
    title
    projectedGrowth
    growthRateBand
    militaryOccupationCount
    annualWageLower
    annualWageHighest
    medianAnnualWage
    imageName
    videoId
    alternateTitle
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OccupationListHighGrowthGQL extends Apollo.Query<OccupationListHighGrowthQuery, OccupationListHighGrowthQueryVariables> {
    document = OccupationListHighGrowthDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OccupationListMilitaryFriendlyDocument = gql`
    query OccupationListMilitaryFriendly {
  getOccupationList(type: MILITARY_FRIENDLY) {
    onetCode
    description
    title
    projectedGrowth
    growthRateBand
    militaryOccupationCount
    annualWageLower
    annualWageHighest
    medianAnnualWage
    imageName
    videoId
    alternateTitle
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OccupationListMilitaryFriendlyGQL extends Apollo.Query<OccupationListMilitaryFriendlyQuery, OccupationListMilitaryFriendlyQueryVariables> {
    document = OccupationListMilitaryFriendlyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOccupationListByCountyDocument = gql`
    query GetOccupationListByCounty($param: String!) {
  getOccupationList(type: BY_COUNTY, param: $param) {
    onetCode
    onetCode
    description
    title
    alternateTitle
    projectedGrowth
    growthRateBand
    militaryOccupationCount
    annualWageLower
    annualWageHighest
    medianAnnualWage
    imageName
    videoId
    typicalWorkExperienceCategoryTypeId
    typicalWorkExperienceCategoryTypeName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOccupationListByCountyGQL extends Apollo.Query<GetOccupationListByCountyQuery, GetOccupationListByCountyQueryVariables> {
    document = GetOccupationListByCountyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOccupationListByDegreeDocument = gql`
    query GetOccupationListByDegree($param: String!) {
  getOccupationList(type: BY_DEGREE, param: $param) {
    onetCode
    onetCode
    description
    title
    alternateTitle
    projectedGrowth
    growthRateBand
    militaryOccupationCount
    annualWageLower
    annualWageHighest
    medianAnnualWage
    imageName
    videoId
    typicalWorkExperienceCategoryTypeId
    typicalWorkExperienceCategoryTypeName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOccupationListByDegreeGQL extends Apollo.Query<GetOccupationListByDegreeQuery, GetOccupationListByDegreeQueryVariables> {
    document = GetOccupationListByDegreeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOccupationCardsDocument = gql`
    query GetOccupationCards($state: String) {
  getOccupationCards(state: $state) {
    ...occupationCardFields
    industryCode
    industry
    wageState
  }
}
    ${OccupationCardFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOccupationCardsGQL extends Apollo.Query<GetOccupationCardsQuery, GetOccupationCardsQueryVariables> {
    document = GetOccupationCardsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OccupationStatePayDocument = gql`
    query OccupationStatePay($state: String!, $onetCodes: [ID!]!) {
  occupationStatePay(state: $state, onetCodes: $onetCodes) {
    onetCode
    state
    medianAnnualWage
    areaCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OccupationStatePayGQL extends Apollo.Query<OccupationStatePayQuery, OccupationStatePayQueryVariables> {
    document = OccupationStatePayDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OccupationStatePayStatesDocument = gql`
    query OccupationStatePayStates($onetCodes: [ID!]!) {
  occupationStatePayStates(onetCodes: $onetCodes) {
    state
    occupationCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OccupationStatePayStatesGQL extends Apollo.Query<OccupationStatePayStatesQuery, OccupationStatePayStatesQueryVariables> {
    document = OccupationStatePayStatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FavoriteOccupationsDocument = gql`
    query FavoriteOccupations {
  favoriteOccupations {
    ...favoriteOccupationFields
  }
}
    ${FavoriteOccupationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FavoriteOccupationsGQL extends Apollo.Query<FavoriteOccupationsQuery, FavoriteOccupationsQueryVariables> {
    document = FavoriteOccupationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOccupationDetailDocument = gql`
    query GetOccupationDetail($onetCode: ID!, $jobId: String, $jobTitle: String) {
  occupation(onetCode: $onetCode, jobId: $jobId, jobTitle: $jobTitle) {
    ...occupationFields
  }
}
    ${OccupationFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOccupationDetailGQL extends Apollo.Query<GetOccupationDetailQuery, GetOccupationDetailQueryVariables> {
    document = GetOccupationDetailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSimilarMilitaryOccupationsDocument = gql`
    query GetSimilarMilitaryOccupations($onetCode: String, $search: String) {
  getSimilarMilitaryOccupations(onetCode: $onetCode, search: $search) {
    mocCode
    mocTitle
    branchCode
    isFavorite
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSimilarMilitaryOccupationsGQL extends Apollo.Query<GetSimilarMilitaryOccupationsQuery, GetSimilarMilitaryOccupationsQueryVariables> {
    document = GetSimilarMilitaryOccupationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OccupationForExportPdfDocument = gql`
    query OccupationForExportPdf($onetCode: ID!, $jobId: String, $jobTitle: String) {
  occupation(onetCode: $onetCode, jobId: $jobId, jobTitle: $jobTitle) {
    ...occupationForReportFields
  }
}
    ${OccupationForReportFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OccupationForExportPdfGQL extends Apollo.Query<OccupationForExportPdfQuery, OccupationForExportPdfQueryVariables> {
    document = OccupationForExportPdfDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchOccupationsDocument = gql`
    query SearchOccupations($searchTerm: String!) {
  searchOccupations: searchOccupationsWithFuzzy(searchTerm: $searchTerm) {
    search {
      onetCode
      description
      title
      projectedGrowth
      growthRateBand
      militaryOccupationCount
      annualWageLower
      annualWageHighest
      imageName
      videoId
      alternateTitle
      alternateTitleId
      industryCode
      typicalWorkExperienceCategoryTypeId
      typicalWorkExperienceCategoryTypeName
    }
    fuzzy {
      onetCode
      description
      title
      projectedGrowth
      growthRateBand
      militaryOccupationCount
      annualWageLower
      annualWageHighest
      imageName
      videoId
      alternateTitle
      alternateTitleId
      industryCode
      typicalWorkExperienceCategoryTypeId
      typicalWorkExperienceCategoryTypeName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchOccupationsGQL extends Apollo.Query<SearchOccupationsQuery, SearchOccupationsQueryVariables> {
    document = SearchOccupationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFavoriteOccupationDocument = gql`
    mutation UpdateFavoriteOccupation($onetCode: ID!, $jobId: Int) {
  favoriteOccupation(onetCode: $onetCode, jobId: $jobId) {
    code
    success
    message
    favoriteOccupation {
      onetSocCode
      jobId
      title
      growthRateBand
      medianAnnualWage
      medianHourlyWage
      imageName
      skillsMatchQualityId
      interestsMatchQualityId
      valuesMatchQualityId
      lifestyleMatchQualityId
      isMatch
      isOverqualified
      isFavorite
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFavoriteOccupationGQL extends Apollo.Mutation<UpdateFavoriteOccupationMutation, UpdateFavoriteOccupationMutationVariables> {
    document = UpdateFavoriteOccupationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnfavoriteOccupationDocument = gql`
    mutation UnfavoriteOccupation($onetCode: ID!, $jobId: Int) {
  unfavoriteOccupation(onetCode: $onetCode, jobId: $jobId) {
    code
    success
    message
    favoriteOccupation {
      onetSocCode
      jobId
      title
      growthRateBand
      medianAnnualWage
      medianHourlyWage
      imageName
      skillsMatchQualityId
      interestsMatchQualityId
      valuesMatchQualityId
      lifestyleMatchQualityId
      isMatch
      isOverqualified
      isFavorite
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnfavoriteOccupationGQL extends Apollo.Mutation<UnfavoriteOccupationMutation, UnfavoriteOccupationMutationVariables> {
    document = UnfavoriteOccupationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FavoriteMilitaryOccupationsDocument = gql`
    query FavoriteMilitaryOccupations {
  favoriteMilitaryOccupations {
    mocCode
    mocTitle
    branchCode
    isFavorite
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FavoriteMilitaryOccupationsGQL extends Apollo.Query<FavoriteMilitaryOccupationsQuery, FavoriteMilitaryOccupationsQueryVariables> {
    document = FavoriteMilitaryOccupationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FavoriteMilitaryOccupationDocument = gql`
    mutation FavoriteMilitaryOccupation($mocCode: String!, $mocTitle: String!) {
  favoriteMilitaryOccupation(mocCode: $mocCode, mocTitle: $mocTitle) {
    favoriteMilitaryOccupation {
      mocCode
      mocTitle
      branchCode
      isFavorite
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FavoriteMilitaryOccupationGQL extends Apollo.Mutation<FavoriteMilitaryOccupationMutation, FavoriteMilitaryOccupationMutationVariables> {
    document = FavoriteMilitaryOccupationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnfavoriteMilitaryOccupationDocument = gql`
    mutation UnfavoriteMilitaryOccupation($mocCode: String!, $mocTitle: String!) {
  unfavoriteMilitaryOccupation(mocCode: $mocCode, mocTitle: $mocTitle) {
    success
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnfavoriteMilitaryOccupationGQL extends Apollo.Mutation<UnfavoriteMilitaryOccupationMutation, UnfavoriteMilitaryOccupationMutationVariables> {
    document = UnfavoriteMilitaryOccupationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateReclassifyingDocument = gql`
    mutation UpdateReclassifying($transitionfrommilitary: Boolean, $stayincurrent: Boolean) {
  updateReclassifying(
    transitionfrommilitary: $transitionfrommilitary
    stayincurrent: $stayincurrent
  ) {
    userReclassifying {
      transitionfrommilitary
      stayincurrent
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateReclassifyingGQL extends Apollo.Mutation<UpdateReclassifyingMutation, UpdateReclassifyingMutationVariables> {
    document = UpdateReclassifyingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConnectOrganizationStateDocument = gql`
    query GetConnectOrganizationState {
  getConnectOrganizationState {
    academic
    employer
    nonprofit
    totalCount
    autoShareEnabled
    premiumPartnerIds
    hasOutdatedConnection
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConnectOrganizationStateGQL extends Apollo.Query<GetConnectOrganizationStateQuery, GetConnectOrganizationStateQueryVariables> {
    document = GetConnectOrganizationStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPremiumPartnersDocument = gql`
    query GetPremiumPartners {
  getPremiumPartners {
    id
    name
    slug
    description
    logoUrl
    website
    disclosureText
    additionalFieldsSchema
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPremiumPartnersGQL extends Apollo.Query<GetPremiumPartnersQuery, GetPremiumPartnersQueryVariables> {
    document = GetPremiumPartnersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConnectWithPremiumPartnerDocument = gql`
    mutation ConnectWithPremiumPartner($input: PremiumPartnerConnectionInput!) {
  connectWithPremiumPartner(input: $input) {
    id
    consentedAt
    revokedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConnectWithPremiumPartnerGQL extends Apollo.Mutation<ConnectWithPremiumPartnerMutation, ConnectWithPremiumPartnerMutationVariables> {
    document = ConnectWithPremiumPartnerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevokePremiumPartnerConnectionDocument = gql`
    mutation RevokePremiumPartnerConnection($premiumPartnerId: ID!) {
  revokePremiumPartnerConnection(premiumPartnerId: $premiumPartnerId) {
    id
    revokedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevokePremiumPartnerConnectionGQL extends Apollo.Mutation<RevokePremiumPartnerConnectionMutation, RevokePremiumPartnerConnectionMutationVariables> {
    document = RevokePremiumPartnerConnectionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMatchedOrganizationsDocument = gql`
    query GetMatchedOrganizations {
  getMatchedOrganizations {
    academic
    employer
    nonprofit
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMatchedOrganizationsGQL extends Apollo.Query<GetMatchedOrganizationsQuery, GetMatchedOrganizationsQueryVariables> {
    document = GetMatchedOrganizationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrganizationDocument = gql`
    query GetOrganization($type: OrganizationType!, $query: String) {
  getOrganizations(type: $type, query: $query) {
    id
    name
    description
    logo
    website
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrganizationGQL extends Apollo.Query<GetOrganizationQuery, GetOrganizationQueryVariables> {
    document = GetOrganizationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAcademicsDocument = gql`
    query GetAcademics($query: String) {
  getOrganizations(type: ACADEMIC, query: $query) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAcademicsGQL extends Apollo.Query<GetAcademicsQuery, GetAcademicsQueryVariables> {
    document = GetAcademicsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConnectWithOrganizationsDocument = gql`
    mutation ConnectWithOrganizations($academicIds: [ID!], $employerIds: [ID!], $nonprofitIds: [ID!], $autoShareEnabled: Boolean) {
  connectWithOrganizations(
    academicIds: $academicIds
    employerIds: $employerIds
    nonprofitIds: $nonprofitIds
    autoShareEnabled: $autoShareEnabled
  ) {
    connectedCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConnectWithOrganizationsGQL extends Apollo.Mutation<ConnectWithOrganizationsMutation, ConnectWithOrganizationsMutationVariables> {
    document = ConnectWithOrganizationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcknowledgeOutdatedConnectionsDocument = gql`
    mutation AcknowledgeOutdatedConnections {
  acknowledgeOutdatedConnections {
    autoShareEnabled
    hasOutdatedConnection
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AcknowledgeOutdatedConnectionsGQL extends Apollo.Mutation<AcknowledgeOutdatedConnectionsMutation, AcknowledgeOutdatedConnectionsMutationVariables> {
    document = AcknowledgeOutdatedConnectionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PathwayDocument = gql`
    query Pathway($pathwayId: ID!) {
  pathway(pathwayId: $pathwayId) {
    ...pathwayFields
  }
}
    ${PathwayFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PathwayGQL extends Apollo.Query<PathwayQuery, PathwayQueryVariables> {
    document = PathwayDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPathwayCardsDocument = gql`
    query GetPathwayCards {
  getPathwayCards {
    pathwayId
    name
    imageUrl
    sponsorshipCompany {
      logo
    }
    minSalary
    medianSalary
    maxSalary
    occupationCount
    skillsmatch
    interestsmatch
    valuesmatch
    lifestylematch
    devPublish
    prodPublish
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPathwayCardsGQL extends Apollo.Query<GetPathwayCardsQuery, GetPathwayCardsQueryVariables> {
    document = GetPathwayCardsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyPortfolioDocument = gql`
    query MyPortfolio {
  myPortfolio {
    ...portfolioFields
  }
}
    ${PortfolioFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MyPortfolioGQL extends Apollo.Query<MyPortfolioQuery, MyPortfolioQueryVariables> {
    document = MyPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublicPortfolioDocument = gql`
    query PublicPortfolio($slug: ID!) {
  publicPortfolio(slug: $slug) {
    slug
    published
    publishedAt
    viaQuestionsLeft
    viaQuestionsLimit
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PublicPortfolioGQL extends Apollo.Query<PublicPortfolioQuery, PublicPortfolioQueryVariables> {
    document = PublicPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SavePortfolioDocument = gql`
    mutation SavePortfolio($draft: JSON!) {
  savePortfolio(draft: $draft) {
    ...portfolioFields
  }
}
    ${PortfolioFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SavePortfolioGQL extends Apollo.Mutation<SavePortfolioMutation, SavePortfolioMutationVariables> {
    document = SavePortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PublishPortfolioDocument = gql`
    mutation PublishPortfolio {
  publishPortfolio {
    ...portfolioFields
  }
}
    ${PortfolioFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PublishPortfolioGQL extends Apollo.Mutation<PublishPortfolioMutation, PublishPortfolioMutationVariables> {
    document = PublishPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UnpublishPortfolioDocument = gql`
    mutation UnpublishPortfolio {
  unpublishPortfolio {
    ...portfolioFields
  }
}
    ${PortfolioFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UnpublishPortfolioGQL extends Apollo.Mutation<UnpublishPortfolioMutation, UnpublishPortfolioMutationVariables> {
    document = UnpublishPortfolioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyResumeDocument = gql`
    query MyResume {
  myResume {
    id
    document
    theme
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MyResumeGQL extends Apollo.Query<MyResumeQuery, MyResumeQueryVariables> {
    document = MyResumeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveResumeDocument = gql`
    mutation SaveResume($document: JSON!, $theme: String, $resumeId: ID) {
  saveResume(document: $document, theme: $theme, resumeId: $resumeId) {
    id
    document
    theme
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveResumeGQL extends Apollo.Mutation<SaveResumeMutation, SaveResumeMutationVariables> {
    document = SaveResumeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AskPortfolioViaDocument = gql`
    mutation AskPortfolioVia($slug: ID!, $question: String!, $role: String) {
  askPortfolioVia(slug: $slug, question: $question, role: $role) {
    answer
    outcome
    remaining
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AskPortfolioViaGQL extends Apollo.Mutation<AskPortfolioViaMutation, AskPortfolioViaMutationVariables> {
    document = AskPortfolioViaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyPortfolioViaUsageDocument = gql`
    query MyPortfolioViaUsage {
  myPortfolioViaUsage {
    used
    limit
    remaining
    enabled
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MyPortfolioViaUsageGQL extends Apollo.Query<MyPortfolioViaUsageQuery, MyPortfolioViaUsageQueryVariables> {
    document = MyPortfolioViaUsageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetPortfolioViaEnabledDocument = gql`
    mutation SetPortfolioViaEnabled($enabled: Boolean!) {
  setPortfolioViaEnabled(enabled: $enabled)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetPortfolioViaEnabledGQL extends Apollo.Mutation<SetPortfolioViaEnabledMutation, SetPortfolioViaEnabledMutationVariables> {
    document = SetPortfolioViaEnabledDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PowerBiDocument = gql`
    query PowerBI {
  getReportEmbedConfig {
    id
    embedUrl
    type
    embedToken {
      token
      tokenId
      expiration
    }
    minutesToExpiration
    defaultPage
    mobileDefaultPage
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PowerBiGQL extends Apollo.Query<PowerBiQuery, PowerBiQueryVariables> {
    document = PowerBiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MilitaryBranchesDocument = gql`
    query MilitaryBranches {
  militaryBranches {
    branchCode
    branchTitle
    branchLabel
    mocSubstitute
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MilitaryBranchesGQL extends Apollo.Query<MilitaryBranchesQuery, MilitaryBranchesQueryVariables> {
    document = MilitaryBranchesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExtendedMilitaryBranchesDocument = gql`
    query ExtendedMilitaryBranches {
  extendedMilitaryBranches {
    branchCode
    extendedBranchCode
    extendedBranchTitle
    mocSubstitute
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExtendedMilitaryBranchesGQL extends Apollo.Query<ExtendedMilitaryBranchesQuery, ExtendedMilitaryBranchesQueryVariables> {
    document = ExtendedMilitaryBranchesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InterestQuestionsDocument = gql`
    query interestQuestions {
  interestQuestions {
    interestsId
    question
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InterestQuestionsGQL extends Apollo.Query<InterestQuestionsQuery, InterestQuestionsQueryVariables> {
    document = InterestQuestionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchRanksDocument = gql`
    query searchRanks($searchTerm: String!, $branchCode: String!) {
  searchRanks(searchTerm: $searchTerm, branchCode: $branchCode) {
    payGrade
    title
    abbreviation
    branchCode
    mpcCode
    payGradeLevel
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchRanksGQL extends Apollo.Query<SearchRanksQuery, SearchRanksQueryVariables> {
    document = SearchRanksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchMocsDocument = gql`
    query searchMocs($searchTerm: String!, $branchCode: String!, $extendedBranchCode: String, $activeType: String!, $mpcCode: String) {
  searchMocs(
    searchTerm: $searchTerm
    branchCode: $branchCode
    extendedBranchCode: $extendedBranchCode
    activeType: $activeType
    mpcCode: $mpcCode
  ) {
    mocCode
    mocTitle
    branchCode
    extendedBranchCode
    mpcCode
    status
    hasEnlisted
    hasWarrantOfficer
    hasCommissionOfficer
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchMocsGQL extends Apollo.Query<SearchMocsQuery, SearchMocsQueryVariables> {
    document = SearchMocsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EducationLevelsDocument = gql`
    query educationLevels {
  educationLevels {
    educationAdj
    educationLevelId
    educationLevelShortDescr
    educationLevelName
    percentage
    altLabel
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EducationLevelsGQL extends Apollo.Query<EducationLevelsQuery, EducationLevelsQueryVariables> {
    document = EducationLevelsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchDegreesDocument = gql`
    query searchDegrees($searchTerm: String!) {
  searchDegrees: searchDegreesWithFuzzy(searchTerm: $searchTerm) {
    search {
      cipCode
      id
      title
    }
    fuzzy {
      cipCode
      id
      title
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchDegreesGQL extends Apollo.Query<SearchDegreesQuery, SearchDegreesQueryVariables> {
    document = SearchDegreesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchDegreesForCcafDocument = gql`
    query searchDegreesForCCAF($searchTerm: String!) {
  searchDegreesForCCAF: searchDegreesForCCAFWithFuzzy(searchTerm: $searchTerm) {
    search {
      cipCode
      id
      title
    }
    fuzzy {
      cipCode
      id
      title
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchDegreesForCcafGQL extends Apollo.Query<SearchDegreesForCcafQuery, SearchDegreesForCcafQueryVariables> {
    document = SearchDegreesForCcafDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateValuesDocument = gql`
    mutation updateValues($values: [ValuesInput!]!) {
  updateValues(values: $values) {
    success
    message
    code
    ...updateProfileResponseFields
  }
}
    ${UpdateProfileResponseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateValuesGQL extends Apollo.Mutation<UpdateValuesMutation, UpdateValuesMutationVariables> {
    document = UpdateValuesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateInterestsDocument = gql`
    mutation updateInterests($interests: [InterestInput!]!, $trackerId: String) {
  updateInterests(interests: $interests, trackerId: $trackerId) {
    success
    message
    code
    ...updateProfileResponseFields
  }
}
    ${UpdateProfileResponseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateInterestsGQL extends Apollo.Mutation<UpdateInterestsMutation, UpdateInterestsMutationVariables> {
    document = UpdateInterestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLifestyleDocument = gql`
    mutation updateLifestyle($lifestyle: LifestyleInput!) {
  updateLifestyle(lifestyle: $lifestyle) {
    success
    message
    code
    ...updateProfileResponseFields
  }
}
    ${UpdateProfileResponseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLifestyleGQL extends Apollo.Mutation<UpdateLifestyleMutation, UpdateLifestyleMutationVariables> {
    document = UpdateLifestyleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddPreferredLocationDocument = gql`
    mutation addPreferredLocation($location: CPDLocationInput!) {
  addPreferredLocation(location: $location) {
    success
    message
    code
    ...updateProfileResponseFields
  }
}
    ${UpdateProfileResponseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddPreferredLocationGQL extends Apollo.Mutation<AddPreferredLocationMutation, AddPreferredLocationMutationVariables> {
    document = AddPreferredLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePreferredLocationDocument = gql`
    mutation deletePreferredLocation($location: CPDLocationInput!) {
  deletePreferredLocation(location: $location) {
    success
    message
    code
    ...updateProfileResponseFields
  }
}
    ${UpdateProfileResponseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePreferredLocationGQL extends Apollo.Mutation<DeletePreferredLocationMutation, DeletePreferredLocationMutationVariables> {
    document = DeletePreferredLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSkillsDocument = gql`
    mutation updateSkills($skills: SkillsInput!) {
  updateSkills(skills: $skills) {
    success
    message
    code
    ...updateProfileResponseFields
  }
}
    ${UpdateProfileResponseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSkillsGQL extends Apollo.Mutation<UpdateSkillsMutation, UpdateSkillsMutationVariables> {
    document = UpdateSkillsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReturnSessionDocument = gql`
    mutation ReturnSession($mailTo: String!) {
  returnSession(mailTo: $mailTo) {
    code
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReturnSessionGQL extends Apollo.Mutation<ReturnSessionMutation, ReturnSessionMutationVariables> {
    document = ReturnSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcceptPrivacyPolicyDocument = gql`
    mutation acceptPrivacyPolicy($values: Boolean) {
  acceptPrivacyPolicy(values: $values) {
    success
    ...updateProfileResponseFields
  }
}
    ${UpdateProfileResponseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AcceptPrivacyPolicyGQL extends Apollo.Mutation<AcceptPrivacyPolicyMutation, AcceptPrivacyPolicyMutationVariables> {
    document = AcceptPrivacyPolicyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProfileWorkTypeDocument = gql`
    mutation UpdateProfileWorkType($values: ProfileWorkTypeInput) {
  updateProfileWorkType(values: $values) {
    success
    ...updateProfileResponseFields
  }
}
    ${UpdateProfileResponseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProfileWorkTypeGQL extends Apollo.Mutation<UpdateProfileWorkTypeMutation, UpdateProfileWorkTypeMutationVariables> {
    document = UpdateProfileWorkTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveUserProgramGoalsDocument = gql`
    mutation SaveUserProgramGoals($values: UserProgramGoalInput!) {
  saveUserProgramGoals(values: $values) {
    success
    ...updateProfileResponseFields
  }
}
    ${UpdateProfileResponseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveUserProgramGoalsGQL extends Apollo.Mutation<SaveUserProgramGoalsMutation, SaveUserProgramGoalsMutationVariables> {
    document = SaveUserProgramGoalsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveUserSchoolGoalsDocument = gql`
    mutation SaveUserSchoolGoals($values: UserSchoolGoalInput!) {
  saveUserSchoolGoals(values: $values) {
    success
    ...updateProfileResponseFields
  }
}
    ${UpdateProfileResponseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveUserSchoolGoalsGQL extends Apollo.Mutation<SaveUserSchoolGoalsMutation, SaveUserSchoolGoalsMutationVariables> {
    document = SaveUserSchoolGoalsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveUserMilitaryTerminationDocument = gql`
    mutation SaveUserMilitaryTermination($values: UserTerminationInput) {
  saveUserMilitaryTermination(values: $values) {
    success
    ...updateProfileResponseFields
  }
}
    ${UpdateProfileResponseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveUserMilitaryTerminationGQL extends Apollo.Mutation<SaveUserMilitaryTerminationMutation, SaveUserMilitaryTerminationMutationVariables> {
    document = SaveUserMilitaryTerminationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveUserWorkTerminationDocument = gql`
    mutation SaveUserWorkTermination($values: UserTerminationInput) {
  saveUserWorkTermination(values: $values) {
    success
    ...updateProfileResponseFields
  }
}
    ${UpdateProfileResponseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveUserWorkTerminationGQL extends Apollo.Mutation<SaveUserWorkTerminationMutation, SaveUserWorkTerminationMutationVariables> {
    document = SaveUserWorkTerminationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveAsvabScoresDocument = gql`
    mutation SaveAsvabScores($scores: AsvabScoresInput!) {
  saveAsvabScores(scores: $scores) {
    success
    ...updateProfileResponseFields
  }
}
    ${UpdateProfileResponseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveAsvabScoresGQL extends Apollo.Mutation<SaveAsvabScoresMutation, SaveAsvabScoresMutationVariables> {
    document = SaveAsvabScoresDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveAsvabScoreSetDocument = gql`
    mutation SaveAsvabScoreSet($scores: [AsvabScoreInput!]!) {
  saveAsvabScoreSet(scores: $scores) {
    success
    message
    ...updateProfileResponseFields
  }
}
    ${UpdateProfileResponseFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveAsvabScoreSetGQL extends Apollo.Mutation<SaveAsvabScoreSetMutation, SaveAsvabScoreSetMutationVariables> {
    document = SaveAsvabScoreSetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProgramsByOccupationDocument = gql`
    query programsByOccupation($onetCode: ID!, $cipCodeCutoff: CipCodeCutoffFilter!, $searchTerm: String, $educationLevel: EducationLevelFilter, $jobId: ID = null, $online: Boolean = false) {
  programsByOccupation(
    onetCode: $onetCode
    cipCodeCutoff: $cipCodeCutoff
    searchTerm: $searchTerm
    educationLevel: $educationLevel
    jobId: $jobId
    online: $online
  ) {
    ...cpdProgramFields
  }
}
    ${CpdProgramFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ProgramsByOccupationGQL extends Apollo.Query<ProgramsByOccupationQuery, ProgramsByOccupationQueryVariables> {
    document = ProgramsByOccupationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyReportShareDocument = gql`
    query MyReportShare {
  myReportShare {
    ...reportShareFields
  }
}
    ${ReportShareFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MyReportShareGQL extends Apollo.Query<MyReportShareQuery, MyReportShareQueryVariables> {
    document = MyReportShareDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ShareReportDocument = gql`
    mutation ShareReport {
  shareReport {
    ...reportShareFields
  }
}
    ${ReportShareFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ShareReportGQL extends Apollo.Mutation<ShareReportMutation, ShareReportMutationVariables> {
    document = ShareReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RevokeReportShareDocument = gql`
    mutation RevokeReportShare {
  revokeReportShare
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RevokeReportShareGQL extends Apollo.Mutation<RevokeReportShareMutation, RevokeReportShareMutationVariables> {
    document = RevokeReportShareDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SharedReportDocument = gql`
    query SharedReport($token: ID!) {
  sharedReport(token: $token) {
    memberFirstName
    sharedAt
    expiresAt
    generatedReportDate
    onetCode
    occupation {
      title
      medianAnnualWage
      edLevelPercent
      edLevelDescription
      matches {
        skillsMatchQuality
        interestsMatchQuality
        lifestyleMatchQuality
        valuesMatchQuality
      }
    }
    school {
      institutionName
      address
      telephoneNumber
      website
      creditForMilitaryTraining
      creditForLifeExperiences
      openAdmissionPolicy
      dedicatedPOCforServiceMembers
      schoolPlacementServices
      averageCostSH
      percentOfDistanceLearners
    }
    degree {
      programName
      schoolProgramEdLevelName
      isRecommendedProgram
      occupationsRelatedToDegree {
        title
      }
    }
    certification {
      certName
      certUrl
      certifyingOrgName
    }
    license {
      licName
      licOrgName
      state
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SharedReportGQL extends Apollo.Query<SharedReportQuery, SharedReportQueryVariables> {
    document = SharedReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SharedReportFullDocument = gql`
    query SharedReportFull($token: ID!) {
  sharedReportFull(token: $token) {
    memberFirstName
    sharedAt
    expiresAt
    profile {
      ...profileReportFields
    }
    goals {
      ...goalsFields
    }
    occupation {
      ...occupationForReportFields
    }
    insights {
      learningSuggestions {
        courses {
          description
          title
          url
        }
        certificates {
          description
          title
          url
        }
      }
    }
    viaInsights
    jst
  }
}
    ${ProfileReportFieldsFragmentDoc}
${GoalsFieldsFragmentDoc}
${OccupationForReportFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SharedReportFullGQL extends Apollo.Query<SharedReportFullQuery, SharedReportFullQueryVariables> {
    document = SharedReportFullDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AskSharedReportViaDocument = gql`
    mutation AskSharedReportVia($token: ID!, $question: String!, $history: [SharedReportViaTurnInput!]) {
  askSharedReportVia(token: $token, question: $question, history: $history) {
    answer
    outcome
    remaining
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AskSharedReportViaGQL extends Apollo.Mutation<AskSharedReportViaMutation, AskSharedReportViaMutationVariables> {
    document = AskSharedReportViaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MySharedReportViaUsageDocument = gql`
    query MySharedReportViaUsage {
  mySharedReportViaUsage {
    used
    limit
    remaining
    enabled
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MySharedReportViaUsageGQL extends Apollo.Query<MySharedReportViaUsageQuery, MySharedReportViaUsageQueryVariables> {
    document = MySharedReportViaUsageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetSharedReportViaEnabledDocument = gql`
    mutation SetSharedReportViaEnabled($enabled: Boolean!) {
  setSharedReportViaEnabled(enabled: $enabled)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetSharedReportViaEnabledGQL extends Apollo.Mutation<SetSharedReportViaEnabledMutation, SetSharedReportViaEnabledMutationVariables> {
    document = SetSharedReportViaEnabledDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSessionDocument = gql`
    query GetSession($token: String) {
  getSession(token: $token) {
    token
    refreshToken
    isAuthenticated
    profile {
      ...profileFields
    }
  }
}
    ${ProfileFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSessionGQL extends Apollo.Query<GetSessionQuery, GetSessionQueryVariables> {
    document = GetSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RefreshSessionDocument = gql`
    query RefreshSession($refreshToken: String!) {
  refreshSession(refreshToken: $refreshToken) {
    token
    refreshToken
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RefreshSessionGQL extends Apollo.Query<RefreshSessionQuery, RefreshSessionQueryVariables> {
    document = RefreshSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FeedbackDocument = gql`
    mutation feedback($feedback: FeedbackInput) {
  feedback(feedback: $feedback) {
    code
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FeedbackGQL extends Apollo.Mutation<FeedbackMutation, FeedbackMutationVariables> {
    document = FeedbackDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportBugDocument = gql`
    mutation reportBug($input: BugReportInput) {
  reportBug(input: $input) {
    ...bugReportFields
  }
}
    ${BugReportFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportBugGQL extends Apollo.Mutation<ReportBugMutation, ReportBugMutationVariables> {
    document = ReportBugDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSystemStatusReportDocument = gql`
    mutation createSystemStatusReport($input: SystemStatusReportInput) {
  createSystemStatusReport(input: $input) {
    ...systemStatusReport
  }
}
    ${SystemStatusReportFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSystemStatusReportGQL extends Apollo.Mutation<CreateSystemStatusReportMutation, CreateSystemStatusReportMutationVariables> {
    document = CreateSystemStatusReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TogglePublishAllSystemStatusReportDocument = gql`
    mutation togglePublishAllSystemStatusReport($input: TogglePublishAllSystemStatusReportInput) {
  togglePublishAllSystemStatusReport(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TogglePublishAllSystemStatusReportGQL extends Apollo.Mutation<TogglePublishAllSystemStatusReportMutation, TogglePublishAllSystemStatusReportMutationVariables> {
    document = TogglePublishAllSystemStatusReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePublishedSystemStatusReportsDocument = gql`
    mutation deletePublishedSystemStatusReports($ids: [ID!]) {
  deletePublishedSystemStatusReports(ids: $ids)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePublishedSystemStatusReportsGQL extends Apollo.Mutation<DeletePublishedSystemStatusReportsMutation, DeletePublishedSystemStatusReportsMutationVariables> {
    document = DeletePublishedSystemStatusReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkBugReportsViewedDocument = gql`
    mutation markBugReportsViewed($input: BugReportViewedInput) {
  markBugReportsViewed(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkBugReportsViewedGQL extends Apollo.Mutation<MarkBugReportsViewedMutation, MarkBugReportsViewedMutationVariables> {
    document = MarkBugReportsViewedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBugReportsDocument = gql`
    query getBugReports {
  getBugReports {
    ...bugReportFields
  }
}
    ${BugReportFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBugReportsGQL extends Apollo.Query<GetBugReportsQuery, GetBugReportsQueryVariables> {
    document = GetBugReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSystemStatusReportsDocument = gql`
    query getSystemStatusReports {
  getSystemStatusReports {
    ...systemStatusReport
  }
}
    ${SystemStatusReportFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSystemStatusReportsGQL extends Apollo.Query<GetSystemStatusReportsQuery, GetSystemStatusReportsQueryVariables> {
    document = GetSystemStatusReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFeedbacksDocument = gql`
    query getFeedbacks {
  getFeedbacks {
    ...feedbackForAdminFields
  }
}
    ${FeedbackForAdminFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFeedbacksGQL extends Apollo.Query<GetFeedbacksQuery, GetFeedbacksQueryVariables> {
    document = GetFeedbacksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFeedbackAnalyticsDocument = gql`
    query getFeedbackAnalytics {
  getFeedbackAnalytics {
    totalFeedback
    avarageRating
    percentDifferenceTotal
    percentDfferenceAvarageRating
    totalIncreased
    avarageRatingIncreased
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFeedbackAnalyticsGQL extends Apollo.Query<GetFeedbackAnalyticsQuery, GetFeedbackAnalyticsQueryVariables> {
    document = GetFeedbackAnalyticsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveVideoUsageDocument = gql`
    mutation saveVideoUsage($videoUsageInput: VideoUsageInput) {
  saveVideoUsage(videoUsageInput: $videoUsageInput) {
    url
    duration
    spend
    endtype
    createdat
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveVideoUsageGQL extends Apollo.Mutation<SaveVideoUsageMutation, SaveVideoUsageMutationVariables> {
    document = SaveVideoUsageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportDownloadedDocument = gql`
    mutation reportDownloaded {
  reportDownloaded {
    code
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportDownloadedGQL extends Apollo.Mutation<ReportDownloadedMutation, ReportDownloadedMutationVariables> {
    document = ReportDownloadedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportSharedDocument = gql`
    mutation reportShared {
  reportShared {
    code
    success
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportSharedGQL extends Apollo.Mutation<ReportSharedMutation, ReportSharedMutationVariables> {
    document = ReportSharedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StartInterestsTrackingDocument = gql`
    mutation startInterestsTracking {
  startInterestsTracking {
    code
    success
    message
    tracker {
      id
      createdat
      startedat
      finishedat
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StartInterestsTrackingGQL extends Apollo.Mutation<StartInterestsTrackingMutation, StartInterestsTrackingMutationVariables> {
    document = StartInterestsTrackingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SavePathwayPageUsageDocument = gql`
    mutation savePathwayPageUsage($input: PathwayPageUsageInput) {
  savePathwayPageUsage(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SavePathwayPageUsageGQL extends Apollo.Mutation<SavePathwayPageUsageMutation, SavePathwayPageUsageMutationVariables> {
    document = SavePathwayPageUsageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterDocument = gql`
    query Register {
  register(anonymous: true) {
    userId
    token
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterGQL extends Apollo.Query<RegisterQuery, RegisterQueryVariables> {
    document = RegisterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserProfileDocument = gql`
    query GetUserProfile($sessionToken: String) {
  profile(sessionToken: $sessionToken) {
    ...profileFields
  }
}
    ${ProfileFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserProfileGQL extends Apollo.Query<GetUserProfileQuery, GetUserProfileQueryVariables> {
    document = GetUserProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReturnSessionDocument = gql`
    query getReturnSession($returnToken: String!) {
  returnSession(returnToken: $returnToken)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReturnSessionGQL extends Apollo.Query<GetReturnSessionQuery, GetReturnSessionQueryVariables> {
    document = GetReturnSessionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InitUserMatchesDocument = gql`
    query initUserMatches {
  initUserMatches {
    success
    message
    code
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InitUserMatchesGQL extends Apollo.Query<InitUserMatchesQuery, InitUserMatchesQueryVariables> {
    document = InitUserMatchesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UsersDocument = gql`
    query Users {
  users {
    ...memberFields
  }
}
    ${MemberFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UsersGQL extends Apollo.Query<UsersQuery, UsersQueryVariables> {
    document = UsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmailToVerifyDocument = gql`
    query getEmailToVerify($token: String) {
  getEmailToVerify(token: $token)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmailToVerifyGQL extends Apollo.Query<GetEmailToVerifyQuery, GetEmailToVerifyQueryVariables> {
    document = GetEmailToVerifyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterLoginUserDocument = gql`
    mutation registerLoginUser($username: String!, $password: String!, $email: String) {
  registerLoginUser(username: $username, password: $password, email: $email) {
    userId
    userRole
    userName
    token
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterLoginUserGQL extends Apollo.Mutation<RegisterLoginUserMutation, RegisterLoginUserMutationVariables> {
    document = RegisterLoginUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginDocument = gql`
    mutation login($username: String!, $password: String!) {
  login(username: $username, password: $password) {
    userId
    userRole
    userName
    userEmail
    token
    profile {
      firstName
      lastName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginGQL extends Apollo.Mutation<LoginMutation, LoginMutationVariables> {
    document = LoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUserDocument = gql`
    mutation deleteUser($userId: Int!) {
  deleteUser(userId: $userId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUserGQL extends Apollo.Mutation<DeleteUserMutation, DeleteUserMutationVariables> {
    document = DeleteUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginByEmailDocument = gql`
    mutation loginByEmail($email: String!, $password: String!) {
  loginByEmail(email: $email, password: $password) {
    userId
    userRole
    userName
    userEmail
    token
    profile {
      firstName
      lastName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginByEmailGQL extends Apollo.Mutation<LoginByEmailMutation, LoginByEmailMutationVariables> {
    document = LoginByEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveUserDetailsDocument = gql`
    mutation saveUserDetails($userId: Int!, $firstName: String!, $lastName: String!, $status: UserActionEnum) {
  saveUserDetails(
    id: $userId
    firstName: $firstName
    lastName: $lastName
    status: $status
  ) {
    profile {
      ...memberFields
    }
  }
}
    ${MemberFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveUserDetailsGQL extends Apollo.Mutation<SaveUserDetailsMutation, SaveUserDetailsMutationVariables> {
    document = SaveUserDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InviteUsersDocument = gql`
    mutation inviteUsers($emails: [String]!, $role: String!) {
  inviteUsers(emails: $emails, role: $role)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InviteUsersGQL extends Apollo.Mutation<InviteUsersMutation, InviteUsersMutationVariables> {
    document = InviteUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VerifyEmailDocument = gql`
    mutation verifyEmail($email: String!) {
  verifyEmail(email: $email)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VerifyEmailGQL extends Apollo.Mutation<VerifyEmailMutation, VerifyEmailMutationVariables> {
    document = VerifyEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveUserCredsDocument = gql`
    mutation saveUserCreds($email: String!, $password: String!, $token: String) {
  saveUserCreds(email: $email, password: $password, token: $token) {
    userId
    token
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveUserCredsGQL extends Apollo.Mutation<SaveUserCredsMutation, SaveUserCredsMutationVariables> {
    document = SaveUserCredsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetPasswordDocument = gql`
    mutation resetPassword($email: String!) {
  resetPassword(email: $email)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetPasswordGQL extends Apollo.Mutation<ResetPasswordMutation, ResetPasswordMutationVariables> {
    document = ResetPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginAfterResetDocument = gql`
    mutation loginAfterReset($token: String!, $password: String!) {
  loginAfterReset(token: $token, password: $password) {
    userId
    token
    profile {
      ...memberFields
    }
  }
}
    ${MemberFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginAfterResetGQL extends Apollo.Mutation<LoginAfterResetMutation, LoginAfterResetMutationVariables> {
    document = LoginAfterResetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitSharedReportFeedbackDocument = gql`
    mutation SubmitSharedReportFeedback($token: ID!, $rating: Int!, $comment: String) {
  submitSharedReportFeedback(token: $token, rating: $rating, comment: $comment)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitSharedReportFeedbackGQL extends Apollo.Mutation<SubmitSharedReportFeedbackMutation, SubmitSharedReportFeedbackMutationVariables> {
    document = SubmitSharedReportFeedbackDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSharedReportFeedbacksDocument = gql`
    query getSharedReportFeedbacks {
  getSharedReportFeedbacks {
    createdtimestamp
    rating
    comment
    moctitle
    careergoal
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSharedReportFeedbacksGQL extends Apollo.Query<GetSharedReportFeedbacksQuery, GetSharedReportFeedbacksQueryVariables> {
    document = GetSharedReportFeedbacksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }